/* ============================================================
   games.js — Interaktive Übungen / Mini-Spiele für die Klausur
   Themen: Page Replacement, MMU, Semaphore, RAID, Buddy,
           Belegungsstrategien, Banker, Scheduling, Disk-Scheduling,
           i-node-Adressierung
   ============================================================ */

window.Games = (() => {

  // -------- Game-Registry ----------
  const GAMES = [
    // === Betriebssysteme ===
    { id: 'pagereplace', deck: 'bs',  icon: '📄', title: 'Page Replacement', subtitle: 'FIFO · LRU · Optimal · Clock', tag: 'BS03 · ⭐ Klausur', render: renderPageReplace },
    { id: 'mmu',         deck: 'bs',  icon: '🧭', title: 'MMU-Adresskonverter', subtitle: 'Virtuelle → physikalische Adresse', tag: 'BS03 · ⭐⭐ Klausur', render: renderMMU },
    { id: 'semaphore',   deck: 'bs',  icon: '🚦', title: 'The Syncing Game',     subtitle: 'Kritische Abschnitte synchronisieren',  tag: 'BS02 · ⭐ Klausur', render: renderSemaphore },
    { id: 'raid',        deck: 'bs',  icon: '💽', title: 'RAID-Rechner',        subtitle: 'Ausfall-P · Kapazität',         tag: 'BS05 · ⭐ Klausur', render: renderRAID },
    { id: 'buddy',       deck: 'bs',  icon: '🌳', title: 'Buddy-System',        subtitle: 'Allozieren · Splitten · Mergen', tag: 'BS03', render: renderBuddy },
    { id: 'fitstrat',    deck: 'bs',  icon: '🧩', title: 'Belegungsstrategien', subtitle: 'FirstFit · BestFit · WorstFit', tag: 'BS03', render: renderFitStrat },
    { id: 'banker',      deck: 'bs',  icon: '🏦', title: 'Deadlock-Detektor',   subtitle: 'Banker-Algorithmus',            tag: 'BS02', render: renderBanker },
    { id: 'scheduling',  deck: 'bs',  icon: '📊', title: 'Scheduling-Gantt',    subtitle: 'FCFS · SJF · SRTF · RR',         tag: 'BS02', render: renderScheduling },
    { id: 'disksched',   deck: 'bs',  icon: '🛞', title: 'Disk-Scheduling',     subtitle: 'FCFS · SSTF · SCAN · LOOK',     tag: 'BS05', render: renderDiskSched },
    { id: 'inode',       deck: 'bs',  icon: '🗂️', title: 'i-node-Adressierung', subtitle: 'Direct · Indirect Pointer',     tag: 'BS04', render: renderInode },

    // === Informationssicherheit ===
    { id: 'phishing',    deck: 'sec', icon: '🕵️', title: 'Phishing Detective', subtitle: 'Fake oder echt? Lives & Combo!', tag: 'InfoSec VL2 · ⭐ Klausur', render: renderPhishing },
    { id: 'caesar',      deck: 'sec', icon: '🔓', title: 'Caesar-Cracker',     subtitle: 'Knacke die Verschiebung', tag: 'InfoSec VL7', render: renderCaesar },
    { id: 'porthunter',  deck: 'sec', icon: '🎯', title: 'Port-Hunter',        subtitle: '30s Speed-Quiz mit Combo', tag: 'InfoSec VL3', render: renderPortHunter },
    { id: 'malwarematch',deck: 'sec', icon: '🦠', title: 'Malware-Memory',     subtitle: 'Finde die Pärchen', tag: 'InfoSec VL1', render: renderMalwareMatch },
    { id: 'rsa',         deck: 'sec', icon: '🔢', title: 'RSA-Dojo',           subtitle: 'Schritt-für-Schritt zum Schlüsselpaar', tag: 'InfoSec EL5 · ⭐⭐ Klausur', render: renderRSA },
    { id: 'dh',          deck: 'sec', icon: '🔄', title: 'Diffie-Hellman-Lab', subtitle: 'Schlüsselaustausch live', tag: 'InfoSec EL3 · ⭐ Klausur', render: renderDH },
    { id: 'sqm',         deck: 'sec', icon: '🧮', title: 'Square & Multiply',  subtitle: 'Modulare Exponentiation animiert', tag: 'InfoSec EL4', render: renderSqM },
    { id: 'ecbcbc',      deck: 'sec', icon: '🖼️', title: 'ECB vs. CBC',        subtitle: 'Sieh, warum ECB undicht ist', tag: 'InfoSec VL8', render: renderEcbCbc },

    // === Datenbanken ===
    { id: 'dbsql',       deck: 'db',  icon: '🧾', title: 'SQL-Werkstatt',         subtitle: 'SELECT · JOIN · GROUP BY · INSERT · UPDATE · DELETE',  tag: 'DB Teil 5 · ⭐⭐ Klausur', render: renderDbSql },
    { id: 'dbnf',        deck: 'db',  icon: '🧮', title: 'Normalform-Detektor',   subtitle: '1NF · 2NF · 3NF · BCNF aus Schema + FDs ableiten',     tag: 'DB Teil 4 · ⭐⭐ Klausur', render: renderDbNF },
    { id: 'dbclosure',   deck: 'db',  icon: '🧲', title: 'Attributhülle α⁺',      subtitle: 'Iterativ Attribute aus FDs ableiten',                  tag: 'DB Teil 4 · ⭐ Klausur',   render: renderDbClosure },
    { id: 'dberd',       deck: 'db',  icon: '🔗', title: 'ER → Relationenmodell', subtitle: '1:1 · 1:N · M:N · schwache Entität korrekt überführen', tag: 'DB Teil 2/3 · ⭐ Klausur', render: renderDbErd },
    { id: 'dbserial',    deck: 'db',  icon: '🔀', title: 'Konfliktgraph',         subtitle: 'Schedule → Konfliktgraph → serialisierbar?',           tag: 'DB Teil 7 · ⭐⭐ Klausur', render: renderDbSerial },
    { id: 'dbjoincost',  deck: 'db',  icon: '⚙️', title: 'Join-Cost-Rechner',     subtitle: 'Nested · Block-NL · Sort-Merge · Hash · I/O-Kosten',   tag: 'DB Teil 6',                render: renderDbJoinCost },
    { id: 'db2pc',       deck: 'db',  icon: '📡', title: '2PC-Simulator',         subtitle: 'PREPARE → READY/FAILED → COMMIT/ABORT',                tag: 'DB Teil 8',                render: renderDb2PC },

    // === Netze und Verteilte Systeme ===
    { id: 'netcrc',      deck: 'net', icon: '🛡️', title: 'CRC-Detective',         subtitle: 'XOR-Division · Restbestimmung · Fehlererkennung',      tag: 'NuvS 3a · ⭐⭐ Klausur', render: renderNetCRC },
    { id: 'netman',      deck: 'net', icon: '📶', title: 'Manchester-Studio',     subtitle: 'NRZ · NRZI · Manchester · Bit-Stuffing visualisieren', tag: 'NuvS 2b · ⭐ Klausur',  render: renderNetManchester },
    { id: 'netwin',      deck: 'net', icon: '🪟', title: 'Sliding-Window-Lab',    subtitle: 'Stop-and-Wait · Go-Back-N · Selective Repeat',         tag: 'NuvS 3a · ⭐ Klausur',  render: renderNetWindow },
    { id: 'netsubnet',   deck: 'net', icon: '🌐', title: 'Subnetz-Sprint',        subtitle: '30s Speed-Quiz: Netz · Broadcast · Hosts',             tag: 'NuvS 4 · ⭐⭐ Klausur', render: renderNetSubnet },
    { id: 'netdvr',      deck: 'net', icon: '🗺️', title: 'DVR-Trainer',           subtitle: 'Distance-Vector Konvergenz Schritt für Schritt',       tag: 'NuvS 6 · ⭐⭐ Klausur', render: renderNetDVR },
    { id: 'netcwnd',     deck: 'net', icon: '📈', title: 'TCP-Cwnd-Surfer',       subtitle: 'Slow Start · AIMD · Loss injizieren · Live-Chart',     tag: 'NuvS 7 · ⭐⭐ Klausur', render: renderNetCwnd },
    { id: 'netdns',      deck: 'net', icon: '🧭', title: 'DNS-Quest',             subtitle: 'Rekursive Auflösung Hop für Hop',                      tag: 'NuvS 5 · ⭐ Klausur',   render: renderNetDNS },
  ];

  const DECK_FILTERS = [
    { id: 'all', label: 'Alle',                   icon: '✨' },
    { id: 'bs',  label: 'Betriebssysteme',        icon: '🖥️' },
    { id: 'sec', label: 'Informationssicherheit', icon: '🔐' },
    { id: 'db',  label: 'Datenbanken',            icon: '🗄️' },
    { id: 'net', label: 'Netze & Verteilte Sys.', icon: '🌐' },
  ];
  let activeFilter = 'all';

  // -------- Public API ----------
  function renderIndex() {
    const grid  = document.getElementById('gamesGrid');
    const stage = document.getElementById('gameStage');
    const back  = document.getElementById('gamesBackBtn');
    if (!grid || !stage) return;
    stage.hidden = true;
    grid.hidden  = false;
    back.style.display = 'none';

    const filterBar = `
      <div class="games-filter" role="tablist" aria-label="Fach filtern">
        ${DECK_FILTERS.map(f => {
          const cnt = f.id === 'all' ? GAMES.length : GAMES.filter(g => g.deck === f.id).length;
          return `<button class="games-filter-chip ${activeFilter === f.id ? 'active' : ''}" data-f="${f.id}" role="tab" aria-selected="${activeFilter === f.id}">
            <span>${f.icon}</span>${f.label}<span class="games-filter-count">${cnt}</span>
          </button>`;
        }).join('')}
      </div>
    `;
    const visible = activeFilter === 'all' ? GAMES : GAMES.filter(g => g.deck === activeFilter);
    const cards = visible.map(g => `
      <button class="game-card" data-id="${g.id}">
        <div class="game-card-ico">${g.icon}</div>
        <div class="game-card-body">
          <div class="game-card-title">${g.title}</div>
          <div class="game-card-sub">${g.subtitle}</div>
          <div class="game-card-tag">${g.tag}</div>
        </div>
      </button>
    `).join('');
    grid.innerHTML = filterBar + `<div class="games-cards">${cards}</div>`;

    grid.querySelectorAll('.game-card').forEach(b => {
      b.addEventListener('click', () => openGame(b.dataset.id));
    });
    grid.querySelectorAll('.games-filter-chip').forEach(b => {
      b.addEventListener('click', () => { activeFilter = b.dataset.f; renderIndex(); });
    });
    if (!back._wired) {
      back._wired = true;
      back.addEventListener('click', renderIndex);
    }
  }

  function openGame(id) {
    const g = GAMES.find(x => x.id === id);
    if (!g) return;
    const grid  = document.getElementById('gamesGrid');
    const stage = document.getElementById('gameStage');
    const back  = document.getElementById('gamesBackBtn');
    grid.hidden  = true;
    stage.hidden = false;
    back.style.display = '';
    stage.innerHTML = `
      <div class="game-header">
        <div class="game-header-ico">${g.icon}</div>
        <div>
          <h2 class="game-header-title">${g.title}</h2>
          <div class="game-header-sub">${g.subtitle} · <span class="muted">${g.tag}</span></div>
        </div>
      </div>
      <div id="gameBody" class="game-body"></div>
    `;
    g.render(document.getElementById('gameBody'));
  }

  function getGames() {
    return GAMES.map(({ id, deck, icon, title, subtitle, tag }) => ({ id, deck, icon, title, subtitle, tag }));
  }

  function renderGameInto(id, root) {
    const g = GAMES.find(x => x.id === id);
    if (!g || !root) return false;
    root.innerHTML = '';
    g.render(root);
    return true;
  }

  // ====== Helpers ======
  function el(html) { const t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }
  function rngInt(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
  function shuffle(arr) { const a = arr.slice(); for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1));[a[i], a[j]] = [a[j], a[i]]; } return a; }
  function toast(msg) { if (window.toast) window.toast(msg); else console.log(msg); }

  /* ================================================================
     1) PAGE REPLACEMENT SIMULATOR
     ================================================================ */
  function renderPageReplace(root) {
    const state = {
      strategy: 'FIFO',
      frames: 3,
      ref: [1, 2, 3, 1, 4, 1, 3, 2, 3],
      step: 0,
      mem: [],
      meta: [],
      ptr: 0,
      faults: 0,
      log: [],
      history: [],   // [{mem:[], fault:bool}] per committed step
      mistakes: 0
    };

    root.innerHTML = `
      <div class="game-controls">
        <label>Strategie
          <select id="prStrat">
            <option>FIFO</option><option>LRU</option><option>Optimal</option><option>Clock</option>
          </select>
        </label>
        <label>Frames
          <select id="prFrames">
            <option>3</option><option>4</option><option>5</option>
          </select>
        </label>
        <label>Referenzfolge
          <input id="prRef" class="input" value="1,2,3,1,4,1,3,2,3" />
        </label>
        <button class="btn btn-secondary" id="prRandom">🎲 Zufällig</button>
        <button class="btn btn-primary" id="prReset">▶ Neu starten</button>
      </div>

      <div class="game-info" id="prInfo"></div>
      <div class="pr-table-wrap"><table class="pr-table" id="prTable"></table></div>

      <div class="game-actions">
        <button class="btn btn-secondary" id="prHint">💡 Hinweis</button>
        <button class="btn btn-secondary" id="prAuto">⏩ Auto-Schritt</button>
      </div>

      <div class="pr-log-wrap"></div>

      <div class="game-help">
        <details>
          <summary>📖 Wie funktioniert das Spiel?</summary>
          <ul>
            <li>Oben siehst du die Referenzfolge. Die <b>aktuelle</b> Anforderung ist blau.</li>
            <li><b>HIT</b>: Klicke das Frame an, in dem die Seite bereits steht.</li>
            <li><b>MISS / Page Fault</b>: Klicke das Frame, in das die neue Seite eingelagert werden soll.<br>
                Bei leeren Frames ist <i>jeder</i> leere Frame korrekt. Sonst gilt die Strategie-Regel.</li>
            <li>Page-Faults und Fehler werden gezählt.</li>
          </ul>
        </details>
      </div>
    `;

    const $ = sel => root.querySelector(sel);

    function reset() {
      state.strategy = $('#prStrat').value;
      state.frames = parseInt($('#prFrames').value, 10);
      const refRaw = $('#prRef').value.trim();
      state.ref = refRaw.split(/[,\s]+/).map(Number).filter(n => !isNaN(n) && n > 0);
      if (state.ref.length === 0) state.ref = [1, 2, 3, 1, 4];
      state.step = 0;
      state.mem  = new Array(state.frames).fill(null);
      state.meta = new Array(state.frames).fill(0);
      state.ptr = 0;
      state.faults = 0;
      state.mistakes = 0;
      state.log = [];
      state.history = [];
      render();
    }

    // PURE function: returns set of acceptable frames + reason. Does NOT mutate state.
    function correctChoiceFor(strategy, mem, meta, ptr, step, ref) {
      const cur = ref[step];
      const hit = mem.indexOf(cur);
      if (hit !== -1) return { kind: 'hit', frames: [hit], cur };
      // empty frame? any one is fine
      const emptyIdxs = mem.map((v, i) => v === null ? i : -1).filter(i => i !== -1);
      if (emptyIdxs.length > 0) return { kind: 'miss-empty', frames: emptyIdxs, cur };
      let victim = 0;
      switch (strategy) {
        case 'FIFO':
        case 'LRU': {
          let best = meta[0];
          meta.forEach((m, i) => { if (m < best) { best = m; victim = i; } });
          break;
        }
        case 'Optimal': {
          let bestDist = -1;
          for (let i = 0; i < mem.length; i++) {
            const page = mem[i];
            let nextUse = Infinity;
            for (let k = step + 1; k < ref.length; k++) {
              if (ref[k] === page) { nextUse = k; break; }
            }
            if (nextUse > bestDist) { bestDist = nextUse; victim = i; }
          }
          break;
        }
        case 'Clock': {
          // simulate on a copy
          const m = meta.slice();
          let p = ptr;
          for (let i = 0; i < mem.length * 2; i++) {
            if (m[p] === 0) { victim = p; break; }
            m[p] = 0;
            p = (p + 1) % mem.length;
          }
          break;
        }
      }
      return { kind: 'miss', frames: [victim], cur };
    }

    function commitChoice(frameIdx) {
      const cur = state.ref[state.step];
      const correct = correctChoiceFor(state.strategy, state.mem, state.meta, state.ptr, state.step, state.ref);
      const ok = correct.frames.includes(frameIdx);
      const t = state.step + 1;
      let isFault = false;

      if (correct.kind === 'hit') {
        // user is supposed to click the hit frame. Always show it as no-fault.
        state.log.push(`#${t}: Seite ${cur} = HIT (Frame ${correct.frames[0] + 1}) ${ok ? '✅' : '❌'}`);
      } else {
        isFault = true;
        state.faults++;
        // If user picked an acceptable frame, use that; else use the correct one for state tracking
        const targetFrame = ok ? frameIdx : correct.frames[0];
        state.mem[targetFrame] = cur;
        state.log.push(`#${t}: Seite ${cur} = MISS → Frame ${targetFrame + 1} ${ok ? '✅' : `❌ (korrekt: Frame ${correct.frames.map(f => f + 1).join('/')})`}`);
      }
      if (!ok) state.mistakes++;

      // Update bookkeeping
      switch (state.strategy) {
        case 'FIFO':
          if (isFault) state.meta[ok ? frameIdx : correct.frames[0]] = t;
          break;
        case 'LRU': {
          const i = state.mem.indexOf(cur);
          if (i !== -1) state.meta[i] = t;
          break;
        }
        case 'Optimal':
          break;
        case 'Clock': {
          const i = state.mem.indexOf(cur);
          if (i !== -1) state.meta[i] = 1;
          if (isFault) {
            const target = ok ? frameIdx : correct.frames[0];
            state.meta[target] = 1;
            // advance pointer past the just-replaced slot, with second-chance clearing
            let p = state.ptr;
            for (let k = 0; k < state.mem.length; k++) {
              if (p === target) { p = (p + 1) % state.mem.length; break; }
              state.meta[p] = 0;
              p = (p + 1) % state.mem.length;
            }
            state.ptr = p;
          }
          break;
        }
      }

      state.history.push({ mem: state.mem.slice(), fault: isFault, page: cur });
      state.step++;
      render();
    }

    function render() {
      const t = $('#prTable');
      const ref = state.ref;
      let html = '<thead><tr><th>Schritt</th>';
      ref.forEach((r, i) => {
        const cls = i === state.step ? 'pr-cur' : '';
        html += `<th class="${cls}">${r}</th>`;
      });
      html += '</tr></thead><tbody>';
      for (let f = 0; f < state.frames; f++) {
        html += `<tr><th>F${f + 1}</th>`;
        for (let i = 0; i < ref.length; i++) {
          let v = '·';
          if (i < state.history.length) v = state.history[i].mem[f] ?? '·';
          else if (i === state.step) v = state.mem[f] ?? '·';
          const isCur = i === state.step;
          const fault = (i < state.history.length && state.history[i].fault) ? ' pr-fault' : '';
          html += `<td class="${isCur ? 'pr-cur-cell pr-clickable' : ''}${fault}" data-frame="${f}" data-step="${i}">${v}</td>`;
        }
        html += '</tr>';
      }
      // Add a "F" indicator row at bottom: F if fault for that step
      html += `<tr><th>F?</th>`;
      for (let i = 0; i < ref.length; i++) {
        let mark = '';
        if (i < state.history.length) mark = state.history[i].fault ? '⚡' : '✓';
        html += `<td>${mark}</td>`;
      }
      html += '</tr>';
      html += '</tbody>';
      t.innerHTML = html;

      $('#prInfo').innerHTML = `
        <span class="chip">Strategie: <b>${state.strategy}</b></span>
        <span class="chip">Frames: <b>${state.frames}</b></span>
        <span class="chip">Page Faults: <b>${state.faults}</b></span>
        <span class="chip">Fehler: <b>${state.mistakes}</b></span>
        <span class="chip">Schritt: <b>${Math.min(state.step + 1, state.ref.length)} / ${state.ref.length}</b></span>
      `;

      if (state.step < ref.length) {
        t.querySelectorAll(`td[data-step="${state.step}"]`).forEach(td => {
          td.addEventListener('click', () => {
            const f = parseInt(td.dataset.frame, 10);
            commitChoice(f);
          });
        });
      }

      let logHtml = '';
      state.log.slice(-10).forEach(l => logHtml += `<div>${l}</div>`);
      if (state.step >= state.ref.length) {
        const acc = state.ref.length === 0 ? 0 : Math.round((state.ref.length - state.mistakes) / state.ref.length * 100);
        logHtml += `<div class="pr-final">🏁 Fertig — ${state.faults} Page Faults · ${state.mistakes} Eingabefehler · ${acc} % korrekt</div>`;
      }
      root.querySelector('.pr-log-wrap').innerHTML = `<div class="pr-log">${logHtml}</div>`;
    }

    $('#prReset').addEventListener('click', reset);
    $('#prRandom').addEventListener('click', () => {
      const len = rngInt(8, 12);
      const max = rngInt(4, 6);
      const arr = [];
      for (let i = 0; i < len; i++) arr.push(rngInt(1, max));
      $('#prRef').value = arr.join(',');
      reset();
    });
    $('#prHint').addEventListener('click', () => {
      if (state.step >= state.ref.length) { toast('Alle Schritte abgearbeitet.'); return; }
      const c = correctChoiceFor(state.strategy, state.mem, state.meta, state.ptr, state.step, state.ref);
      toast(c.kind === 'hit'
        ? `HIT: Seite ${c.cur} liegt schon in Frame ${c.frames[0] + 1}.`
        : c.kind === 'miss-empty'
          ? `MISS: leeres Frame verfügbar (z.B. Frame ${c.frames[0] + 1}).`
          : `MISS: ${state.strategy} würde Frame ${c.frames[0] + 1} ersetzen.`);
    });
    $('#prAuto').addEventListener('click', () => {
      if (state.step >= state.ref.length) return;
      const c = correctChoiceFor(state.strategy, state.mem, state.meta, state.ptr, state.step, state.ref);
      commitChoice(c.frames[0]);
    });

    reset();
  }

  /* ================================================================
     2) MMU — virtuelle → physikalische Adresse
     ================================================================ */
  function renderMMU(root) {
    // 16-bit virtual address: 4 bit L1 | 4 bit L2 | 8 bit offset
    // Physical address: 32 bit. Each L2 entry maps to a 24-bit frame base (top 24 bits) + 8-bit offset = 32-bit phys.
    // We model:
    //   L1 table: 16 entries, each is either NIL or a pointer (frame base) to an L2 table (just symbolic).
    //   L2 tables: 16 entries each, each is NIL or a 24-bit frame base.
    // For the puzzle we only need: given virt addr, look up L1[i1], if not NIL, look up L2[i2], if not NIL → frame base + offset.

    function newPuzzle() {
      // populate ~6 of 16 L1 entries; for each populated L1 entry, populate ~8 of 16 L2 entries
      const L1 = new Array(16).fill(null);
      const L1Tables = {};   // i1 -> array length 16
      const populatedL1 = shuffle([...Array(16).keys()]).slice(0, 6);
      for (const i of populatedL1) {
        L1[i] = '0x' + (rngInt(0x10, 0xFF) * 0x10000 + rngInt(0, 0xFFFF)).toString(16).toUpperCase().padStart(6, '0');
        const tbl = new Array(16).fill(null);
        const populatedL2 = shuffle([...Array(16).keys()]).slice(0, 8);
        for (const j of populatedL2) {
          tbl[j] = rngInt(0, 0xFFFFFF);  // 24-bit frame base
        }
        L1Tables[i] = tbl;
      }
      // pick a virtual address; chance to be valid or NIL at L1/L2
      const r = Math.random();
      let virt;
      if (r < 0.65) {
        // valid path: pick from populated
        const i1 = populatedL1[rngInt(0, populatedL1.length - 1)];
        const tbl = L1Tables[i1];
        const validJs = tbl.map((v, j) => v !== null ? j : -1).filter(j => j !== -1);
        const i2 = validJs[rngInt(0, validJs.length - 1)];
        const off = rngInt(0, 255);
        virt = (i1 << 12) | (i2 << 8) | off;
      } else if (r < 0.85) {
        // NIL at L2
        const i1 = populatedL1[rngInt(0, populatedL1.length - 1)];
        const tbl = L1Tables[i1];
        const invalidJs = tbl.map((v, j) => v === null ? j : -1).filter(j => j !== -1);
        const i2 = invalidJs[rngInt(0, invalidJs.length - 1)];
        const off = rngInt(0, 255);
        virt = (i1 << 12) | (i2 << 8) | off;
      } else {
        // NIL at L1
        const allI1 = [...Array(16).keys()];
        const invalidI1 = allI1.filter(i => L1[i] === null);
        const i1 = invalidI1[rngInt(0, invalidI1.length - 1)];
        virt = (i1 << 12) | (rngInt(0, 0xFFFF));
      }
      return { L1, L1Tables, virt };
    }

    const state = { puzzle: newPuzzle(), revealed: false };

    function hex(n, w) { return n.toString(16).toUpperCase().padStart(w, '0'); }
    function solve(p) {
      const i1  = (p.virt >> 12) & 0xF;
      const i2  = (p.virt >> 8)  & 0xF;
      const off = p.virt & 0xFF;
      if (p.L1[i1] === null) return { fault: 'L1', i1, i2, off };
      const fb = p.L1Tables[i1][i2];
      if (fb === null) return { fault: 'L2', i1, i2, off };
      // fb ist 24-bit (kann Bit 23 gesetzt haben). JS-Bitshift `<<` arbeitet mit 32-Bit signed,
      // daher würde `(fb << 8)` für fb >= 0x800000 negativ werden. Multiplikation hält uns
      // sauber im Number-Bereich (52 Bit safe integer reichen für 32-Bit Ergebnis).
      const phys = fb * 256 + off;
      return { fault: null, i1, i2, off, phys };
    }

    function render() {
      const p = state.puzzle;
      const v = p.virt;
      const i1 = (v >> 12) & 0xF, i2 = (v >> 8) & 0xF, off = v & 0xFF;
      const sol = solve(p);

      let l1Html = '<table class="mmu-table"><thead><tr><th>i1</th><th>L2-Tabellen-Adresse</th></tr></thead><tbody>';
      for (let i = 0; i < 16; i++) {
        const cls = i === i1 ? 'mmu-hl' : '';
        l1Html += `<tr class="${cls}"><td>${hex(i, 1)}</td><td>${p.L1[i] === null ? '<span class="mmu-nil">NIL</span>' : p.L1[i]}</td></tr>`;
      }
      l1Html += '</tbody></table>';

      let l2Html = '';
      if (p.L1[i1] !== null) {
        const tbl = p.L1Tables[i1];
        l2Html = `<div class="mmu-sub">L2-Tabelle für i1=${hex(i1, 1)}:</div><table class="mmu-table"><thead><tr><th>i2</th><th>Frame-Basis (24 Bit)</th></tr></thead><tbody>`;
        for (let j = 0; j < 16; j++) {
          const cls = j === i2 ? 'mmu-hl' : '';
          l2Html += `<tr class="${cls}"><td>${hex(j, 1)}</td><td>${tbl[j] === null ? '<span class="mmu-nil">NIL</span>' : '0x' + hex(tbl[j], 6)}</td></tr>`;
        }
        l2Html += '</tbody></table>';
      } else {
        l2Html = `<div class="mmu-sub muted">L1[${hex(i1, 1)}] = NIL → keine L2-Tabelle</div>`;
      }

      root.innerHTML = `
        <div class="game-info">
          <span class="chip">Virtuelle Adresse: <b>0x${hex(v, 4)}</b></span>
          <span class="chip">Bit-Aufteilung: <b>4 | 4 | 8</b></span>
          <span class="chip">Adressraum: <b>16 Bit virt → 32 Bit phys</b></span>
        </div>

        <div class="mmu-decompose">
          <div class="mmu-deco-step">
            <div class="mmu-deco-label">i1 (L1-Index)</div>
            <input id="mmuI1" class="input mmu-input" placeholder="0–F" />
          </div>
          <div class="mmu-deco-step">
            <div class="mmu-deco-label">i2 (L2-Index)</div>
            <input id="mmuI2" class="input mmu-input" placeholder="0–F" />
          </div>
          <div class="mmu-deco-step">
            <div class="mmu-deco-label">Offset (8 Bit)</div>
            <input id="mmuOff" class="input mmu-input" placeholder="00–FF" />
          </div>
          <button class="btn btn-secondary" id="mmuCheckSplit">Zerlegung prüfen</button>
        </div>

        <div class="mmu-tables">
          <div>${l1Html}</div>
          <div>${l2Html}</div>
        </div>

        <div class="mmu-result">
          <label>Physikalische Adresse (8-stelliger Hex) bzw. <b>FAULT</b>:
            <input id="mmuPhys" class="input" placeholder="z.B. 00ABCD12 oder FAULT" />
          </label>
          <button class="btn btn-primary" id="mmuCheck">Lösung prüfen</button>
          <button class="btn btn-secondary" id="mmuReveal">👁 Lösung zeigen</button>
          <button class="btn btn-secondary" id="mmuNew">🎲 Neue Aufgabe</button>
        </div>

        <div id="mmuFeedback" class="mmu-feedback"></div>

        <div class="game-help">
          <details>
            <summary>📖 Vorgehen</summary>
            <ol>
              <li><b>Adresse zerlegen</b>: Top 4 Bit = L1-Index, nächste 4 Bit = L2-Index, untere 8 Bit = Offset.</li>
              <li><b>L1[i1]</b> nachschlagen — falls NIL → <code>page fault</code>.</li>
              <li><b>L2[i2]</b> aus dieser Tabelle nachschlagen — falls NIL → <code>page fault</code>.</li>
              <li>Frame-Basis (24 Bit) <b>links anhängen</b>, Offset (8 Bit) anhängen → 32-Bit physikalische Adresse.</li>
            </ol>
          </details>
        </div>
      `;

      const $ = sel => root.querySelector(sel);
      $('#mmuCheckSplit').addEventListener('click', () => {
        const a = parseInt($('#mmuI1').value || '-1', 16);
        const b = parseInt($('#mmuI2').value || '-1', 16);
        const c = parseInt($('#mmuOff').value || '-1', 16);
        const ok = (a === i1) && (b === i2) && (c === off);
        $('#mmuFeedback').innerHTML = ok
          ? `<div class="mmu-ok">✅ Zerlegung korrekt: i1=${hex(i1, 1)}, i2=${hex(i2, 1)}, offset=0x${hex(off, 2)}</div>`
          : `<div class="mmu-bad">❌ Falsch. Erwartet: i1=${hex(i1, 1)}, i2=${hex(i2, 1)}, offset=0x${hex(off, 2)}</div>`;
      });
      $('#mmuCheck').addEventListener('click', () => {
        const ans = $('#mmuPhys').value.trim().toUpperCase().replace(/^0X/, '');
        let ok = false;
        if (sol.fault) {
          ok = (ans === 'FAULT' || ans === 'PAGEFAULT' || ans === 'PAGE FAULT');
          $('#mmuFeedback').innerHTML = ok
            ? `<div class="mmu-ok">✅ Korrekt — page fault auf Stufe ${sol.fault} (${sol.fault === 'L1' ? 'L1[' + hex(i1, 1) + ']' : 'L2[' + hex(i2, 1) + ']'} = NIL).</div>`
            : `<div class="mmu-bad">❌ Falsch. Erwartet: <b>FAULT</b> (auf Stufe ${sol.fault}).</div>`;
        } else {
          const expected = hex(sol.phys, 8);
          ok = (ans === expected);
          $('#mmuFeedback').innerHTML = ok
            ? `<div class="mmu-ok">✅ Korrekt: 0x${expected}</div>`
            : `<div class="mmu-bad">❌ Falsch. Erwartet: <b>0x${expected}</b><br>(Frame-Basis 0x${hex(p.L1Tables[i1][i2], 6)} ‖ Offset 0x${hex(off, 2)})</div>`;
        }
      });
      $('#mmuReveal').addEventListener('click', () => {
        $('#mmuI1').value = hex(i1, 1);
        $('#mmuI2').value = hex(i2, 1);
        $('#mmuOff').value = hex(off, 2);
        $('#mmuPhys').value = sol.fault ? 'FAULT' : hex(sol.phys, 8);
        $('#mmuCheck').click();
      });
      $('#mmuNew').addEventListener('click', () => { state.puzzle = newPuzzle(); render(); });
    }
    render();
  }

  /* ================================================================
     3) THE SYNCING GAME — Semaphor-Synchronisation
        Nachgebaut nach worldofsemaphores.de/the-syncing-game.html
     ================================================================ */
  function renderSemaphore(root) {

    /* ── Szenarien ── */
    const SCENARIOS = [
      {
        id: 'easy',
        name: '🟢 Einfach · 2 Prozesse · 2 krit. Abschnitte',
        numSem: 3,
        processes: [
          { name: 'Prozess 1', blocks: ['A', 'B'] },
          { name: 'Prozess 2', blocks: ['B', 'A'] },
        ],
        critical: new Set(['A', 'B']),
        solution: { A: 1, B: 2 },
        minSem: 2,
      },
      {
        id: 'medium',
        name: '🟡 Mittel · 3 Prozesse · 3 krit. Abschnitte',
        numSem: 4,
        processes: [
          { name: 'Prozess 1', blocks: ['A', 'B', 'A'] },
          { name: 'Prozess 2', blocks: ['B', 'C', 'B'] },
          { name: 'Prozess 3', blocks: ['C', 'A', 'C'] },
        ],
        critical: new Set(['A', 'B', 'C']),
        solution: { A: 1, B: 2, C: 3 },
        minSem: 3,
      },
      {
        id: 'hard',
        name: '🔴 Schwer · 4 Prozesse · 4 krit. Abschnitte (worldofsemaphores.de)',
        numSem: 6,
        processes: [
          { name: 'Prozess 1', blocks: ['C', 'D', 'C', 'A'] },
          { name: 'Prozess 2', blocks: ['A', 'C', 'B', 'C'] },
          { name: 'Prozess 3', blocks: ['D', 'A', 'B', 'C'] },
          { name: 'Prozess 4', blocks: ['B', 'C', 'E', 'E'] },
        ],
        critical: new Set(['A', 'B', 'C', 'D']),
        solution: { A: 1, B: 2, C: 3, D: 4 },
        minSem: 4,
      },
    ];

    /* ── Zufalls-Generator für neue Beispiele ────────────────────────
       Erzeugt valide Synchronisations-Aufgaben mit korrespondierenden
       kritischen Abschnitten — keine vorgefertigten Szenarien nötig. */
    function generateScenario(difficulty = 'medium') {
      const cfg = ({
        easy:   { procs: 2, critTypes: 2, blocksMin: 2, blocksMax: 3, freeMax: 1, semExtra: 1 },
        medium: { procs: 3, critTypes: 3, blocksMin: 3, blocksMax: 4, freeMax: 2, semExtra: 1 },
        hard:   { procs: 4, critTypes: 4, blocksMin: 4, blocksMax: 5, freeMax: 2, semExtra: 2 },
      })[difficulty] || null;
      if (!cfg) return null;

      const critPool = ['A', 'B', 'C', 'D', 'E'].slice(0, cfg.critTypes);
      const freePool = ['x', 'y', 'z', 'w', 'v'];
      const rand     = (n) => Math.floor(Math.random() * n);
      const pick     = (arr) => arr[rand(arr.length)];

      const processes = [];
      for (let p = 0; p < cfg.procs; p++) {
        const span    = cfg.blocksMax - cfg.blocksMin + 1;
        const total   = cfg.blocksMin + rand(span);
        const numFree = Math.min(cfg.freeMax, rand(cfg.freeMax + 1));
        const numCrit = Math.max(1, total - numFree);

        const blocks = [];
        for (let i = 0; i < numCrit; i++) blocks.push(pick(critPool));
        for (let i = 0; i < numFree; i++) {
          const pos = rand(blocks.length + 1);
          blocks.splice(pos, 0, pick(freePool));
        }
        // Direkt benachbarte Wiederholungen desselben krit. Typs ersetzen
        for (let i = 1; i < blocks.length; i++) {
          if (blocks[i] === blocks[i - 1] && critPool.includes(blocks[i]) && critPool.length > 1) {
            const alt = critPool.filter((l) => l !== blocks[i - 1]);
            blocks[i] = pick(alt);
          }
        }
        processes.push({ name: `Prozess ${p + 1}`, blocks });
      }

      // Sicherstellen, dass jeder krit. Typ in mind. 2 verschiedenen Prozessen
      // vorkommt — sonst gäbe es keine Race Condition zu schützen.
      const procsWith = (l) => processes.filter((pr) => pr.blocks.includes(l)).length;
      for (const l of critPool) {
        let guard = 6;
        while (procsWith(l) < 2 && guard-- > 0) {
          const candidates = processes.filter((pr) => !pr.blocks.includes(l));
          const target = candidates.length ? pick(candidates) : pick(processes);
          let pos, tries = 8;
          do {
            pos = rand(target.blocks.length + 1);
            tries--;
          } while (
            tries > 0 &&
            (target.blocks[pos - 1] === l || target.blocks[pos] === l)
          );
          target.blocks.splice(pos, 0, l);
        }
      }

      const solution = {};
      critPool.forEach((l, i) => { solution[l] = i + 1; });

      const numSem = Math.min(6, critPool.length + cfg.semExtra);
      const labels = { easy: '🟢 Einfach', medium: '🟡 Mittel', hard: '🔴 Schwer' };

      return {
        id: 'gen-' + Date.now(),
        generated: true,
        difficulty,
        name: `🎲 Generiert · ${labels[difficulty]} · ${processes.length} Prozesse · ${critPool.length} krit. Abschnitte`,
        numSem,
        processes,
        critical: new Set(critPool),
        solution,
        minSem: critPool.length,
      };
    }

    /* ── State ── */
    let scIdx = 0;
    let userSlots = [];
    let dragData  = null;
    let genDifficulty = 'medium';

    function initSlots(sc) {
      userSlots = sc.processes.map(p =>
        Array.from({ length: p.blocks.length + 1 }, () => [])
      );
    }

    /* ── Validation ── */
    function validate(sc) {
      const blockToSem = {};
      const errors = [];

      for (let pIdx = 0; pIdx < sc.processes.length; pIdx++) {
        const proc  = sc.processes[pIdx];
        const slots = userSlots[pIdx];

        for (let bIdx = 0; bIdx < proc.blocks.length; bIdx++) {
          const blockType = proc.blocks[bIdx];
          const preOps    = slots[bIdx];
          const postOps   = slots[bIdx + 1];
          const isCrit    = sc.critical.has(blockType);

          if (isCrit) {
            const lastPre   = preOps[preOps.length - 1];
            const firstPost = postOps[0];
            if (!lastPre || lastPre.type !== 'P') {
              errors.push(`${proc.name}: Abschnitt <b>${blockType}</b> braucht P() unmittelbar davor`);
              continue;
            }
            if (!firstPost || firstPost.type !== 'V' || firstPost.sem !== lastPre.sem) {
              errors.push(`${proc.name}: Abschnitt <b>${blockType}</b> braucht V(s${lastPre.sem}) unmittelbar danach`);
              continue;
            }
            const sx = lastPre.sem;
            const conflict = Object.entries(blockToSem).find(([t, s]) => t !== blockType && s === sx);
            if (conflict) {
              errors.push(`s${sx} wird für verschiedene Abschnitte genutzt (<b>${conflict[0]}</b> und <b>${blockType}</b>)`);
            } else if (blockToSem[blockType] !== undefined && blockToSem[blockType] !== sx) {
              errors.push(`Abschnitt <b>${blockType}</b>: inkonsistentes Semaphor (s${blockToSem[blockType]} vs s${sx})`);
            } else {
              blockToSem[blockType] = sx;
            }
          } else {
            const lastPre   = preOps[preOps.length - 1];
            const firstPost = postOps[0];
            if (lastPre && lastPre.type === 'P' && firstPost && firstPost.type === 'V' && lastPre.sem === firstPost.sem) {
              errors.push(`${proc.name}: Nicht-kritischer Abschnitt <b>${blockType}</b> darf nicht mit Semaphor geschützt werden`);
            }
          }
        }

        const semCount = {};
        for (const slotOps of slots)
          for (const op of slotOps) {
            if (!semCount[op.sem]) semCount[op.sem] = { P: 0, V: 0 };
            semCount[op.sem][op.type]++;
          }
        for (const [s, cnt] of Object.entries(semCount))
          if (cnt.P !== cnt.V)
            errors.push(`${proc.name}: s${s} ist nicht balanciert (${cnt.P}× P, ${cnt.V}× V)`);
      }

      for (const type of sc.critical)
        if (blockToSem[type] === undefined)
          errors.push(`Abschnittstyp <b>${type}</b> ist nirgends geschützt`);

      const semsUsed = new Set(Object.values(blockToSem)).size;
      if (errors.length === 0 && semsUsed > sc.minSem)
        errors.push(`Zu viele verschiedene Semaphore benutzt: ${semsUsed} (Minimum: ${sc.minSem})`);

      return errors;
    }

    /* ── Helpers ── */
    function semColor(sem) {
      const palette = ['#6366f1', '#10b981', '#f59e0b', '#ec4899', '#06b6d4', '#8b5cf6'];
      return palette[(sem - 1) % palette.length];
    }

    function opChipHTML(op, ctx = {}) {
      const color = semColor(op.sem);
      const cls   = `sync-op sync-op-${op.type}`;
      const data  = ctx.source === 'slot'
        ? `data-source="slot" data-pidx="${ctx.pIdx}" data-sidx="${ctx.sIdx}" data-oidx="${ctx.oIdx}" data-type="${op.type}" data-sem="${op.sem}"`
        : `data-source="bank" data-type="${op.type}" data-sem="${op.sem}"`;
      return `<span class="${cls}" draggable="true" ${data} style="--sem-color:${color}">
        <span class="sync-op-letter">${op.type}</span><span class="sync-op-paren">(s</span><sub>${op.sem}</sub><span class="sync-op-paren">)</span>
      </span>`;
    }

    function slotInnerHTML(pIdx, sIdx) {
      const ops = userSlots[pIdx][sIdx];
      if (ops.length === 0) return '<span class="sync-slot-hint">＋</span>';
      return ops.map((op, oIdx) => opChipHTML(op, { source: 'slot', pIdx, sIdx, oIdx })).join('');
    }

    function refreshSlots() {
      root.querySelectorAll('.sync-slot').forEach(el => {
        const pi = +el.dataset.pidx, si = +el.dataset.sidx;
        const ops = userSlots[pi][si];
        el.innerHTML = slotInnerHTML(pi, si);
        el.classList.toggle('sync-slot-empty', ops.length === 0);
        el.classList.toggle('sync-slot-full',  ops.length >= 2);
      });
    }

    /* ── Drag & Drop ────────────────────────────────────────────────
       WICHTIG: Container-Listener (Slots, Trash, Bank-Chips) werden
       nur EINMAL pro render() registriert. Sonst akkumulieren sich
       Listener nach jedem Drop und Operationen werden mehrfach
       eingefügt. */
    function attachContainerHandlers() {
      root.querySelectorAll('.sync-bank .sync-op').forEach(chip => {
        chip.addEventListener('dragstart', e => {
          dragData = { type: chip.dataset.type, sem: +chip.dataset.sem, source: 'bank' };
          chip.classList.add('sync-op-dragging');
          e.dataTransfer.effectAllowed = 'copy';
          try { e.dataTransfer.setData('text/plain', `${dragData.type}${dragData.sem}`); } catch(_) {}
        });
        chip.addEventListener('dragend', () => {
          chip.classList.remove('sync-op-dragging');
          dragData = null;
          root.querySelectorAll('.sync-slot-hover, .sync-trash-hover')
              .forEach(s => s.classList.remove('sync-slot-hover', 'sync-trash-hover'));
        });
      });

      root.querySelectorAll('.sync-slot').forEach(slot => {
        slot.addEventListener('dragover', e => {
          if (!dragData) return;
          const pi = +slot.dataset.pidx, si = +slot.dataset.sidx;
          const sameSlot = dragData.source === 'slot' && dragData.pIdx === pi && dragData.sIdx === si;
          if (userSlots[pi][si].length >= 2 && !sameSlot) return;
          e.preventDefault();
          e.dataTransfer.dropEffect = dragData.source === 'bank' ? 'copy' : 'move';
          slot.classList.add('sync-slot-hover');
        });
        slot.addEventListener('dragleave', () => slot.classList.remove('sync-slot-hover'));
        slot.addEventListener('drop', e => {
          e.preventDefault();
          slot.classList.remove('sync-slot-hover');
          if (!dragData) return;
          const pi = +slot.dataset.pidx, si = +slot.dataset.sidx;
          const sameSlot = dragData.source === 'slot' && dragData.pIdx === pi && dragData.sIdx === si;
          if (userSlots[pi][si].length >= 2 && !sameSlot) return;
          const op = { type: dragData.type, sem: dragData.sem };
          if (dragData.source === 'slot') {
            userSlots[dragData.pIdx][dragData.sIdx].splice(dragData.oIdx, 1);
          }
          userSlots[pi][si].push(op);
          dragData = null; // Drop konsumiert — verhindert versehentliche Mehrfachverarbeitung
          refreshSlots(); attachChipHandlers();
          requestAnimationFrame(() => {
            const ops = slot.querySelectorAll('.sync-op');
            const last = ops[ops.length - 1];
            if (last) {
              last.classList.add('sync-op-pop');
              setTimeout(() => last.classList.remove('sync-op-pop'), 400);
            }
          });
        });
      });

      const trash = root.querySelector('#syncTrash');
      if (trash) {
        trash.addEventListener('dragover', e => {
          if (dragData && dragData.source === 'slot') {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            trash.classList.add('sync-trash-hover');
          }
        });
        trash.addEventListener('dragleave', () => trash.classList.remove('sync-trash-hover'));
        trash.addEventListener('drop', e => {
          e.preventDefault();
          trash.classList.remove('sync-trash-hover');
          if (dragData && dragData.source === 'slot') {
            userSlots[dragData.pIdx][dragData.sIdx].splice(dragData.oIdx, 1);
            dragData = null;
            refreshSlots(); attachChipHandlers();
          }
        });
      }
    }

    /* Slot-Chip-Handler werden nach jedem refreshSlots() neu gesetzt,
       weil refreshSlots() den innerHTML der Slots ersetzt. */
    function attachChipHandlers() {
      root.querySelectorAll('.sync-slot .sync-op').forEach(chip => {
        chip.addEventListener('dragstart', e => {
          e.stopPropagation();
          dragData = {
            type:  chip.dataset.type,
            sem:   +chip.dataset.sem,
            source:'slot',
            pIdx:  +chip.dataset.pidx,
            sIdx:  +chip.dataset.sidx,
            oIdx:  +chip.dataset.oidx,
          };
          chip.classList.add('sync-op-dragging');
          e.dataTransfer.effectAllowed = 'move';
          try { e.dataTransfer.setData('text/plain', 'move'); } catch(_) {}
        });
        chip.addEventListener('dragend', () => {
          chip.classList.remove('sync-op-dragging');
          dragData = null;
          root.querySelectorAll('.sync-slot-hover, .sync-trash-hover')
              .forEach(s => s.classList.remove('sync-slot-hover', 'sync-trash-hover'));
        });
        chip.addEventListener('dblclick', e => {
          e.stopPropagation();
          const pi = +chip.dataset.pidx, si = +chip.dataset.sidx, oi = +chip.dataset.oidx;
          userSlots[pi][si].splice(oi, 1);
          refreshSlots(); attachChipHandlers();
        });
      });
      // Tap-Handler (Mobile) hängen ebenfalls an Chips → mit auffrischen
      attachTapHandlers();
    }

    /* ── Tap-to-place fallback (Mobile) ── */
    let tapSelected = null;
    function attachTapHandlers() {
      root.querySelectorAll('.sync-bank .sync-op').forEach(chip => {
        chip.onclick = () => {
          const type = chip.dataset.type, sem = +chip.dataset.sem;
          if (tapSelected && tapSelected.type === type && tapSelected.sem === sem) {
            tapSelected = null;
          } else {
            tapSelected = { type, sem };
          }
          root.querySelectorAll('.sync-bank .sync-op').forEach(c =>
            c.classList.toggle('sync-op-tapselected',
              tapSelected && c.dataset.type === tapSelected.type && +c.dataset.sem === tapSelected.sem));
        };
      });
      root.querySelectorAll('.sync-slot').forEach(slot => {
        slot.onclick = e => {
          if (e.target.closest('.sync-op')) return;
          if (!tapSelected) return;
          const pi = +slot.dataset.pidx, si = +slot.dataset.sidx;
          if (userSlots[pi][si].length >= 2) return;
          userSlots[pi][si].push({ ...tapSelected });
          refreshSlots(); attachChipHandlers();
          requestAnimationFrame(() => {
            const ops = slot.querySelectorAll('.sync-op');
            const last = ops[ops.length - 1];
            if (last) { last.classList.add('sync-op-pop'); setTimeout(() => last.classList.remove('sync-op-pop'), 400); }
          });
        };
      });
      root.querySelectorAll('.sync-slot .sync-op').forEach(chip => {
        chip.onclick = e => {
          e.stopPropagation();
          const pi = +chip.dataset.pidx, si = +chip.dataset.sidx, oi = +chip.dataset.oidx;
          chip.classList.add('sync-op-removing');
          setTimeout(() => {
            userSlots[pi][si].splice(oi, 1);
            refreshSlots(); attachChipHandlers();
          }, 180);
        };
      });
    }

    /* ── Haupt-Render ── */
    function render() {
      const sc = SCENARIOS[scIdx];
      initSlots(sc);
      tapSelected = null;
      const semList = Array.from({ length: sc.numSem }, (_, i) => i + 1);

      root.innerHTML = `
        <div class="sync-toolbar">
          <label class="sync-toolbar-label">
            <span>Szenario</span>
            <select id="syncScenSel" class="sync-toolbar-sel">
              ${SCENARIOS.map((s, i) => `<option value="${i}"${i === scIdx ? ' selected' : ''}>${s.name}</option>`).join('')}
            </select>
          </label>
          <div class="sync-toolbar-gen">
            <label class="sync-toolbar-label">
              <span>Generator</span>
              <select id="syncGenDiff" class="sync-toolbar-sel">
                <option value="easy"${genDifficulty === 'easy' ? ' selected' : ''}>🟢 Einfach</option>
                <option value="medium"${genDifficulty === 'medium' ? ' selected' : ''}>🟡 Mittel</option>
                <option value="hard"${genDifficulty === 'hard' ? ' selected' : ''}>🔴 Schwer</option>
              </select>
            </label>
            <button class="btn btn-primary sync-toolbar-btn" id="syncGenBtn" title="Erzeugt zufällig ein neues Beispiel">🎲 Neues Beispiel</button>
          </div>
          <div class="sync-toolbar-info">
            <span class="sync-pill"><b>${sc.processes.length}</b> Prozesse</span>
            <span class="sync-pill"><b>${sc.critical.size}</b> krit. Abschnitte</span>
            <span class="sync-pill"><b>${sc.numSem}</b> Semaphore (Init = 1)</span>
          </div>
        </div>

        <details class="sync-rules">
          <summary>📖 Regeln &amp; Anleitung</summary>
          <div class="sync-rules-body">
            <p><b>Ziel:</b> Synchronisiere alle Prozesse, sodass keine Race Conditions auftreten.
            Identisch beschriftete Blöcke sind <b>korrespondierend kritisch</b> (nur ein Prozess gleichzeitig).</p>
            <p><b>Bedienung:</b> Ziehe P/V-Operationen aus der Bank in die Lücken zwischen den Blöcken.
            Du kannst Operationen auch zwischen Lücken verschieben oder per Drag in den Papierkorb 🗑️ ziehen
            (oder per Doppelklick löschen). Mobile: Operation antippen, dann auf Lücke tippen.</p>
            <ol>
              <li>Niemals mehr als ein Prozess im selben krit. Abschnitt.</li>
              <li>Minimale Anzahl Semaphore verwenden.</li>
              <li>Nicht-kritische Abschnitte nicht schützen.</li>
              <li>P() direkt vor, V() direkt nach dem krit. Abschnitt.</li>
              <li>P/V müssen pro Prozess balanciert sein.</li>
              <li>Gleicher Abschnittstyp → immer dasselbe Semaphor.</li>
            </ol>
          </div>
        </details>

        <div class="sync-bank-wrap">
          <div class="sync-bank">
            <div class="sync-bank-head">
              <span class="sync-bank-title">🎒 Operationen-Bank</span>
              <span class="sync-bank-hint">Ziehen oder antippen &amp; in Lücke ablegen</span>
            </div>
            <div class="sync-bank-grid">
              ${semList.map(s => `
                <div class="sync-bank-pair" style="--sem-color:${semColor(s)}">
                  <span class="sync-bank-label">s<sub>${s}</sub></span>
                  <span class="sync-op sync-op-P" draggable="true" data-source="bank" data-type="P" data-sem="${s}" style="--sem-color:${semColor(s)}">
                    <span class="sync-op-letter">P</span><span class="sync-op-paren">(s</span><sub>${s}</sub><span class="sync-op-paren">)</span>
                  </span>
                  <span class="sync-op sync-op-V" draggable="true" data-source="bank" data-type="V" data-sem="${s}" style="--sem-color:${semColor(s)}">
                    <span class="sync-op-letter">V</span><span class="sync-op-paren">(s</span><sub>${s}</sub><span class="sync-op-paren">)</span>
                  </span>
                </div>
              `).join('')}
            </div>
          </div>
          <div id="syncTrash" class="sync-trash" title="Hierhin ziehen zum Löschen">
            <span class="sync-trash-icon">🗑️</span>
            <span class="sync-trash-label">Löschen</span>
          </div>
        </div>

        <div class="sync-board" id="syncProcs">
          ${sc.processes.map((proc, pIdx) => `
            <div class="sync-proc" style="--proc-color:${semColor(pIdx + 1)}">
              <div class="sync-proc-head">
                <span class="sync-proc-dot"></span>
                <span>${proc.name}</span>
              </div>
              <div class="sync-proc-body">
                <div class="sync-slot sync-slot-empty" data-pidx="${pIdx}" data-sidx="0">
                  <span class="sync-slot-hint">＋</span>
                </div>
                ${proc.blocks.map((blockType, bIdx) => {
                  const isCrit = sc.critical.has(blockType);
                  return (
                    `<div class="sync-block ${isCrit ? 'sync-block-crit' : 'sync-block-free'}">
                       <span class="sync-block-letter">${blockType}</span>
                       ${isCrit ? '<span class="sync-block-tag">krit.</span>' : '<span class="sync-block-tag sync-block-tag-free">frei</span>'}
                     </div>` +
                    `<div class="sync-slot sync-slot-empty" data-pidx="${pIdx}" data-sidx="${bIdx + 1}">
                       <span class="sync-slot-hint">＋</span>
                     </div>`
                  );
                }).join('')}
              </div>
            </div>
          `).join('')}
        </div>

        <div class="sync-actions">
          <button class="btn btn-primary" id="syncCheck">✔ Lösung prüfen</button>
          <button class="btn btn-secondary" id="syncReveal">👁 Beispiellösung</button>
          <button class="btn btn-secondary" id="syncClear">↺ Zurücksetzen</button>
        </div>
        <div id="syncFeedback" class="sync-feedback" aria-live="polite"></div>
      `;

      root.querySelector('#syncScenSel').addEventListener('change', e => {
        scIdx = +e.target.value; render();
      });

      const genDiffSel = root.querySelector('#syncGenDiff');
      if (genDiffSel) {
        genDiffSel.addEventListener('change', e => { genDifficulty = e.target.value; });
      }
      const genBtn = root.querySelector('#syncGenBtn');
      if (genBtn) {
        genBtn.addEventListener('click', () => {
          const newSc = generateScenario(genDifficulty);
          if (!newSc) return;
          // Erstes generiertes ersetzen, sonst anhängen — so wächst die Liste nicht endlos
          const existingIdx = SCENARIOS.findIndex(s => s.generated);
          if (existingIdx >= 0) {
            SCENARIOS[existingIdx] = newSc;
            scIdx = existingIdx;
          } else {
            SCENARIOS.push(newSc);
            scIdx = SCENARIOS.length - 1;
          }
          render();
        });
      }

      root.querySelector('#syncCheck').addEventListener('click', () => {
        const errors = validate(sc);
        const fb = root.querySelector('#syncFeedback');
        if (errors.length === 0) {
          fb.innerHTML = `
            <div class="sync-result sync-result-ok">
              <div class="sync-result-icon">🎉</div>
              <div>
                <div class="sync-result-title">Perfekt synchronisiert!</div>
                <div class="sync-result-sub">Alle kritischen Abschnitte sind korrekt geschützt — keine Race Conditions möglich.</div>
              </div>
            </div>`;
          root.querySelectorAll('.sync-slot:not(.sync-slot-empty)').forEach((s, i) =>
            setTimeout(() => {
              s.classList.add('sync-slot-success');
              setTimeout(() => s.classList.remove('sync-slot-success'), 800);
            }, i * 40));
        } else {
          fb.innerHTML = `
            <div class="sync-result sync-result-bad">
              <div class="sync-result-icon">🤔</div>
              <div style="flex:1;min-width:0">
                <div class="sync-result-title">Noch nicht ganz korrekt</div>
                <ul class="sync-result-list">${errors.map(e => `<li>${e}</li>`).join('')}</ul>
              </div>
            </div>`;
        }
      });

      root.querySelector('#syncClear').addEventListener('click', () => {
        initSlots(sc); refreshSlots(); attachChipHandlers();
        root.querySelector('#syncFeedback').innerHTML = '';
      });

      root.querySelector('#syncReveal').addEventListener('click', () => {
        initSlots(sc);
        for (let pIdx = 0; pIdx < sc.processes.length; pIdx++) {
          const proc = sc.processes[pIdx];
          for (let bIdx = 0; bIdx < proc.blocks.length; bIdx++) {
            const blockType = proc.blocks[bIdx];
            if (!sc.critical.has(blockType)) continue;
            const sx = sc.solution[blockType];
            userSlots[pIdx][bIdx].push({ type: 'P', sem: sx });
            userSlots[pIdx][bIdx + 1].unshift({ type: 'V', sem: sx });
          }
        }
        refreshSlots(); attachChipHandlers();
        root.querySelector('#syncFeedback').innerHTML =
          `<div class="sync-result sync-result-info">
             <div class="sync-result-icon">💡</div>
             <div>
               <div class="sync-result-title">Beispiellösung eingetragen</div>
               <div class="sync-result-sub">Eine von mehreren äquivalenten Lösungen — Semaphor-Nummern sind frei wählbar.</div>
             </div>
           </div>`;
      });

      attachContainerHandlers();
      attachChipHandlers();
    }

    render();
  }

  function renderRAID(root) {
    const state = {
      level: '0',
      n: 4,
      capPerDisk: 4,        // TB
      pPerDisk: 0.05
    };

    function compute() {
      const { level, n, capPerDisk, pPerDisk } = state;
      let pFail = 0, capacity = 0, formula = '', explain = '';
      const p = pPerDisk;
      const q = 1 - p;
      switch (level) {
        case '0':
          pFail = 1 - Math.pow(q, n);
          capacity = n * capPerDisk;
          formula = `1 − (1 − p)^n = 1 − ${q.toFixed(2)}^${n}`;
          explain = 'Ausfall, sobald mind. 1 Festplatte ausfällt.';
          break;
        case '1':
          pFail = Math.pow(p, n);
          capacity = capPerDisk;
          formula = `p^n = ${p}^${n}`;
          explain = 'Ausfall nur, wenn ALLE Festplatten ausfallen.';
          break;
        case '5':
          // tolerates 1 failure; fails if ≥2 fail
          pFail = 0;
          for (let k = 2; k <= n; k++) pFail += binom(n, k) * Math.pow(p, k) * Math.pow(q, n - k);
          capacity = (n - 1) * capPerDisk;
          formula = `Σ_{k=2..n} C(n,k) · p^k · (1−p)^(n−k)`;
          explain = 'Toleriert 1 Ausfall, fällt ab 2 Ausfällen aus. Kapazität (n−1)·c.';
          break;
        case '6':
          pFail = 0;
          for (let k = 3; k <= n; k++) pFail += binom(n, k) * Math.pow(p, k) * Math.pow(q, n - k);
          capacity = (n - 2) * capPerDisk;
          formula = `Σ_{k=3..n} C(n,k) · p^k · (1−p)^(n−k)`;
          explain = 'Toleriert 2 Ausfälle (doppelte Parität).';
          break;
        case '10': {
          // n must be even ≥4: pairs of mirrors striped.
          if (n % 2 !== 0) { pFail = NaN; capacity = NaN; break; }
          const pairs = n / 2;
          const pairFail = p * p;     // both disks of a mirror fail
          pFail = 1 - Math.pow(1 - pairFail, pairs);
          capacity = pairs * capPerDisk;
          formula = `1 − (1 − p²)^(n/2)`;
          explain = 'RAID 0 über RAID-1-Paare. Jedes Paar fällt nur aus, wenn beide Disks ausfallen.';
          break;
        }
        case '01': {
          if (n % 2 !== 0) { pFail = NaN; capacity = NaN; break; }
          const pairs = n / 2;        // 2 stripe-sets
          const stripeFail = 1 - Math.pow(q, pairs);
          pFail = stripeFail * stripeFail;
          capacity = pairs * capPerDisk;
          formula = `(1 − (1−p)^(n/2))²`;
          explain = 'RAID 1 über RAID-0-Sets. Jeder Stripe fällt aus, sobald 1 Disk ausfällt; gespiegelt.';
          break;
        }
      }
      return { pFail, capacity, formula, explain };
    }

    function binom(n, k) { if (k < 0 || k > n) return 0; let r = 1; for (let i = 0; i < k; i++) r = r * (n - i) / (i + 1); return r; }

    function render() {
      const r = compute();
      const pStr = isNaN(r.pFail) ? '—' : (r.pFail * 100).toFixed(4) + ' %';
      const capStr = isNaN(r.capacity) ? '—' : r.capacity + ' TB';
      root.innerHTML = `
        <div class="game-controls raid-controls">
          <label>RAID-Level
            <select id="rLevel">
              <option value="0">RAID 0 (Striping)</option>
              <option value="1">RAID 1 (Mirroring)</option>
              <option value="5">RAID 5 (1× Parität)</option>
              <option value="6">RAID 6 (2× Parität)</option>
              <option value="10">RAID 10 (Stripe of Mirrors)</option>
              <option value="01">RAID 01 (Mirror of Stripes)</option>
            </select>
          </label>
          <label>Anzahl Festplatten n
            <input type="number" min="2" max="12" id="rN" value="${state.n}" />
          </label>
          <label>Kapazität pro Disk (TB)
            <input type="number" min="1" max="64" id="rCap" value="${state.capPerDisk}" />
          </label>
          <label>Ausfall-Wahrscheinlichkeit p (pro Disk, pro Zeiteinheit)
            <input type="number" min="0" max="1" step="0.01" id="rP" value="${state.pPerDisk}" />
          </label>
        </div>

        <div class="raid-result">
          <div class="raid-card">
            <div class="raid-label">Nutzbare Kapazität</div>
            <div class="raid-val">${capStr}</div>
          </div>
          <div class="raid-card">
            <div class="raid-label">Ausfall-Wahrscheinlichkeit</div>
            <div class="raid-val">${pStr}</div>
            <div class="raid-formula">${r.formula}</div>
          </div>
        </div>

        <div class="raid-explain">${r.explain}</div>

        <hr>

        <div class="raid-quiz">
          <h3>🎯 Quiz</h3>
          <div id="raidQuiz"></div>
        </div>

        <div class="game-help">
          <details>
            <summary>📖 Formeln im Überblick</summary>
            <ul>
              <li>RAID 0: <code>P(Ausfall) = 1 − (1−p)^n</code>; Kap = n·c</li>
              <li>RAID 1 (n Spiegel): <code>P = p^n</code>; Kap = c</li>
              <li>RAID 5: ≥2 Ausfälle ⇒ Datenverlust; Kap = (n−1)·c</li>
              <li>RAID 6: ≥3 Ausfälle ⇒ Datenverlust; Kap = (n−2)·c</li>
              <li>RAID 10: <code>P = 1 − (1−p²)^(n/2)</code>; Kap = (n/2)·c</li>
              <li>RAID 01: <code>P = (1 − (1−p)^(n/2))²</code>; Kap = (n/2)·c</li>
            </ul>
          </details>
        </div>
      `;
      root.querySelector('#rLevel').value = state.level;
      root.querySelectorAll('#rLevel,#rN,#rCap,#rP').forEach(inp => {
        inp.addEventListener('change', () => {
          state.level = root.querySelector('#rLevel').value;
          state.n = Math.max(2, parseInt(root.querySelector('#rN').value, 10) || 2);
          state.capPerDisk = Math.max(1, parseFloat(root.querySelector('#rCap').value) || 1);
          state.pPerDisk = Math.min(1, Math.max(0, parseFloat(root.querySelector('#rP').value) || 0));
          render();
        });
      });
      renderQuiz();
    }

    function renderQuiz() {
      const levels = [['0', 2, 0.1], ['1', 2, 0.1], ['0', 3, 0.05], ['5', 4, 0.05], ['1', 3, 0.2], ['10', 4, 0.1]];
      const [lvl, n, p] = levels[Math.floor(Math.random() * levels.length)];
      const old = { ...state };
      state.level = lvl; state.n = n; state.pPerDisk = p; state.capPerDisk = 1;
      const r = compute();
      Object.assign(state, old);
      const target = (r.pFail * 100).toFixed(2);
      const node = root.querySelector('#raidQuiz');
      node.innerHTML = `
        <div>Berechne die Ausfallwahrscheinlichkeit für: <b>RAID ${lvl}</b>, n=<b>${n}</b>, p=<b>${p}</b> pro Disk.</div>
        <div class="raid-quiz-row">
          <input class="input" id="rqAns" placeholder="z.B. 1.99 (in %)" />
          <button class="btn btn-primary" id="rqCheck">Prüfen</button>
          <button class="btn btn-secondary" id="rqNew">🎲 Neue Frage</button>
        </div>
        <div id="rqFb"></div>
      `;
      node.querySelector('#rqCheck').addEventListener('click', () => {
        const ans = parseFloat(node.querySelector('#rqAns').value.replace(',', '.'));
        const ok = !isNaN(ans) && Math.abs(ans - parseFloat(target)) < 0.5;
        node.querySelector('#rqFb').innerHTML = ok
          ? `<div class="mmu-ok">✅ Richtig (Toleranz ±0,5 %). Exakt: ${target} %.</div>`
          : `<div class="mmu-bad">❌ Erwartet: ${target} %.</div>`;
      });
      node.querySelector('#rqNew').addEventListener('click', renderQuiz);
    }

    render();
  }

  /* ================================================================
     5) BUDDY-SYSTEM
     ================================================================ */
  function renderBuddy(root) {
    const SIZE = 256; // KiB total
    const MIN  = 4;   // smallest split (KiB)
    // Tree node: { size, free: bool, alloc: null|{label,reqSize}, left, right }

    function makeTree(size = SIZE) { return { size, free: true, alloc: null, left: null, right: null }; }
    let tree = makeTree();
    let allocs = 0;
    let log = [];

    function findFit(node, size) {
      if (node.size < size) return null;
      // If split:
      if (node.left) {
        return findFit(node.left, size) || findFit(node.right, size);
      }
      if (!node.free) return null;
      // free leaf with size >= request
      if (node.size === size) return node;
      // need to split if node.size / 2 >= size and node.size > MIN
      if (node.size / 2 >= size && node.size > MIN) {
        node.left = makeTree(node.size / 2);
        node.right = makeTree(node.size / 2);
        node.free = false;
        return findFit(node.left, size);
      }
      return node; // exact in 2-power sense
    }

    function allocate(reqKb) {
      // round up to next power of 2 >= max(MIN, reqKb)
      let s = MIN;
      while (s < reqKb) s *= 2;
      if (s > SIZE) { log.push(`❌ ${reqKb} KiB > Speichergröße`); return false; }
      const node = findFit(tree, s);
      if (!node) { log.push(`❌ ${reqKb} KiB → keinen ${s}-KiB-Block frei`); return false; }
      node.free = false;
      node.alloc = { label: 'A' + (++allocs), reqSize: reqKb };
      log.push(`✅ ${reqKb} KiB → Block ${s} KiB belegt (Verschnitt ${s - reqKb})`);
      return true;
    }

    function findByLabel(node, label) {
      if (!node) return null;
      if (node.alloc && node.alloc.label === label) return node;
      return findByLabel(node.left, label) || findByLabel(node.right, label);
    }

    function tryMerge(parent) {
      // both children must be free leaves
      if (!parent || !parent.left || !parent.right) return;
      const L = parent.left, R = parent.right;
      if (L.free && !L.left && R.free && !R.left) {
        parent.left = parent.right = null;
        parent.free = true;
        return true;
      }
      return false;
    }

    function freeAlloc(label) {
      const node = findByLabel(tree, label);
      if (!node) return;
      node.alloc = null;
      node.free = true;
      log.push(`🗑 ${label} freigegeben`);
      // bottom-up merge: walk from root to leaf and try to merge on the way back up
      function walk(n) {
        if (!n || !n.left) return;
        walk(n.left); walk(n.right);
        tryMerge(n);
      }
      walk(tree);
    }

    function listAllocs(node, out = []) {
      if (!node) return out;
      if (node.alloc) out.push(node.alloc.label);
      listAllocs(node.left, out); listAllocs(node.right, out);
      return out;
    }

    function totalWaste(node) {
      if (!node) return 0;
      if (node.alloc) return node.size - node.alloc.reqSize;
      return totalWaste(node.left) + totalWaste(node.right);
    }

    function renderTree(node) {
      if (!node.left) {
        const cls = node.alloc ? 'buddy-alloc' : 'buddy-free';
        const lbl = node.alloc ? `${node.alloc.label} <small>(${node.alloc.reqSize}/${node.size} KiB)</small>` : `frei ${node.size} KiB`;
        return `<div class="buddy-leaf ${cls}" style="flex-grow:${node.size}">${lbl}</div>`;
      }
      return `<div class="buddy-split">${renderTree(node.left)}${renderTree(node.right)}</div>`;
    }

    function render() {
      const labels = listAllocs(tree);
      root.innerHTML = `
        <div class="game-controls">
          <label>Allozieren (KiB)
            <input type="number" min="1" max="256" id="bdAlloc" value="50" />
          </label>
          <button class="btn btn-primary" id="bdAdd">+ Allozieren</button>
          <label>Freigeben
            <select id="bdFreeSel">${labels.length === 0 ? '<option disabled>(nichts belegt)</option>' : labels.map(l => `<option>${l}</option>`).join('')}</select>
          </label>
          <button class="btn btn-secondary" id="bdFree">🗑 Freigeben</button>
          <button class="btn btn-secondary" id="bdReset">↺ Reset</button>
        </div>

        <div class="buddy-bar">${renderTree(tree)}</div>

        <div class="game-info">
          <span class="chip">Gesamt: <b>${SIZE} KiB</b></span>
          <span class="chip">Verschnitt: <b>${totalWaste(tree)} KiB</b></span>
          <span class="chip">Belegt: <b>${labels.length}</b></span>
        </div>

        <div class="pr-log">${log.slice(-8).map(l => `<div>${l}</div>`).join('')}</div>

        <div class="game-help">
          <details><summary>📖 Buddy-System</summary>
          <ul>
            <li>Speicher wird in 2er-Potenz-Blöcke geteilt (Min 4 KiB).</li>
            <li>Anfrage <code>x</code> wird auf nächste 2er-Potenz aufgerundet → Verschnitt.</li>
            <li>Freigabe verschmilzt mit Buddy automatisch.</li>
          </ul>
          </details>
        </div>
      `;
      const $ = sel => root.querySelector(sel);
      $('#bdAdd').addEventListener('click', () => {
        const v = parseInt($('#bdAlloc').value, 10);
        if (!v || v <= 0) return;
        allocate(v);
        render();
      });
      $('#bdFree').addEventListener('click', () => {
        const sel = $('#bdFreeSel');
        if (!sel || !sel.value) return;
        freeAlloc(sel.value);
        render();
      });
      $('#bdReset').addEventListener('click', () => { tree = makeTree(); allocs = 0; log = []; render(); });
    }

    render();
  }

  /* ================================================================
     6) BELEGUNGSSTRATEGIEN — FIRSTFIT/BESTFIT/WORSTFIT/NEXTFIT
     ================================================================ */
  function renderFitStrat(root) {
    function newPuzzle() {
      const free = [];
      const n = rngInt(5, 7);
      for (let i = 0; i < n; i++) free.push(rngInt(4, 32));
      const reqs = [rngInt(4, 16), rngInt(4, 12)];
      return { free, reqs };
    }

    function pickFirst(free, req, last = -1) {
      for (let i = 0; i < free.length; i++) if (free[i] >= req) return i;
      return -1;
    }
    function pickNext(free, req, last) {
      const start = (last + 1) % free.length;
      for (let off = 0; off < free.length; off++) {
        const i = (start + off) % free.length;
        if (free[i] >= req) return i;
      }
      return -1;
    }
    function pickBest(free, req) {
      let best = -1, bestVal = Infinity;
      for (let i = 0; i < free.length; i++) if (free[i] >= req && free[i] < bestVal) { best = i; bestVal = free[i]; }
      return best;
    }
    function pickWorst(free, req) {
      let best = -1, bestVal = -1;
      for (let i = 0; i < free.length; i++) if (free[i] >= req && free[i] > bestVal) { best = i; bestVal = free[i]; }
      return best;
    }

    function solve(p) {
      const out = {};
      ['First', 'Next', 'Best', 'Worst'].forEach(s => {
        const free = p.free.slice();
        const picks = [];
        let last = -1;
        for (const r of p.reqs) {
          let i;
          if (s === 'First') i = pickFirst(free, r);
          if (s === 'Next')  i = pickNext(free, r, last);
          if (s === 'Best')  i = pickBest(free, r);
          if (s === 'Worst') i = pickWorst(free, r);
          picks.push(i);
          if (i !== -1) { free[i] -= r; last = i; }
        }
        out[s] = picks;
      });
      return out;
    }

    let puzzle = newPuzzle();

    function render() {
      const sol = solve(puzzle);
      let opts = '';
      puzzle.free.forEach((v, i) => opts += `<option value="${i}">Block ${i + 1} (${v} KiB)</option>`);
      opts += `<option value="-1">— passt nicht —</option>`;

      let reqRows = '';
      puzzle.reqs.forEach((r, idx) => {
        reqRows += `<tr><th>${r} KiB</th>` +
          ['First', 'Next', 'Best', 'Worst'].map(s =>
            `<td><select class="select small" data-strat="${s}" data-idx="${idx}">${opts}</select></td>`
          ).join('') + '</tr>';
      });

      root.innerHTML = `
        <div class="game-info">
          <span class="chip">Freie Blöcke (Reihenfolge): ${puzzle.free.map((v, i) => `<b>B${i + 1}=${v}</b>`).join(', ')}</span>
        </div>
        <div>Anfragen in Reihenfolge: ${puzzle.reqs.map(r => `<b>${r} KiB</b>`).join(', ')}</div>
        <table class="pr-table fit-table">
          <thead><tr><th>Anfrage</th><th>FirstFit</th><th>NextFit</th><th>BestFit</th><th>WorstFit</th></tr></thead>
          <tbody>${reqRows}</tbody>
        </table>
        <div class="game-actions">
          <button class="btn btn-primary" id="fsCheck">Prüfen</button>
          <button class="btn btn-secondary" id="fsReveal">Lösung</button>
          <button class="btn btn-secondary" id="fsNew">🎲 Neu</button>
        </div>
        <div id="fsFb" class="mmu-feedback"></div>
      `;

      const $ = s => root.querySelector(s);
      $('#fsCheck').addEventListener('click', () => {
        const errs = [];
        ['First', 'Next', 'Best', 'Worst'].forEach(s => {
          puzzle.reqs.forEach((r, idx) => {
            const sel = root.querySelector(`select[data-strat="${s}"][data-idx="${idx}"]`);
            const got = parseInt(sel.value, 10);
            const exp = sol[s][idx];
            if (got !== exp) errs.push(`${s}Fit · Anfrage ${r} KiB: erwartet ${exp === -1 ? '— passt nicht —' : 'B' + (exp + 1)}, gewählt ${got === -1 ? '— passt nicht —' : 'B' + (got + 1)}`);
          });
        });
        $('#fsFb').innerHTML = errs.length === 0
          ? `<div class="mmu-ok">✅ Alle Strategien korrekt!</div>`
          : `<div class="mmu-bad">❌ ${errs.length} Fehler:<br>${errs.join('<br>')}</div>`;
      });
      $('#fsReveal').addEventListener('click', () => {
        ['First', 'Next', 'Best', 'Worst'].forEach(s => {
          puzzle.reqs.forEach((r, idx) => {
            root.querySelector(`select[data-strat="${s}"][data-idx="${idx}"]`).value = sol[s][idx];
          });
        });
        $('#fsCheck').click();
      });
      $('#fsNew').addEventListener('click', () => { puzzle = newPuzzle(); render(); });
    }
    render();
  }

  /* ================================================================
     7) BANKER — Deadlock-Detektor
     ================================================================ */
  function renderBanker(root) {
    function newPuzzle() {
      const nP = 4, nR = 3;
      const E = [rngInt(6, 9), rngInt(5, 8), rngInt(4, 7)];
      const B = Array.from({ length: nP }, () => new Array(nR).fill(0));
      const C = Array.from({ length: nP }, () => new Array(nR).fill(0));

      // 1) Belegung B verteilen — pro Ressource Σ B[i][j] ≤ E[j].
      //    Pro Ressource lassen wir 60–95 % von E vergeben werden.
      for (let j = 0; j < nR; j++) {
        const totalToAssign = Math.max(0, Math.min(
          E[j],
          Math.floor(E[j] * (0.6 + Math.random() * 0.35))
        ));
        let remaining = totalToAssign;
        // zufällige Reihenfolge der Prozesse, damit nicht immer P1 am meisten kriegt
        const order = [...Array(nP).keys()].sort(() => Math.random() - 0.5);
        for (let k = 0; k < order.length; k++) {
          const i = order[k];
          const procsLeft = order.length - k;
          // im Schnitt fair, aber leicht zufällig (0..2*Schnitt)
          const avg = remaining / procsLeft;
          const give = Math.min(remaining, Math.max(0, Math.round(Math.random() * 2 * avg)));
          B[i][j] = give;
          remaining -= give;
        }
        // Rest dem letzten geben (numerische Restpoolung)
        if (remaining > 0) B[order[order.length - 1]][j] += remaining;
      }

      // 2) Wunsch C plausibilisieren — Wunsch darf den frei verfügbaren
      //    Gesamtbestand pro Ressource nicht überschreiten (sonst niemals
      //    erfüllbar). Wir wählen C[i][j] ≤ E[j] - B[i][j].
      for (let i = 0; i < nP; i++) {
        for (let j = 0; j < nR; j++) {
          const maxWish = Math.max(0, E[j] - B[i][j]);
          C[i][j] = rngInt(0, Math.min(3, maxWish));
        }
      }
      return { E, B, C };
    }
    let puzzle = newPuzzle();

    function detect(p) {
      const A = p.E.map((e, j) => e - p.B.reduce((s, b) => s + b[j], 0));
      const marked = new Array(p.B.length).fill(false);
      const order = [];
      let progress = true;
      while (progress) {
        progress = false;
        for (let i = 0; i < p.B.length; i++) {
          if (marked[i]) continue;
          if (p.C[i].every((c, j) => c <= A[j])) {
            marked[i] = true;
            order.push(i);
            for (let j = 0; j < A.length; j++) A[j] += p.B[i][j];
            progress = true;
          }
        }
      }
      const deadlocked = marked.map((m, i) => m ? -1 : i).filter(x => x !== -1);
      return { order, deadlocked, finalA: A };
    }

    function render() {
      const sol = detect(puzzle);
      let html = `
        <div>Gesamtbestand E: ${puzzle.E.map((e, j) => `<b>${'ABC'[j]}=${e}</b>`).join(' · ')}</div>
        <table class="pr-table">
          <thead><tr><th>Prozess</th><th colspan="3">Belegung B</th><th colspan="3">Wunsch C</th></tr>
          <tr><th></th><th>A</th><th>B</th><th>C</th><th>A</th><th>B</th><th>C</th></tr></thead>
          <tbody>
            ${puzzle.B.map((row, i) => `<tr><th>P${i + 1}</th>${row.map(v => `<td>${v}</td>`).join('')}${puzzle.C[i].map(v => `<td>${v}</td>`).join('')}</tr>`).join('')}
          </tbody>
        </table>
        <div class="bk-question">
          Welche Prozesse können in welcher Reihenfolge fertiglaufen?<br>
          <input class="input" id="bkOrder" placeholder="z.B. 1,3,2,4 (oder leer wenn alle deadlocked)" />
        </div>
        <div class="bk-question">
          Welche Prozesse stecken im Deadlock fest? (Nummern, kommasepariert; leer = keine)<br>
          <input class="input" id="bkDead" placeholder="z.B. 2,4" />
        </div>
        <div class="game-actions">
          <button class="btn btn-primary" id="bkCheck">Prüfen</button>
          <button class="btn btn-secondary" id="bkReveal">Lösung</button>
          <button class="btn btn-secondary" id="bkNew">🎲 Neu</button>
        </div>
        <div id="bkFb" class="mmu-feedback"></div>
      `;
      root.innerHTML = html;
      const $ = s => root.querySelector(s);
      $('#bkCheck').addEventListener('click', () => {
        const ord = ($('#bkOrder').value || '').split(/[,\s]+/).filter(Boolean).map(x => parseInt(x, 10) - 1);
        const dl  = ($('#bkDead').value  || '').split(/[,\s]+/).filter(Boolean).map(x => parseInt(x, 10) - 1).sort((a,b)=>a-b);

        // Die User-Reihenfolge gegen das System simulieren — es darf MEHRERE
        // gültige Safe-Sequences geben, daher reicht „eine valide" Reihenfolge.
        let okOrd = true;
        let ordError = '';
        const A = puzzle.E.map((e, j) => e - puzzle.B.reduce((s, b) => s + b[j], 0));
        const seen = new Set();
        for (const i of ord) {
          if (!Number.isInteger(i) || i < 0 || i >= puzzle.B.length) {
            okOrd = false; ordError = `Prozess „${i + 1}" existiert nicht.`; break;
          }
          if (seen.has(i)) {
            okOrd = false; ordError = `Prozess P${i + 1} wurde mehrfach genannt.`; break;
          }
          if (!puzzle.C[i].every((c, j) => c <= A[j])) {
            okOrd = false;
            ordError = `P${i + 1} kann an dieser Stelle nicht laufen — Wunsch (${puzzle.C[i].join(',')}) > frei (${A.join(',')}).`;
            break;
          }
          seen.add(i);
          for (let j = 0; j < A.length; j++) A[j] += puzzle.B[i][j];
        }
        // Es müssen genau die nicht-deadlocked-Prozesse vorkommen
        const expectedRunning = sol.order.slice().sort((a,b)=>a-b);
        const gotRunning = [...seen].sort((a,b)=>a-b);
        if (okOrd && (gotRunning.length !== expectedRunning.length
                      || gotRunning.some((v, k) => v !== expectedRunning[k]))) {
          okOrd = false;
          ordError = 'Die genannte Reihenfolge enthält nicht alle ausführbaren Prozesse.';
        }

        const okDl = dl.length === sol.deadlocked.length
                  && dl.every((v, i) => v === sol.deadlocked[i]);

        const ordTxt  = sol.order.map(i => 'P' + (i + 1)).join(' → ') || '(keine)';
        const deadTxt = sol.deadlocked.length
          ? sol.deadlocked.map(i => 'P' + (i + 1)).join(', ')
          : 'keine';
        $('#bkFb').innerHTML = (okOrd && okDl)
          ? `<div class="mmu-ok">✅ Korrekt! Eine gültige Reihenfolge: ${ordTxt}; Deadlock: ${deadTxt}.</div>`
          : `<div class="mmu-bad">❌ ${ordError ? ordError + '<br>' : ''}Eine gültige Lösung wäre: Reihenfolge ${ordTxt}; Deadlock: ${deadTxt}.</div>`;
      });
      $('#bkReveal').addEventListener('click', () => {
        $('#bkOrder').value = sol.order.map(i => i + 1).join(',');
        $('#bkDead').value  = sol.deadlocked.map(i => i + 1).join(',');
        $('#bkCheck').click();
      });
      $('#bkNew').addEventListener('click', () => { puzzle = newPuzzle(); render(); });
    }
    render();
  }

  /* ================================================================
     8) SCHEDULING — Gantt
     ================================================================ */
  function renderScheduling(root) {
    const state = {
      strategy: 'FCFS',
      quantum: 2,
      procs: [
        { name: 'P1', arrival: 0, burst: 4 },
        { name: 'P2', arrival: 1, burst: 3 },
        { name: 'P3', arrival: 2, burst: 1 },
        { name: 'P4', arrival: 3, burst: 2 },
      ]
    };

    function simulate() {
      const procs = state.procs.map(p => ({ ...p, rem: p.burst, start: -1, finish: -1 }));
      const timeline = [];
      let t = 0; const nDone = () => procs.filter(p => p.rem === 0).length;
      const guard = 10000;
      let g = 0;
      switch (state.strategy) {
        case 'FCFS': {
          const q = procs.slice().sort((a, b) => a.arrival - b.arrival);
          for (const p of q) {
            if (t < p.arrival) { timeline.push({ name: 'idle', from: t, to: p.arrival }); t = p.arrival; }
            timeline.push({ name: p.name, from: t, to: t + p.burst });
            p.start = t; p.finish = t + p.burst; t += p.burst;
          }
          break;
        }
        case 'SJF': {  // non-preemptive shortest job first (by burst, among arrived)
          while (nDone() < procs.length && g++ < guard) {
            const ready = procs.filter(p => p.rem > 0 && p.arrival <= t);
            if (ready.length === 0) {
              const next = Math.min(...procs.filter(p => p.rem > 0).map(p => p.arrival));
              timeline.push({ name: 'idle', from: t, to: next }); t = next; continue;
            }
            ready.sort((a, b) => a.burst - b.burst || a.arrival - b.arrival);
            const p = ready[0];
            timeline.push({ name: p.name, from: t, to: t + p.burst });
            t += p.burst; p.rem = 0; p.finish = t;
          }
          break;
        }
        case 'SRTF': {
          while (nDone() < procs.length && g++ < guard) {
            const ready = procs.filter(p => p.rem > 0 && p.arrival <= t);
            if (ready.length === 0) {
              const next = Math.min(...procs.filter(p => p.rem > 0).map(p => p.arrival));
              timeline.push({ name: 'idle', from: t, to: next }); t = next; continue;
            }
            ready.sort((a, b) => a.rem - b.rem || a.arrival - b.arrival);
            const p = ready[0];
            const last = timeline[timeline.length - 1];
            if (last && last.name === p.name) last.to = t + 1;
            else timeline.push({ name: p.name, from: t, to: t + 1 });
            p.rem--; t++;
            if (p.rem === 0) p.finish = t;
          }
          break;
        }
        case 'RR': {
          const q = state.quantum;
          const queue = [];
          const arrived = new Set();
          while (nDone() < procs.length && g++ < guard) {
            // add new arrivals
            procs.forEach(p => { if (!arrived.has(p.name) && p.arrival <= t && p.rem > 0) { queue.push(p); arrived.add(p.name); } });
            if (queue.length === 0) {
              const next = Math.min(...procs.filter(p => p.rem > 0 && !arrived.has(p.name)).map(p => p.arrival));
              if (!isFinite(next)) break;
              timeline.push({ name: 'idle', from: t, to: next });
              t = next; continue;
            }
            const p = queue.shift();
            const slice = Math.min(q, p.rem);
            timeline.push({ name: p.name, from: t, to: t + slice });
            for (let s = 1; s <= slice; s++) {
              procs.forEach(pp => { if (!arrived.has(pp.name) && pp.arrival <= t + s && pp.rem > 0) { queue.push(pp); arrived.add(pp.name); } });
            }
            t += slice; p.rem -= slice;
            if (p.rem > 0) queue.push(p);
            else p.finish = t;
          }
          break;
        }
      }
      return { procs, timeline };
    }

    function render() {
      const sim = simulate();
      const total = sim.timeline.length ? sim.timeline[sim.timeline.length - 1].to : 0;
      const colors = {};
      const palette = ['#6366f1', '#10b981', '#f59e0b', '#ef4444', '#06b6d4', '#a855f7', '#ec4899'];
      sim.procs.forEach((p, i) => colors[p.name] = palette[i % palette.length]);

      const ganttHtml = sim.timeline.map(seg => {
        const w = (seg.to - seg.from) / total * 100;
        const c = seg.name === 'idle' ? 'repeating-linear-gradient(45deg,#cbd5e1,#cbd5e1 6px,#e2e8f0 6px,#e2e8f0 12px)' : colors[seg.name];
        return `<div class="gantt-seg" style="width:${w}%;background:${c}" title="${seg.name} ${seg.from}–${seg.to}">${seg.name}</div>`;
      }).join('');

      const axis = [];
      for (let i = 0; i <= total; i++) axis.push(`<span style="left:${i / total * 100}%">${i}</span>`);

      const stats = sim.procs.map(p => {
        const tat = p.finish - p.arrival;
        const wait = tat - p.burst;
        return `<tr><th>${p.name}</th><td>${p.arrival}</td><td>${p.burst}</td><td>${p.finish}</td><td>${tat}</td><td>${wait}</td></tr>`;
      }).join('');

      root.innerHTML = `
        <div class="game-controls">
          <label>Strategie
            <select id="schStrat">
              <option ${state.strategy === 'FCFS' ? 'selected' : ''}>FCFS</option>
              <option ${state.strategy === 'SJF' ? 'selected' : ''}>SJF</option>
              <option ${state.strategy === 'SRTF' ? 'selected' : ''}>SRTF</option>
              <option ${state.strategy === 'RR' ? 'selected' : ''}>RR</option>
            </select>
          </label>
          <label>Quantum (RR)
            <input type="number" id="schQ" min="1" max="10" value="${state.quantum}" />
          </label>
          <button class="btn btn-secondary" id="schAdd">+ Prozess</button>
        </div>

        <table class="pr-table" id="schTable">
          <thead><tr><th>Name</th><th>Ankunft</th><th>Burst</th><th></th></tr></thead>
          <tbody>
            ${state.procs.map((p, i) => `
              <tr>
                <td><input class="input small" data-i="${i}" data-k="name" value="${p.name}"/></td>
                <td><input class="input small" type="number" min="0" data-i="${i}" data-k="arrival" value="${p.arrival}"/></td>
                <td><input class="input small" type="number" min="1" data-i="${i}" data-k="burst" value="${p.burst}"/></td>
                <td><button class="btn-ghost" data-del="${i}">✕</button></td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <h3>Gantt</h3>
        <div class="gantt-bar">${ganttHtml}</div>
        <div class="gantt-axis">${axis.join('')}</div>

        <h3>Statistik</h3>
        <table class="pr-table">
          <thead><tr><th>P</th><th>Ankunft</th><th>Burst</th><th>Finish</th><th>Turnaround</th><th>Wartezeit</th></tr></thead>
          <tbody>${stats}</tbody>
        </table>
      `;

      const $ = s => root.querySelector(s);
      $('#schStrat').addEventListener('change', e => { state.strategy = e.target.value; render(); });
      $('#schQ').addEventListener('change', e => { state.quantum = Math.max(1, parseInt(e.target.value, 10) || 1); render(); });
      $('#schAdd').addEventListener('click', () => { state.procs.push({ name: 'P' + (state.procs.length + 1), arrival: 0, burst: 1 }); render(); });
      root.querySelectorAll('input[data-i]').forEach(inp => {
        inp.addEventListener('change', () => {
          const i = parseInt(inp.dataset.i, 10);
          const k = inp.dataset.k;
          state.procs[i][k] = (k === 'name') ? inp.value : Math.max(0, parseInt(inp.value, 10) || 0);
          if (k !== 'name' && state.procs[i].burst < 1) state.procs[i].burst = 1;
          render();
        });
      });
      root.querySelectorAll('button[data-del]').forEach(b => {
        b.addEventListener('click', () => {
          state.procs.splice(parseInt(b.dataset.del, 10), 1);
          if (state.procs.length === 0) state.procs.push({ name: 'P1', arrival: 0, burst: 1 });
          render();
        });
      });
    }
    render();
  }

  /* ================================================================
     9) DISK SCHEDULING
     ================================================================ */
  function renderDiskSched(root) {
    const state = {
      strategy: 'SSTF',
      head: 50,
      direction: 'up', // for SCAN/LOOK
      maxTrack: 199,
      requests: [82, 170, 43, 140, 24, 16, 190]
    };

    function simulate() {
      const reqs = state.requests.slice();
      const order = [];
      let head = state.head;
      let total = 0;
      switch (state.strategy) {
        case 'FCFS':
          for (const r of reqs) { total += Math.abs(r - head); order.push(r); head = r; }
          break;
        case 'SSTF': {
          const remaining = reqs.slice();
          while (remaining.length) {
            let bestI = 0, bestD = Infinity;
            remaining.forEach((r, i) => { const d = Math.abs(r - head); if (d < bestD) { bestD = d; bestI = i; } });
            const r = remaining.splice(bestI, 1)[0];
            total += Math.abs(r - head); order.push(r); head = r;
          }
          break;
        }
        case 'SCAN': {
          const sorted = reqs.slice().sort((a, b) => a - b);
          const above = sorted.filter(r => r >= head);
          const below = sorted.filter(r => r < head).reverse();
          if (state.direction === 'up') {
            above.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
            // hit end of disk
            if (head < state.maxTrack) { total += Math.abs(state.maxTrack - head); head = state.maxTrack; order.push('end:' + state.maxTrack); }
            below.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
          } else {
            below.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
            if (head > 0) { total += head; head = 0; order.push('end:0'); }
            above.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
          }
          break;
        }
        case 'LOOK': {
          const sorted = reqs.slice().sort((a, b) => a - b);
          const above = sorted.filter(r => r >= head);
          const below = sorted.filter(r => r < head).reverse();
          if (state.direction === 'up') {
            above.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
            below.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
          } else {
            below.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
            above.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
          }
          break;
        }
        case 'C-SCAN': {
          const sorted = reqs.slice().sort((a, b) => a - b);
          const above = sorted.filter(r => r >= head);
          const below = sorted.filter(r => r < head);
          above.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
          if (head < state.maxTrack) { total += state.maxTrack - head; }
          total += state.maxTrack;            // jump to 0
          head = 0; order.push('jump→0');
          below.forEach(r => { total += Math.abs(r - head); order.push(r); head = r; });
          break;
        }
      }
      return { order, total };
    }

    function render() {
      const sim = simulate();
      const all = [state.head, ...sim.order.filter(x => typeof x === 'number')];
      const max = Math.max(state.maxTrack, ...all);
      const W = 700, H = 220;
      const x = i => 30 + (i / (sim.order.length)) * (W - 40);
      const y = v => 20 + (v / max) * (H - 40);

      let pts = `M ${30},${y(state.head)}`;
      let dots = `<circle cx="30" cy="${y(state.head)}" r="4" fill="#6366f1"></circle><text x="34" y="${y(state.head) - 6}" font-size="10">Start ${state.head}</text>`;
      sim.order.forEach((r, i) => {
        const v = typeof r === 'number' ? r : parseInt(String(r).split(':')[1] || (String(r).startsWith('jump') ? 0 : 0), 10);
        const xi = x(i + 1), yi = y(v);
        pts += ` L ${xi},${yi}`;
        dots += `<circle cx="${xi}" cy="${yi}" r="3" fill="#10b981"></circle><text x="${xi + 4}" y="${yi - 4}" font-size="10">${typeof r === 'number' ? r : r}</text>`;
      });

      root.innerHTML = `
        <div class="game-controls">
          <label>Strategie
            <select id="dsStrat">${['FCFS', 'SSTF', 'SCAN', 'LOOK', 'C-SCAN'].map(s => `<option ${state.strategy === s ? 'selected' : ''}>${s}</option>`).join('')}</select>
          </label>
          <label>Kopfposition <input type="number" id="dsHead" value="${state.head}" min="0" max="${state.maxTrack}"/></label>
          <label>Max Track <input type="number" id="dsMax" value="${state.maxTrack}" min="1"/></label>
          <label>Richtung
            <select id="dsDir"><option value="up" ${state.direction === 'up' ? 'selected' : ''}>↑ aufwärts</option><option value="down" ${state.direction === 'down' ? 'selected' : ''}>↓ abwärts</option></select>
          </label>
          <label>Anfragen <input class="input" id="dsReq" value="${state.requests.join(',')}" /></label>
        </div>

        <div class="game-info"><span class="chip">Reihenfolge: <b>${sim.order.join(' → ')}</b></span><span class="chip">Gesamtbewegung: <b>${sim.total}</b> Tracks</span></div>

        <svg viewBox="0 0 ${W} ${H}" class="ds-svg" style="width:100%;max-width:${W}px;background:var(--bg-soft);border-radius:8px">
          <path d="${pts}" stroke="#6366f1" stroke-width="2" fill="none"/>
          ${dots}
        </svg>
      `;
      const $ = s => root.querySelector(s);
      $('#dsStrat').addEventListener('change', e => { state.strategy = e.target.value; render(); });
      $('#dsHead').addEventListener('change', e => { state.head = parseInt(e.target.value, 10) || 0; render(); });
      $('#dsMax').addEventListener('change', e => { state.maxTrack = parseInt(e.target.value, 10) || 1; render(); });
      $('#dsDir').addEventListener('change', e => { state.direction = e.target.value; render(); });
      $('#dsReq').addEventListener('change', e => {
        state.requests = e.target.value.split(/[,\s]+/).map(Number).filter(n => !isNaN(n) && n >= 0);
        if (!state.requests.length) state.requests = [10];
        render();
      });
    }
    render();
  }

  /* ================================================================
     10) i-NODE-ADRESSIERUNG
     ================================================================ */
  function renderInode(root) {
    const state = {
      blockSize: 4096,         // Bytes
      pointerSize: 4,          // Bytes per pointer
      direct: 12,
    };

    function calc() {
      const pPerBlock = state.blockSize / state.pointerSize;
      const direct      = state.direct * state.blockSize;
      const single      = pPerBlock * state.blockSize;
      const dbl         = pPerBlock * pPerBlock * state.blockSize;
      const triple      = pPerBlock * pPerBlock * pPerBlock * state.blockSize;
      return { pPerBlock, direct, single, dbl, triple, max: direct + single + dbl + triple };
    }

    function fmt(b) {
      const u = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB'];
      let i = 0; let v = b;
      while (v >= 1024 && i < u.length - 1) { v /= 1024; i++; }
      return v.toFixed(2) + ' ' + u[i];
    }

    function render() {
      const r = calc();
      root.innerHTML = `
        <div class="game-controls">
          <label>Blockgröße (Bytes) <input type="number" id="inBs" value="${state.blockSize}"/></label>
          <label>Pointer-Größe (Bytes) <input type="number" id="inPs" value="${state.pointerSize}"/></label>
          <label>Anzahl direct pointer <input type="number" id="inDir" value="${state.direct}"/></label>
        </div>

        <table class="pr-table">
          <thead><tr><th>Stufe</th><th>Adressraum</th><th>Berechnung</th></tr></thead>
          <tbody>
            <tr><th>direct</th><td>${fmt(r.direct)}</td><td>${state.direct} × ${fmt(state.blockSize)}</td></tr>
            <tr><th>single indirect</th><td>${fmt(r.single)}</td><td>${r.pPerBlock} × ${fmt(state.blockSize)}</td></tr>
            <tr><th>double indirect</th><td>${fmt(r.dbl)}</td><td>${r.pPerBlock}² × ${fmt(state.blockSize)}</td></tr>
            <tr><th>triple indirect</th><td>${fmt(r.triple)}</td><td>${r.pPerBlock}³ × ${fmt(state.blockSize)}</td></tr>
            <tr><th>≈ MAX Dateigröße</th><td><b>${fmt(r.max)}</b></td><td>Summe</td></tr>
          </tbody>
        </table>

        <hr>
        <h3>🎯 Quiz</h3>
        <div id="inoQuiz"></div>

        <div class="game-help">
          <details><summary>📖 Formel</summary>
          Pointer pro Block: <code>p = blockSize / pointerSize</code>.<br>
          Max-Größe = <code>direct·B + p·B + p²·B + p³·B</code>.
          </details>
        </div>
      `;
      ['inBs', 'inPs', 'inDir'].forEach(id => {
        root.querySelector('#' + id).addEventListener('change', e => {
          const v = Math.max(1, parseInt(e.target.value, 10) || 1);
          if (id === 'inBs') state.blockSize = v;
          if (id === 'inPs') state.pointerSize = v;
          if (id === 'inDir') state.direct = v;
          render();
        });
      });
      renderQuiz();
    }

    function renderQuiz() {
      const offsetMib = rngInt(1, 1024);
      const offsetBytes = offsetMib * 1024 * 1024;
      const r = calc();
      let level = 'direct';
      if (offsetBytes < r.direct) level = 'direct';
      else if (offsetBytes < r.direct + r.single) level = 'single indirect';
      else if (offsetBytes < r.direct + r.single + r.dbl) level = 'double indirect';
      else if (offsetBytes < r.max) level = 'triple indirect';
      else level = 'außerhalb der Datei';
      const node = root.querySelector('#inoQuiz');
      node.innerHTML = `
        <div>Frage: Über welche Indirektionsstufe wird Byte-Offset <b>${offsetMib} MiB</b> adressiert?</div>
        <div class="raid-quiz-row">
          <select class="select" id="iqAns">
            <option>direct</option><option>single indirect</option><option>double indirect</option><option>triple indirect</option><option>außerhalb der Datei</option>
          </select>
          <button class="btn btn-primary" id="iqCheck">Prüfen</button>
          <button class="btn btn-secondary" id="iqNew">🎲 Neue Frage</button>
        </div>
        <div id="iqFb"></div>
      `;
      node.querySelector('#iqCheck').addEventListener('click', () => {
        const ans = node.querySelector('#iqAns').value;
        node.querySelector('#iqFb').innerHTML = (ans === level)
          ? `<div class="mmu-ok">✅ Korrekt — ${level}.</div>`
          : `<div class="mmu-bad">❌ Erwartet: <b>${level}</b>.</div>`;
      });
      node.querySelector('#iqNew').addEventListener('click', renderQuiz);
    }

    render();
  }

  /* ================================================================
     INFOSEC #1) PHISHING DETECTIVE
     ================================================================ */
  function renderPhishing(root) {
    const POOL = [
      { phish: true,  from: 'paypa1-service@security-paypal.com',
        subject: 'Ihr Konto wurde eingeschränkt!',
        url: 'http://paypal.com.security-login.ru/verify',
        body: 'Sehr geehrter Kunde, wegen ungewöhnlicher Aktivitäten haben wir Ihr Konto VORÜBERGEHEND gesperrt. Bitte verifizieren Sie INNERHALB 24 STD Ihre Daten:',
        flags: ['Domain ist .ru, nicht paypal.com', 'Tippfehler "paypa1" statt "paypal"', 'Künstlicher Zeitdruck', 'Generische Anrede'] },
      { phish: false, from: 'no-reply@github.com',
        subject: 'New sign-in to your GitHub account',
        url: 'https://github.com/settings/sessions',
        body: 'We noticed a new sign-in to your account from Berlin, DE. If this was you, you can safely ignore this email.',
        flags: ['Domain stimmt mit Anbieter überein', 'Kein Druck, keine Datenabfrage', 'HTTPS auf Originaldomain'] },
      { phish: true,  from: 'amaz0n-support@amaz0n-de.shop',
        subject: 'Ihre Bestellung #A-882134 konnte nicht zugestellt werden',
        url: 'http://bit.ly/3xY9aQp',
        body: 'Bitte bestätigen Sie Ihre Lieferadresse über den Link, andernfalls wird die Sendung zurückgeschickt.',
        flags: ['"amaz0n" mit Null', '.shop-Domain statt amazon.de', 'URL-Shortener verschleiert Ziel', 'Keine personalisierte Bestellnummer'] },
      { phish: false, from: 'campus@hochschule-bremerhaven.de',
        subject: 'Klausurplan WS 25/26 veröffentlicht',
        url: 'https://campus.hs-bremerhaven.de/klausurplan',
        body: 'Liebe Studierende, der Klausurplan ist nun online verfügbar. Bei Fragen wenden Sie sich an das Prüfungsamt.',
        flags: ['Bekannte Hochschul-Domain', 'Kein Login angefordert', 'Plausibler Kontext'] },
      { phish: true,  from: 'IT-Support <it-support@firma-intern.help>',
        subject: 'Passwort läuft heute ab – sofort handeln',
        url: 'https://firma-intern.help/passwort-reset',
        body: 'Ihr Passwort läuft in 2 Stunden ab. Klicken Sie hier, um es zurückzusetzen, andernfalls verlieren Sie Ihren Zugang.',
        flags: ['Externe .help-Domain täuscht intern vor', 'Massiver Zeitdruck', 'Drohung mit Zugangsverlust', 'IT-Abteilung schickt nie solche Links'] },
      { phish: false, from: 'newsletter@heise.de',
        subject: 'c\'t wöchentlich: Die wichtigsten IT-News',
        url: 'https://www.heise.de/newsletter/aktuell',
        body: 'Diese Woche: Quanten-Krypto, neue Sicherheitslücken in… (Klicken Sie hier zum Abbestellen)',
        flags: ['Erwarteter Newsletter', 'Originaldomain', 'Abmelde-Link vorhanden'] },
      { phish: true,  from: 'Sparkasse Sicherheit <service@sparkasse-de-sicher.com>',
        subject: 'PushTAN-Aktualisierung erforderlich',
        url: 'https://sparkasse-de-sicher.com/pushtan',
        body: 'Sehr geehrte/r Kunde/in, Ihre PushTAN-Verbindung ist abgelaufen. Bitte mit IBAN, PIN und SMS-TAN reaktivieren.',
        flags: ['Bank fragt NIE nach PIN/TAN per Mail', 'Falsche Domain', 'Generische Anrede', 'Hinzugefügtes "-sicher"'] },
      { phish: false, from: 'security-noreply@dropbox.com',
        subject: 'Two-step verification turned on',
        url: 'https://www.dropbox.com/account/security',
        body: 'You enabled two-step verification on your Dropbox account. If this wasn\'t you, please contact support.',
        flags: ['Echte Dropbox-Domain', 'Bestätigung statt Aufforderung', 'Kein Klick erforderlich'] },
      { phish: true,  from: 'lottery@euro-millions-winner.org',
        subject: 'CONGRATULATIONS! You have won 2,500,000 EUR',
        url: 'http://claim-your-prize.win/registration',
        body: 'Dear Winner, your email address was selected randomly from millions. Send your bank details and a 250€ processing fee to claim.',
        flags: ['Vorabgebühr-Betrug ("Advance Fee")', 'Niemand "gewinnt" ohne mitzuspielen', 'Verdächtige TLD .win', 'Bittet um Geld + Daten'] },
      { phish: true,  from: 'ceo@firmagroup.com',
        subject: 'Dringend & vertraulich – bitte nicht weiterleiten',
        url: '—',
        body: 'Hallo, ich bin gerade in einem Meeting und brauche schnell eine Überweisung über 14.500€ an folgenden Lieferanten. Details folgen. Vertraulich!',
        flags: ['Klassischer CEO-Fraud / BEC', 'Druck + Geheimhaltung', 'Umgeht Vier-Augen-Prinzip', 'Externe Adresse statt internes Mail'] },
      { phish: false, from: 'kalender@google.com',
        subject: 'Termin: Vorlesung Informationssicherheit (morgen 09:00)',
        url: 'https://calendar.google.com/event?eid=…',
        body: 'Erinnerung an deinen Termin. Ort: Hörsaal 1.',
        flags: ['Erwarteter Kalendereintrag', 'Echte Google-Domain', 'Keine Datenabfrage'] },
      { phish: true,  from: 'microsoft-365-team@office365-mail.com',
        subject: '[Aktion erforderlich] Ihr Postfach wurde eingefroren',
        url: 'https://office365-mail.com/unfreeze?u=user@domain',
        body: 'Wegen Sicherheitsverletzungen wurde Ihr Postfach gesperrt. Klicken Sie unten zum Entsperren – sonst Datenverlust nach 12h.',
        flags: ['Microsoft-Domain ist NICHT office365-mail.com', 'Drohung mit Datenverlust', 'Künstlicher Zeitdruck'] },
    ];

    const state = { round: 0, score: 0, lives: 3, combo: 0, max: 8, picks: shuffle(POOL).slice(0, 8), reveal: false, last: null };

    function statusBar() {
      return `
        <div class="ph-status">
          <div class="ph-stat"><span>📨</span> Runde <b>${Math.min(state.round + 1, state.max)}</b> / ${state.max}</div>
          <div class="ph-stat ph-score"><span>⭐</span> <b>${state.score}</b> Pkt</div>
          <div class="ph-stat ph-combo">🔥 Combo <b>x${state.combo}</b></div>
          <div class="ph-stat ph-lives">${'❤️'.repeat(state.lives)}${'🩶'.repeat(3 - state.lives)}</div>
        </div>`;
    }

    function endScreen() {
      const grade = state.score >= 80 ? '🥇 Phish-Hunter Gold' :
                    state.score >= 50 ? '🥈 Wachsamer Detektiv' :
                    state.score >= 25 ? '🥉 Lehrling' : '☠️ In die Falle getappt';
      root.innerHTML = `
        <div class="ph-end">
          <div class="ph-end-grade">${grade}</div>
          <div class="ph-end-score">${state.score} Punkte</div>
          <p class="muted">Du hast ${state.round} von ${state.max} Mails geprüft. Nochmal?</p>
          <button class="btn btn-primary" id="phRestart">🔄 Neue Runde</button>
        </div>
      `;
      root.querySelector('#phRestart').addEventListener('click', () => renderPhishing(root));
    }

    function render() {
      if (state.round >= state.max || state.lives <= 0) return endScreen();
      const m = state.picks[state.round];
      root.innerHTML = `
        ${statusBar()}
        <div class="ph-mail">
          <div class="ph-mail-head">
            <div><span class="ph-l">Von:</span> <code>${escAttr(m.from)}</code></div>
            <div><span class="ph-l">Betreff:</span> <b>${escHtml(m.subject)}</b></div>
            <div><span class="ph-l">Link:</span> <code>${escAttr(m.url)}</code></div>
          </div>
          <div class="ph-mail-body">${escHtml(m.body)}</div>
        </div>
        <div class="ph-actions">
          <button class="btn ph-btn ph-btn-phish" id="phPhish">🎣 Phishing!</button>
          <button class="btn ph-btn ph-btn-legit" id="phLegit">✅ Echt</button>
        </div>
        <details class="game-help"><summary>💡 Tipps zur Phishing-Erkennung</summary>
          <ul>
            <li>Sender-Domain & Schreibweise (paypa1, amaz0n)</li>
            <li>URL-Mouseover: zeigt das Ziel?</li>
            <li>Druck, Drohungen, Zeitlimits</li>
            <li>Forderung nach PIN/TAN/Passwort</li>
            <li>Generische Anrede ("Sehr geehrter Kunde")</li>
          </ul>
        </details>
      `;
      const decide = (isPhish) => {
        const correct = isPhish === m.phish;
        if (correct) {
          state.combo += 1;
          state.score += 10 + Math.max(0, state.combo - 1) * 2;
        } else {
          state.combo = 0;
          state.lives -= 1;
        }
        state.last = { correct, mail: m };
        showReveal();
      };
      root.querySelector('#phPhish').addEventListener('click', () => decide(true));
      root.querySelector('#phLegit').addEventListener('click', () => decide(false));
    }

    function showReveal() {
      const { correct, mail } = state.last;
      root.innerHTML = `
        ${statusBar()}
        <div class="ph-reveal ${correct ? 'ok' : 'bad'}">
          <div class="ph-reveal-head">${correct ? '✅ Richtig!' : '❌ Daneben!'} Diese Mail war <b>${mail.phish ? 'Phishing 🎣' : 'echt ✉️'}</b>.</div>
          <div class="ph-reveal-flags">
            <div class="ph-l">Anhaltspunkte:</div>
            <ul>${mail.flags.map(f => `<li>${escHtml(f)}</li>`).join('')}</ul>
          </div>
          <button class="btn btn-primary" id="phNext">${state.round + 1 >= state.max || state.lives <= 0 ? 'Auswertung →' : 'Nächste Mail →'}</button>
        </div>
      `;
      root.querySelector('#phNext').addEventListener('click', () => {
        state.round += 1;
        render();
      });
    }

    render();
  }

  /* ================================================================
     INFOSEC #2) CAESAR-CRACKER
     ================================================================ */
  function renderCaesar(root) {
    const PHRASES = [
      'KRYPTOGRAPHIE IST DIE LEHRE DER GEHEIMSCHRIFTEN',
      'KERCKHOFFS PRINZIP STELLT SICHERHEIT AUF DEN SCHLUESSEL',
      'CAESAR VERSCHIEBT JEDEN BUCHSTABEN UM K STELLEN',
      'BRUTE FORCE GELINGT THEORETISCH IMMER',
      'EIN ANGREIFER SUCHT DEN SCHWAECHSTEN PUNKT',
      'CIA STEHT FUER VERTRAULICHKEIT INTEGRITAET VERFUEGBARKEIT',
      'PHISHING IST EIN WORTSPIEL AUS PASSWORD FISHING',
      'SHANNON SAGTE MAN MUSS DEM FEIND ALLES ZUTRAUEN',
      'SCHLUESSELRAUM WAECHST EXPONENTIELL MIT DER LAENGE',
      'ALLES WAS SICH HACKEN LAESST WIRD AUCH GEHACKT',
    ];

    const state = { round: 0, max: 5, score: 0, plain: '', shift: 0, guess: 0, hints: 0, t0: 0 };

    function pickRound() {
      state.plain = PHRASES[Math.floor(Math.random() * PHRASES.length)];
      state.shift = rngInt(3, 23);
      state.guess = 0;
      state.hints = 0;
      state.t0 = Date.now();
    }

    function shiftChar(c, k) {
      if (c < 'A' || c > 'Z') return c;
      return String.fromCharCode(((c.charCodeAt(0) - 65 + k) % 26 + 26) % 26 + 65);
    }
    function applyShift(text, k) { return text.split('').map(c => shiftChar(c, k)).join(''); }

    function endScreen() {
      const grade = state.score >= 400 ? '🥇 Krypto-Meister' :
                    state.score >= 250 ? '🥈 Krypto-Profi' :
                    state.score >= 100 ? '🥉 Code-Knacker' : '🔓 Übung macht den Meister';
      root.innerHTML = `
        <div class="ph-end">
          <div class="ph-end-grade">${grade}</div>
          <div class="ph-end-score">${state.score} Punkte</div>
          <p class="muted">${state.max} Sätze geknackt. Nochmal?</p>
          <button class="btn btn-primary" id="caRestart">🔄 Neue Runde</button>
        </div>
      `;
      root.querySelector('#caRestart').addEventListener('click', () => renderCaesar(root));
    }

    function render() {
      if (state.round >= state.max) return endScreen();
      const cipher = applyShift(state.plain, state.shift);
      const decoded = applyShift(cipher, -state.guess);
      const correct = decoded === state.plain;

      const counts = {};
      for (const c of cipher) if (c >= 'A' && c <= 'Z') counts[c] = (counts[c] || 0) + 1;
      const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]).slice(0, 5);

      root.innerHTML = `
        <div class="ph-status">
          <div class="ph-stat"><span>🧩</span> Runde <b>${state.round + 1}</b> / ${state.max}</div>
          <div class="ph-stat ph-score"><span>⭐</span> <b>${state.score}</b> Pkt</div>
          <div class="ph-stat">💡 Hints: <b>${state.hints}</b></div>
        </div>
        <div class="ca-cipher" aria-label="Geheimtext">${cipher}</div>
        <div class="ca-wheel">
          <button class="btn btn-secondary" id="caDown">−</button>
          <div class="ca-shift"><div class="ca-shift-label">Verschiebung k</div><div class="ca-shift-val">${state.guess}</div></div>
          <button class="btn btn-secondary" id="caUp">+</button>
          <input type="range" min="0" max="25" value="${state.guess}" id="caSlider" class="ca-slider"/>
        </div>
        <div class="ca-plain ${correct ? 'ok' : ''}" aria-label="Klartext-Vorschau">${decoded}</div>
        <div class="game-actions">
          <button class="btn btn-primary" id="caLock" ${correct ? '' : 'disabled'}>🔒 Lösung einreichen</button>
          <button class="btn btn-secondary" id="caHint">💡 Häufigkeitsanalyse (−20 Pkt)</button>
        </div>
        <div id="caHintBox" class="ca-hintbox" hidden>
          <b>Top-5 Buchstaben im Geheimtext:</b>
          ${sorted.map(([c, n]) => `<span class="chip">${c}: ${n}</span>`).join(' ')}
          <div class="muted" style="margin-top:6px;font-size:12px">Im Deutschen sind E, N, I, R, S am häufigsten – probiere k = (häufigster Buchstabe) − E.</div>
        </div>
      `;
      const $ = s => root.querySelector(s);
      const setG = (k) => { state.guess = ((k % 26) + 26) % 26; render(); };
      $('#caUp').addEventListener('click', () => setG(state.guess + 1));
      $('#caDown').addEventListener('click', () => setG(state.guess - 1));
      $('#caSlider').addEventListener('input', e => setG(parseInt(e.target.value, 10)));
      $('#caHint').addEventListener('click', () => {
        if (state.hints === 0) { state.score = Math.max(0, state.score - 20); }
        state.hints += 1;
        $('#caHintBox').hidden = false;
      });
      $('#caLock').addEventListener('click', () => {
        const sec = (Date.now() - state.t0) / 1000;
        const speedBonus = Math.max(0, 60 - Math.floor(sec));
        state.score += 100 + speedBonus;
        state.round += 1;
        pickRound();
        render();
      });
    }

    pickRound();
    render();
  }

  /* ================================================================
     INFOSEC #3) PORT-HUNTER (Speed-Quiz)
     ================================================================ */
  function renderPortHunter(root) {
    const PORTS = [
      { p: 22,  s: 'SSH',     hint: 'Secure Shell' },
      { p: 23,  s: 'Telnet',  hint: 'Unverschlüsselte Remote-Shell' },
      { p: 25,  s: 'SMTP',    hint: 'Mailversand' },
      { p: 53,  s: 'DNS',     hint: 'Namensauflösung' },
      { p: 80,  s: 'HTTP',    hint: 'Web (unverschlüsselt)' },
      { p: 110, s: 'POP3',    hint: 'Mailabholung' },
      { p: 143, s: 'IMAP',    hint: 'Mailzugriff (server-seitig)' },
      { p: 161, s: 'SNMP',    hint: 'Netzwerk-Monitoring' },
      { p: 443, s: 'HTTPS',   hint: 'Web mit TLS' },
      { p: 465, s: 'SMTPS',   hint: 'SMTP über TLS' },
      { p: 587, s: 'SMTP-Submission', hint: 'Mailversand mit Auth' },
      { p: 993, s: 'IMAPS',   hint: 'IMAP über TLS' },
      { p: 995, s: 'POP3S',   hint: 'POP3 über TLS' },
      { p: 3389,s: 'RDP',     hint: 'Windows Remote Desktop' },
      { p: 21,  s: 'FTP',     hint: 'Unverschlüsselter Dateitransfer' },
      { p: 67,  s: 'DHCP',    hint: 'IP-Konfiguration (Server)' },
    ];
    const TOTAL_TIME = 30;
    const state = { score: 0, combo: 0, best: 0, t: TOTAL_TIME, q: null, opts: [], answered: false, _t: null };

    function nextQ() {
      state.q = PORTS[Math.floor(Math.random() * PORTS.length)];
      const wrong = shuffle(PORTS.filter(p => p.p !== state.q.p)).slice(0, 5);
      state.opts = shuffle([state.q, ...wrong]);
      state.answered = false;
    }

    function endScreen() {
      if (state._t) { clearInterval(state._t); state._t = null; }
      const grade = state.score >= 200 ? '🥇 Port-Sniper' :
                    state.score >= 120 ? '🥈 Network Ninja' :
                    state.score >= 60  ? '🥉 Scanner-Schüler' : '🐌 Übung macht den Meister';
      root.innerHTML = `
        <div class="ph-end">
          <div class="ph-end-grade">${grade}</div>
          <div class="ph-end-score">${state.score} Punkte</div>
          <p class="muted">Beste Combo: <b>x${state.best}</b></p>
          <button class="btn btn-primary" id="phRestart">🔄 Nochmal</button>
        </div>
      `;
      root.querySelector('#phRestart').addEventListener('click', () => renderPortHunter(root));
    }

    function render() {
      if (state.t <= 0) return endScreen();
      root.innerHTML = `
        <div class="ph-status">
          <div class="ph-stat">⏱️ <b id="phT">${state.t}</b>s</div>
          <div class="ph-stat ph-score">⭐ <b>${state.score}</b> Pkt</div>
          <div class="ph-stat ph-combo">🔥 Combo <b>x${state.combo}</b></div>
        </div>
        <div class="phh-q">
          <div class="phh-svc">${state.q.s}</div>
          <div class="phh-hint muted">${state.q.hint}</div>
        </div>
        <div class="phh-grid">
          ${state.opts.map(o => `<button class="phh-opt" data-p="${o.p}">${o.p}</button>`).join('')}
        </div>
      `;
      root.querySelectorAll('.phh-opt').forEach(b => {
        b.addEventListener('click', () => {
          if (state.answered) return;
          state.answered = true;
          const correct = parseInt(b.dataset.p, 10) === state.q.p;
          if (correct) {
            state.combo += 1;
            state.best = Math.max(state.best, state.combo);
            state.score += 10 + Math.max(0, state.combo - 1) * 3;
            b.classList.add('ok');
          } else {
            state.combo = 0;
            state.score = Math.max(0, state.score - 5);
            b.classList.add('bad');
            const right = root.querySelector(`.phh-opt[data-p="${state.q.p}"]`);
            if (right) right.classList.add('ok');
          }
          setTimeout(() => { nextQ(); render(); }, 600);
        });
      });
    }

    nextQ();
    render();
    if (state._t) clearInterval(state._t);
    state._t = setInterval(() => {
      state.t -= 1;
      const el = root.querySelector('#phT');
      if (el) el.textContent = state.t;
      if (state.t <= 0) { clearInterval(state._t); state._t = null; render(); }
    }, 1000);
  }

  /* ================================================================
     INFOSEC #4) MALWARE-MEMORY
     ================================================================ */
  function renderMalwareMatch(root) {
    const PAIRS = [
      { k: 'Virus',           v: 'Wirt nötig, infiziert Dateien' },
      { k: 'Wurm',            v: 'Eigenständig, verbreitet sich übers Netz' },
      { k: 'Trojaner',        v: 'Tarnt sich als nützliches Programm' },
      { k: 'Ransomware',      v: 'Verschlüsselt Daten gegen Lösegeld' },
      { k: 'Spyware',         v: 'Spioniert Nutzeraktivitäten aus' },
      { k: 'Rootkit',         v: 'Versteckt sich tief im System' },
      { k: 'Botnet/Zombie',   v: 'Vom C&C-Server ferngesteuert' },
      { k: 'Polymorpher Virus', v: 'Mutiert Code → umgeht Signaturen' },
    ];

    const cards = shuffle([
      ...PAIRS.map((p, i) => ({ id: 'k' + i, pair: i, type: 'k', text: p.k })),
      ...PAIRS.map((p, i) => ({ id: 'v' + i, pair: i, type: 'v', text: p.v })),
    ]);

    const state = { flipped: [], matched: new Set(), moves: 0, t0: Date.now() };

    function endScreen() {
      const sec = Math.round((Date.now() - state.t0) / 1000);
      const grade = state.moves <= PAIRS.length + 2 ? '🥇 Photographic Memory' :
                    state.moves <= PAIRS.length + 6 ? '🥈 Sehr gut' :
                    state.moves <= PAIRS.length + 12 ? '🥉 Geschafft' : '🐢 Geht noch besser';
      root.innerHTML = `
        <div class="ph-end">
          <div class="ph-end-grade">${grade}</div>
          <div class="ph-end-score">${state.moves} Versuche · ${sec}s</div>
          <button class="btn btn-primary" id="mmRestart">🔄 Neue Runde</button>
        </div>
      `;
      root.querySelector('#mmRestart').addEventListener('click', () => renderMalwareMatch(root));
    }

    function render() {
      if (state.matched.size === PAIRS.length) return endScreen();
      root.innerHTML = `
        <div class="ph-status">
          <div class="ph-stat">🔁 Versuche: <b>${state.moves}</b></div>
          <div class="ph-stat">🧩 ${state.matched.size} / ${PAIRS.length} Paare</div>
        </div>
        <div class="mm-grid">
          ${cards.map(c => {
            const isMatched = state.matched.has(c.pair);
            const isFlipped = state.flipped.includes(c.id) || isMatched;
            return `<button class="mm-card ${isFlipped ? 'flip' : ''} ${isMatched ? 'matched' : ''} mm-${c.type}" data-id="${c.id}">
              <div class="mm-front">?</div>
              <div class="mm-back">${escHtml(c.text)}</div>
            </button>`;
          }).join('')}
        </div>
      `;
      root.querySelectorAll('.mm-card').forEach(b => {
        b.addEventListener('click', () => {
          const c = cards.find(x => x.id === b.dataset.id);
          if (state.matched.has(c.pair)) return;
          if (state.flipped.includes(c.id)) return;
          if (state.flipped.length >= 2) return;
          state.flipped.push(c.id);
          if (state.flipped.length === 2) {
            state.moves += 1;
            const [a, bId] = state.flipped;
            const A = cards.find(x => x.id === a);
            const B = cards.find(x => x.id === bId);
            if (A.pair === B.pair && A.type !== B.type) {
              state.matched.add(A.pair);
              state.flipped = [];
              render();
            } else {
              render();
              setTimeout(() => { state.flipped = []; render(); }, 900);
              return;
            }
          }
          render();
        });
      });
    }

    render();
  }

  /* ================================================================
     INFOSEC #5) RSA-DOJO
     ================================================================ */
  function renderRSA(root) {
    const PRIMES = [3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47];
    const state = { p: 11, q: 13, e: 7, msg: 9 };

    function gcd(a, b) { return b === 0 ? a : gcd(b, a % b); }
    function modPow(b, e, m) {
      let r = 1n; b = BigInt(b) % BigInt(m); let ee = BigInt(e); const mm = BigInt(m);
      while (ee > 0n) { if (ee & 1n) r = (r * b) % mm; b = (b * b) % mm; ee >>= 1n; }
      return Number(r);
    }
    function eea(a, b) {
      let [old_r, r] = [a, b], [old_s, s] = [1, 0], [old_t, t] = [0, 1];
      while (r !== 0) {
        const q = Math.floor(old_r / r);
        [old_r, r] = [r, old_r - q * r];
        [old_s, s] = [s, old_s - q * s];
        [old_t, t] = [t, old_t - q * t];
      }
      return { gcd: old_r, x: old_s, y: old_t };
    }
    function modInverse(a, m) {
      const { gcd: g, x } = eea(a, m);
      if (g !== 1) return null;
      return ((x % m) + m) % m;
    }
    function validE(phi) {
      const out = [];
      for (let i = 3; i < phi; i += 2) if (gcd(i, phi) === 1) out.push(i);
      return out;
    }

    function render() {
      const n = state.p * state.q;
      const phi = (state.p - 1) * (state.q - 1);
      const eOpts = validE(phi).slice(0, 12);
      if (!eOpts.includes(state.e)) state.e = eOpts[0] || 3;
      const d = modInverse(state.e, phi);
      const ok = state.msg < n;
      const c = ok ? modPow(state.msg, state.e, n) : null;
      const mDecrypted = (ok && d != null) ? modPow(c, d, n) : '?';

      root.innerHTML = `
        <div class="rsa-grid">
          <div class="rsa-step">
            <div class="rsa-num">1</div>
            <div class="rsa-title">Wähle zwei Primzahlen p und q</div>
            <div class="rsa-row">
              <label>p
                <select id="rsaP">${PRIMES.map(x => `<option ${x === state.p ? 'selected' : ''}>${x}</option>`).join('')}</select>
              </label>
              <label>q
                <select id="rsaQ">${PRIMES.filter(x => x !== state.p).map(x => `<option ${x === state.q ? 'selected' : ''}>${x}</option>`).join('')}</select>
              </label>
            </div>
          </div>

          <div class="rsa-step">
            <div class="rsa-num">2</div>
            <div class="rsa-title">Berechne n = p · q und φ(n) = (p−1)(q−1)</div>
            <div class="rsa-eq">n = ${state.p} · ${state.q} = <b>${n}</b></div>
            <div class="rsa-eq">φ(n) = ${state.p - 1} · ${state.q - 1} = <b>${phi}</b></div>
          </div>

          <div class="rsa-step">
            <div class="rsa-num">3</div>
            <div class="rsa-title">Wähle e mit ggT(e, φ(n)) = 1</div>
            <div class="rsa-row">
              <label>e
                <select id="rsaE">${eOpts.map(x => `<option ${x === state.e ? 'selected' : ''}>${x}</option>`).join('')}</select>
              </label>
              <span class="muted">gültige Werte: {${eOpts.join(', ')}…}</span>
            </div>
          </div>

          <div class="rsa-step">
            <div class="rsa-num">4</div>
            <div class="rsa-title">Berechne d = e⁻¹ mod φ(n) (erweiterter Euklid)</div>
            <div class="rsa-eq">d = ${state.e}⁻¹ mod ${phi} = <b>${d ?? '—'}</b></div>
            <div class="rsa-keys">
              <div class="rsa-key rsa-pub">🔓 Public Key: (n=${n}, e=${state.e})</div>
              <div class="rsa-key rsa-priv">🔒 Private Key: (n=${n}, d=${d ?? '—'})</div>
            </div>
          </div>

          <div class="rsa-step">
            <div class="rsa-num">5</div>
            <div class="rsa-title">Verschlüssle eine Nachricht m &lt; n</div>
            <div class="rsa-row">
              <label>m <input type="number" id="rsaM" min="0" max="${n - 1}" value="${state.msg}" /></label>
              ${ok ? '' : '<span class="bad">⚠️ m muss kleiner als n sein</span>'}
            </div>
            <div class="rsa-eq">c = m^e mod n = ${state.msg}^${state.e} mod ${n} = <b>${ok ? c : '—'}</b></div>
            <div class="rsa-eq">m' = c^d mod n = ${ok ? c : '?'}^${d} mod ${n} = <b class="${mDecrypted === state.msg ? 'ok' : ''}">${mDecrypted}</b>
              ${mDecrypted === state.msg ? '✅' : ''}
            </div>
          </div>
        </div>
        <details class="game-help"><summary>📚 Theorie kompakt</summary>
          <ul>
            <li>Sicherheit beruht darauf, dass Faktorisierung von n = p·q für große p,q schwer ist.</li>
            <li>Eulersche Phi-Funktion: φ(p·q) = (p−1)(q−1).</li>
            <li>Es muss gelten: e · d ≡ 1 (mod φ(n)).</li>
            <li>Verschlüsseln: c = m^e mod n &nbsp;·&nbsp; Entschlüsseln: m = c^d mod n.</li>
          </ul>
        </details>
      `;
      const $ = s => root.querySelector(s);
      $('#rsaP').addEventListener('change', e => { state.p = parseInt(e.target.value, 10); if (state.q === state.p) state.q = PRIMES.find(x => x !== state.p); render(); });
      $('#rsaQ').addEventListener('change', e => { state.q = parseInt(e.target.value, 10); render(); });
      $('#rsaE').addEventListener('change', e => { state.e = parseInt(e.target.value, 10); render(); });
      $('#rsaM').addEventListener('input', e => { state.msg = Math.max(0, parseInt(e.target.value, 10) || 0); render(); });
    }

    render();
  }

  /* ================================================================
     INFOSEC #6) DIFFIE-HELLMAN-LAB
     ================================================================ */
  function renderDH(root) {
    const PRIMES = [23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73];
    const state = { p: 23, g: 5, xa: 6, xb: 15 };

    function modPow(b, e, m) {
      let r = 1n; b = BigInt(b) % BigInt(m); let ee = BigInt(e); const mm = BigInt(m);
      while (ee > 0n) { if (ee & 1n) r = (r * b) % mm; b = (b * b) % mm; ee >>= 1n; }
      return Number(r);
    }

    function render() {
      const pubA = modPow(state.g, state.xa, state.p);
      const pubB = modPow(state.g, state.xb, state.p);
      const sA = modPow(pubB, state.xa, state.p);
      const sB = modPow(pubA, state.xb, state.p);
      const ok = sA === sB;

      root.innerHTML = `
        <div class="dh-public">
          <div class="dh-pub-title">🌍 Öffentliche Parameter</div>
          <div class="dh-row">
            <label>Primzahl p
              <select id="dhP">${PRIMES.map(x => `<option ${x === state.p ? 'selected' : ''}>${x}</option>`).join('')}</select>
            </label>
            <label>primitive Wurzel g
              <input type="number" id="dhG" value="${state.g}" min="2" max="${state.p - 1}"/>
            </label>
          </div>
        </div>
        <div class="dh-grid">
          <div class="dh-party dh-alice">
            <div class="dh-party-title">👩‍💻 Alice</div>
            <label>Privat x_A <input type="number" id="dhXA" value="${state.xa}" min="2" max="${state.p - 2}"/></label>
            <div class="dh-eq">pub_A = g^x_A mod p = ${state.g}^${state.xa} mod ${state.p} = <b>${pubA}</b></div>
            <div class="dh-eq">Schlüssel = pub_B^x_A mod p = ${pubB}^${state.xa} mod ${state.p} = <b class="ok">${sA}</b></div>
          </div>
          <div class="dh-arrows">
            <div class="dh-arrow">→ pub_A = ${pubA} →</div>
            <div class="dh-arrow">← pub_B = ${pubB} ←</div>
            <div class="dh-shared ${ok ? 'ok' : 'bad'}">
              ${ok ? '🤝 Gemeinsamer Schlüssel: ' + sA : '⚠️ Schlüssel stimmen nicht überein'}
            </div>
          </div>
          <div class="dh-party dh-bob">
            <div class="dh-party-title">🧑‍💻 Bob</div>
            <label>Privat x_B <input type="number" id="dhXB" value="${state.xb}" min="2" max="${state.p - 2}"/></label>
            <div class="dh-eq">pub_B = g^x_B mod p = ${state.g}^${state.xb} mod ${state.p} = <b>${pubB}</b></div>
            <div class="dh-eq">Schlüssel = pub_A^x_B mod p = ${pubA}^${state.xb} mod ${state.p} = <b class="ok">${sB}</b></div>
          </div>
        </div>
        <details class="game-help"><summary>🦹 MITM-Szenario (Eve)</summary>
          <p>Wenn Eve sich zwischen Alice und Bob klemmt und beide pub-Keys abfängt, kann sie Alice einen eigenen pub_E und Bob ebenfalls einen eigenen pub_E' senden. Beide etablieren dann Schlüssel mit Eve – nicht miteinander!</p>
          <p><b>Schutz:</b> Authentifizierung der pub-Keys durch Zertifikate (PKI).</p>
        </details>
      `;
      const $ = s => root.querySelector(s);
      $('#dhP').addEventListener('change', e => { state.p = parseInt(e.target.value, 10); render(); });
      $('#dhG').addEventListener('change', e => { state.g = parseInt(e.target.value, 10) || 2; render(); });
      $('#dhXA').addEventListener('change', e => { state.xa = parseInt(e.target.value, 10) || 2; render(); });
      $('#dhXB').addEventListener('change', e => { state.xb = parseInt(e.target.value, 10) || 2; render(); });
    }

    render();
  }

  /* ================================================================
     INFOSEC #7) SQUARE & MULTIPLY
     ================================================================ */
  function renderSqM(root) {
    const state = { a: 7, n: 13, m: 23 };

    function steps(a, n, m) {
      const bin = n.toString(2);
      const out = [];
      let r = 1n;
      const A = BigInt(a), M = BigInt(m);
      for (let i = 0; i < bin.length; i++) {
        const before = r;
        r = (r * r) % M;
        out.push({ type: 'square', bit: bin[i], i, before: Number(before), after: Number(r) });
        if (bin[i] === '1') {
          const beforeM = r;
          r = (r * A) % M;
          out.push({ type: 'multiply', bit: bin[i], i, before: Number(beforeM), after: Number(r) });
        }
      }
      return { result: Number(r), bin, steps: out };
    }

    function render() {
      const { result, bin, steps: st } = steps(state.a, state.n, state.m);
      root.innerHTML = `
        <div class="game-controls">
          <label>Basis a <input type="number" id="sqA" value="${state.a}" min="1"/></label>
          <label>Exponent n <input type="number" id="sqN" value="${state.n}" min="0"/></label>
          <label>Modulus m <input type="number" id="sqM" value="${state.m}" min="2"/></label>
        </div>
        <div class="game-info">
          <span class="chip">n binär: <code>${bin}</code></span>
          <span class="chip">Bits: <b>${bin.length}</b></span>
          <span class="chip ok">Ergebnis: <b>${state.a}^${state.n} mod ${state.m} = ${result}</b></span>
        </div>
        <table class="sqm-table">
          <thead><tr><th>#</th><th>Bit</th><th>Operation</th><th>vorher</th><th>→</th><th>nachher</th></tr></thead>
          <tbody>
            ${st.map((s, idx) => `<tr class="${s.type}">
              <td>${idx + 1}</td>
              <td><code>${s.bit}</code></td>
              <td>${s.type === 'square' ? '² (square)' : '· a (multiply)'}</td>
              <td>${s.before}</td>
              <td>→</td>
              <td><b>${s.after}</b></td>
            </tr>`).join('')}
          </tbody>
        </table>
        <details class="game-help"><summary>📚 Idee von Square-and-Multiply</summary>
          <p>Statt n−1 Multiplikationen reicht eine Iteration über die Binärdarstellung von n: für jedes Bit <i>quadrieren</i>, und bei einer „1" zusätzlich mit a <i>multiplizieren</i>. Das macht modulare Exponentiation in O(log n) Operationen.</p>
        </details>
      `;
      const $ = s => root.querySelector(s);
      $('#sqA').addEventListener('change', e => { state.a = parseInt(e.target.value, 10) || 1; render(); });
      $('#sqN').addEventListener('change', e => { state.n = Math.max(0, parseInt(e.target.value, 10) || 0); render(); });
      $('#sqM').addEventListener('change', e => { state.m = Math.max(2, parseInt(e.target.value, 10) || 2); render(); });
    }

    render();
  }

  /* ================================================================
     INFOSEC #8) ECB vs. CBC – visueller Beweis
     ================================================================ */
  function renderEcbCbc(root) {
    const SHAPES = {
      'Smiley 🙂': [
        '..XXXXXX..',
        '.X......X.',
        'X..X..X..X',
        'X........X',
        'X.X....X.X',
        'X..XXXX..X',
        '.X......X.',
        '..XXXXXX..',
      ],
      'Herz ♥': [
        '.XX..XX.',
        'XXXXXXXX',
        'XXXXXXXX',
        'XXXXXXXX',
        '.XXXXXX.',
        '..XXXX..',
        '...XX...',
        '........',
      ],
      'Pfeil →': [
        '........',
        '....X...',
        '....XX..',
        'XXXXXXX.',
        'XXXXXXX.',
        '....XX..',
        '....X...',
        '........',
      ],
    };

    const state = { shape: 'Smiley 🙂', mode: 'ECB' };

    function hashBlock(s) {
      let h = 0x9e3779b1;
      for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 0x85ebca6b);
        h ^= h >>> 13;
      }
      h ^= h >>> 16;
      return ((h >>> 0).toString(16).padStart(8, '0')).slice(0, 6);
    }

    function encrypt(rows, mode) {
      const w = rows[0].length;
      const blockSize = 2;
      const blocks = [];
      let prev = 'IV';
      for (const row of rows) {
        const rowBlocks = [];
        for (let x = 0; x < w; x += blockSize) {
          const data = row.substr(x, blockSize);
          let key = data;
          if (mode === 'CBC') {
            let mixed = '';
            for (let i = 0; i < data.length; i++) {
              const a = data.charCodeAt(i);
              const b = (prev.charCodeAt(i % prev.length) || 0);
              mixed += String.fromCharCode(a ^ b);
            }
            key = mixed;
          }
          const h = hashBlock(key);
          rowBlocks.push(h);
          prev = h;
        }
        blocks.push(rowBlocks);
      }
      return blocks;
    }

    function render() {
      const rows = SHAPES[state.shape];
      const enc = encrypt(rows, state.mode);
      const cell = 18;
      const w = rows[0].length;
      const h = rows.length;

      root.innerHTML = `
        <div class="game-controls">
          <label>Klartext-Bild
            <select id="ecShape">${Object.keys(SHAPES).map(s => `<option ${s === state.shape ? 'selected' : ''}>${s}</option>`).join('')}</select>
          </label>
          <label>Modus
            <select id="ecMode">
              <option ${state.mode === 'ECB' ? 'selected' : ''}>ECB</option>
              <option ${state.mode === 'CBC' ? 'selected' : ''}>CBC</option>
            </select>
          </label>
        </div>

        <div class="ecb-side">
          <div>
            <div class="ecb-h">📝 Klartext</div>
            <svg viewBox="0 0 ${w * cell} ${h * cell}" class="ecb-svg">
              ${rows.map((row, y) => row.split('').map((c, x) =>
                `<rect x="${x * cell}" y="${y * cell}" width="${cell}" height="${cell}" fill="${c === 'X' ? '#0f172a' : '#f1f5f9'}" stroke="#e5e7eb"/>`
              ).join('')).join('')}
            </svg>
          </div>
          <div>
            <div class="ecb-h">🔒 Chiffretext (${state.mode})</div>
            <svg viewBox="0 0 ${w * cell} ${h * cell}" class="ecb-svg">
              ${enc.map((row, y) => row.map((hex, bx) =>
                [0, 1].map(off => `<rect x="${(bx * 2 + off) * cell}" y="${y * cell}" width="${cell}" height="${cell}" fill="#${hex}" stroke="rgba(0,0,0,.05)"/>`).join('')
              ).join('')).join('')}
            </svg>
          </div>
        </div>
        <div class="ecb-explain ${state.mode === 'ECB' ? 'bad' : 'ok'}">
          ${state.mode === 'ECB'
            ? '⚠️ <b>ECB:</b> gleiche Klartextblöcke ergeben gleiche Chiffretextblöcke → das Muster bleibt erkennbar (vgl. „ECB-Tux").'
            : '✅ <b>CBC:</b> jeder Block wird mit dem vorigen Chiffretext verXORt → identische Klartextblöcke werden zu unterschiedlichen Chiffretextblöcken. Das Muster verschwindet.'}
        </div>
        <details class="game-help"><summary>📚 ECB vs. CBC kompakt</summary>
          <ul>
            <li><b>ECB:</b> C_i = E_k(P_i) — schnell, aber undicht.</li>
            <li><b>CBC:</b> C_i = E_k(P_i ⊕ C_{i−1}) mit IV — Maskierung von Mustern, sequentiell.</li>
            <li>Heute Standard: <b>GCM</b> (Authenticated Encryption: Vertraulichkeit + Integrität).</li>
          </ul>
        </details>
      `;
      const $ = s => root.querySelector(s);
      $('#ecShape').addEventListener('change', e => { state.shape = e.target.value; render(); });
      $('#ecMode').addEventListener('change', e => { state.mode = e.target.value; render(); });
    }

    render();
  }

  // ====== InfoSec helpers (escaping) ======
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c])); }
  function escAttr(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
  /* ================================================================
     DATENBANKEN — Übungen (SQL · Normalformen · Attributhülle ·
     ER-Mapping · Konfliktgraph · Join-Kosten · 2PC)
     ================================================================ */

  function dbBadge(html, cls = 'chip') {
    return `<span class="db-badge ${cls}">${html}</span>`;
  }

  // ---------- 1) SQL-Werkstatt ----------
  function renderDbSql(root) {
    const TASKS = [
      {
        topic: 'SELECT · JOIN · GROUP BY · HAVING (Probeklausur Aufgabe 3a)',
        prompt: 'Gib für jeden <b>aktiven</b> Raum die Anzahl <b>aktiver</b> Arbeitsplätze und den Durchschnittspreis aus, aber nur Räume mit mindestens 3 aktiven Plätzen.',
        choices: [
`SELECT r.RaumID, COUNT(*), AVG(a.Tagespreis)
FROM RAUM r JOIN ARBEITSPLATZ a ON r.RaumID = a.RaumID
WHERE r.Aktiv = TRUE AND a.Aktiv = TRUE
GROUP BY r.RaumID
HAVING COUNT(*) >= 3;`,
`SELECT r.RaumID, COUNT(*), AVG(a.Tagespreis)
FROM RAUM r JOIN ARBEITSPLATZ a ON r.RaumID = a.RaumID
WHERE r.Aktiv = TRUE AND a.Aktiv = TRUE AND COUNT(*) >= 3
GROUP BY r.RaumID;`,
`SELECT r.RaumID, COUNT(*), AVG(a.Tagespreis)
FROM RAUM r LEFT JOIN ARBEITSPLATZ a ON r.RaumID = a.RaumID
GROUP BY r.RaumID
HAVING COUNT(*) >= 3;`,
        ],
        correct: 0,
        explain: 'WHERE filtert Zeilen <i>vor</i> der Aggregation, HAVING <i>nach</i> GROUP BY. COUNT(*) im WHERE ist syntaktisch unzulässig.',
      },
      {
        topic: 'LEFT JOIN + COUNT (Probeklausur Aufgabe 3c)',
        prompt: 'Liste <b>alle</b> Nutzer (auch ohne bestätigte Reservierung) zusammen mit ihrer Anzahl bestätigter Reservierungen.',
        choices: [
`SELECT n.NutzerID, n.Name, COUNT(res.ReservierungID)
FROM NUTZER n
LEFT JOIN RESERVIERUNG res
  ON n.NutzerID = res.NutzerID AND res.Status = 'BESTAETIGT'
GROUP BY n.NutzerID, n.Name;`,
`SELECT n.NutzerID, n.Name, COUNT(res.ReservierungID)
FROM NUTZER n
JOIN RESERVIERUNG res ON n.NutzerID = res.NutzerID
WHERE res.Status = 'BESTAETIGT'
GROUP BY n.NutzerID, n.Name;`,
`SELECT n.NutzerID, n.Name, COUNT(res.ReservierungID)
FROM NUTZER n
LEFT JOIN RESERVIERUNG res ON n.NutzerID = res.NutzerID
WHERE res.Status = 'BESTAETIGT'
GROUP BY n.NutzerID, n.Name;`,
        ],
        correct: 0,
        explain: 'Bedingung im ON statt im WHERE — sonst werden „leere" Nutzer durch das WHERE wieder herausgefiltert (LEFT JOIN entartet zu INNER JOIN).',
      },
      {
        topic: 'UPDATE mit Bedingung (Probeklausur Aufgabe 4c)',
        prompt: 'Setze für einen Nutzer (:nid) alle bestätigten Reservierungen, deren Beginn in der <b>Zukunft</b> liegt, auf STORNIERT.',
        choices: [
`UPDATE RESERVIERUNG
SET Status = 'STORNIERT'
WHERE NutzerID = :nid
  AND Status = 'BESTAETIGT'
  AND VonDatum > CURRENT_DATE;`,
`UPDATE RESERVIERUNG
SET Status = 'STORNIERT'
WHERE NutzerID = :nid OR VonDatum > CURRENT_DATE;`,
`DELETE FROM RESERVIERUNG
WHERE NutzerID = :nid AND VonDatum > CURRENT_DATE;`,
        ],
        correct: 0,
        explain: 'OR statt AND würde fremde Nutzer mitverändern; DELETE löscht statt zu stornieren — Historie geht verloren.',
      },
      {
        topic: 'DELETE vs. Inaktiv-Flag (Probeklausur Aufgabe 5)',
        prompt: 'Ein Raum soll außer Betrieb gehen, alte Reservierungen aber für Auswertungen erhalten bleiben. Welches Vorgehen ist fachlich korrekt?',
        choices: [
`UPDATE ARBEITSPLATZ SET Aktiv = FALSE WHERE RaumID = :rid;
UPDATE RAUM SET Aktiv = FALSE WHERE RaumID = :rid;`,
`DELETE FROM ARBEITSPLATZ WHERE RaumID = :rid;
DELETE FROM RAUM WHERE RaumID = :rid;`,
`DELETE FROM RAUM WHERE RaumID = :rid; -- ON DELETE CASCADE`,
        ],
        correct: 0,
        explain: 'Inaktiv-Flag bewahrt Historie. Physisches DELETE würde referenzierte Reservierungen brechen oder per CASCADE mitlöschen.',
      },
      {
        topic: 'INSERT-Syntax',
        prompt: 'Welche INSERT-Anweisung legt einen neuen Arbeitsplatz korrekt an?',
        choices: [
`INSERT INTO ARBEITSPLATZ (PlatzID, RaumID, PlatzCode, Typ, Tagespreis, Aktiv)
VALUES (9001, 12, 'W-12-07', 'FOCUS', 19.50, TRUE);`,
`INSERT ARBEITSPLATZ
SET PlatzID=9001, RaumID=12, PlatzCode='W-12-07';`,
`INSERT INTO ARBEITSPLATZ
VALUES PlatzID=9001, RaumID=12, PlatzCode='W-12-07', Typ='FOCUS';`,
        ],
        correct: 0,
        explain: 'Standard-SQL: INSERT INTO tabelle (spalten) VALUES (werte); die anderen Formen sind MySQL- bzw. ungültige Syntax.',
      },
      {
        topic: 'EXISTS vs. IN',
        prompt: 'Finde alle Nutzer, die mindestens eine bestätigte Reservierung haben.',
        choices: [
`SELECT n.* FROM NUTZER n
WHERE EXISTS (
  SELECT 1 FROM RESERVIERUNG r
  WHERE r.NutzerID = n.NutzerID AND r.Status = 'BESTAETIGT'
);`,
`SELECT n.* FROM NUTZER n
WHERE n.NutzerID IN (
  SELECT r.Status FROM RESERVIERUNG r WHERE r.Status = 'BESTAETIGT'
);`,
`SELECT n.* FROM NUTZER n, RESERVIERUNG r
WHERE n.NutzerID = r.NutzerID;`,
        ],
        correct: 0,
        explain: 'Variante 2 vergleicht NutzerID mit Status (Typfehler bzw. falsches Resultat). Variante 3 ignoriert die Statusbedingung und liefert Duplikate.',
      },
      {
        topic: 'GROUP BY-Korrektheit',
        prompt: 'Welche Abfrage ist gemäß SQL-Standard korrekt formuliert?',
        choices: [
`SELECT Typ, AVG(Tagespreis) FROM ARBEITSPLATZ GROUP BY Typ;`,
`SELECT PlatzID, Typ, AVG(Tagespreis) FROM ARBEITSPLATZ GROUP BY Typ;`,
`SELECT Typ, AVG(Tagespreis) FROM ARBEITSPLATZ;`,
        ],
        correct: 0,
        explain: 'Im SELECT dürfen nur GROUP-BY-Spalten oder Aggregate stehen. Variante 2 enthält PlatzID ohne Aggregat; Variante 3 hat ein Aggregat ohne GROUP BY (mehrere Typen).',
      },
    ];

    const state = { i: 0, score: 0, total: 0, picked: null };

    function render() {
      const t = TASKS[state.i];
      root.innerHTML = `
        <div class="game-info">
          ${dbBadge('Aufgabe ' + (state.i + 1) + ' / ' + TASKS.length)}
          ${dbBadge('Score ' + state.score + ' / ' + state.total, 'good')}
        </div>
        <div class="db-card">
          <div class="db-kicker">${t.topic}</div>
          <div class="db-card-title" style="font-weight:700;">${t.prompt}</div>
          <div class="db-choices">
            ${t.choices.map((c, idx) => `
              <button class="db-choice" data-i="${idx}"><pre>${escHtml(c)}</pre></button>
            `).join('')}
          </div>
          <div class="db-feedback" id="dbsqlFb"></div>
        </div>
        <div class="game-actions">
          <button class="btn btn-secondary" id="dbsqlNext">Nächste Aufgabe →</button>
        </div>
        <details class="game-help"><summary>📚 SQL-Spickzettel</summary>
          <ul>
            <li><b>WHERE</b> filtert Zeilen vor GROUP BY, <b>HAVING</b> nach GROUP BY (nur Aggregate / Group-Spalten).</li>
            <li><b>LEFT JOIN</b>: Filter auf rechter Tabelle gehören in <code>ON</code>, sonst entartet er zu INNER JOIN.</li>
            <li>UPDATE/DELETE immer mit präziser <code>WHERE</code>-Klausel (sonst trifft es alles!).</li>
            <li>Soft-Delete (Inaktiv-Flag) bewahrt Historie und vermeidet kaskadierende Verluste.</li>
            <li><code>EXISTS</code> prüft Existenz, <code>IN</code> vergleicht Werte — typisch korrelierte vs. unkorrelierte Subquery.</li>
          </ul>
        </details>
      `;
      const $ = s => root.querySelector(s);
      root.querySelectorAll('.db-choice').forEach(b => {
        b.addEventListener('click', () => {
          if (state.picked !== null) return;
          const i = parseInt(b.dataset.i, 10);
          state.picked = i;
          state.total += 1;
          const ok = i === t.correct;
          if (ok) state.score += 1;
          root.querySelectorAll('.db-choice').forEach((btn, idx) => {
            if (idx === t.correct) btn.classList.add('ok');
            else if (idx === i) btn.classList.add('bad');
            btn.disabled = true;
          });
          $('#dbsqlFb').innerHTML = (ok ? '✅ Richtig! ' : '❌ Falsch. ') + t.explain;
        });
      });
      $('#dbsqlNext').addEventListener('click', () => {
        state.i = (state.i + 1) % TASKS.length;
        state.picked = null;
        render();
      });
    }
    render();
  }

  // ---------- 2) Normalform-Detektor ----------
  function renderDbNF(root) {
    const TASKS = [
      {
        rel: 'KURS(KursID, KursName, DozentID, DozentName)',
        fds: ['KursID → KursName, DozentID', 'DozentID → DozentName'],
        keys: ['KursID'],
        nf: '2NF',
        why: '1NF und 2NF erfüllt (Schlüssel ist einfach). Aber: KursID → DozentID → DozentName ist eine <b>transitive</b> Abhängigkeit eines Nicht-Primattributs → 3NF verletzt.',
      },
      {
        rel: 'BESTELLUNG(BestNr, ArtikelNr, Menge, ArtikelName)',
        fds: ['BestNr, ArtikelNr → Menge', 'ArtikelNr → ArtikelName'],
        keys: ['(BestNr, ArtikelNr)'],
        nf: '1NF',
        why: 'ArtikelName hängt nur von einem Teil des Schlüssels (ArtikelNr) ab → <b>partielle</b> Abhängigkeit, also nicht in 2NF.',
      },
      {
        rel: 'MITARBEITER(PersNr, Name, Abteilung, Projekt)',
        fds: ['PersNr → Name, Abteilung'],
        keys: ['(PersNr, Projekt)'],
        nf: '1NF',
        why: 'Name/Abteilung hängen nur von einem Teil des Schlüssels (PersNr) ab → 2NF verletzt.',
      },
      {
        rel: 'ARTIKEL(ArtNr, Bezeichnung, Preis)',
        fds: ['ArtNr → Bezeichnung, Preis'],
        keys: ['ArtNr'],
        nf: 'BCNF',
        why: 'Einfacher Schlüssel, einzige FD hat den Superschlüssel als linke Seite → BCNF (und damit 3NF, 2NF, 1NF).',
      },
      {
        rel: 'PROJEKT_MA(ProjID, MaID, MaName)',
        fds: ['MaID → MaName'],
        keys: ['(ProjID, MaID)'],
        nf: '1NF',
        why: 'MaName hängt nur von MaID (Teil des Schlüssels) ab → partielle Abhängigkeit → 2NF verletzt.',
      },
      {
        rel: 'TERMIN(Datum, Raum, Zeit, Dozent)',
        fds: ['Datum, Raum, Zeit → Dozent', 'Datum, Dozent, Zeit → Raum'],
        keys: ['(Datum, Raum, Zeit)', '(Datum, Dozent, Zeit)'],
        nf: 'BCNF',
        why: 'Beide FD-Linksseiten sind Schlüsselkandidaten und damit Superschlüssel — somit BCNF (und 3NF / 2NF / 1NF).',
      },
    ];

    const NFS = ['1NF', '2NF', '3NF', 'BCNF'];
    const state = { i: 0, score: 0, total: 0, picked: null };

    function render() {
      const t = TASKS[state.i];
      root.innerHTML = `
        <div class="game-info">
          ${dbBadge('Aufgabe ' + (state.i + 1) + ' / ' + TASKS.length)}
          ${dbBadge('Score ' + state.score + ' / ' + state.total, 'good')}
        </div>
        <div class="db-card">
          <div class="db-kicker">Höchste erfüllte Normalform?</div>
          <div class="db-mono">${escHtml(t.rel)}</div>
          <div style="margin-top:.5rem"><b>FDs:</b><ul class="db-list">${t.fds.map(f => `<li><code>${escHtml(f)}</code></li>`).join('')}</ul></div>
          <div><b>Schlüsselkandidat(en):</b> ${t.keys.map(k => `<code>${escHtml(k)}</code>`).join(', ')}</div>
          <div class="db-choices row">
            ${NFS.map(n => `<button class="db-choice pill" data-nf="${n}">${n}</button>`).join('')}
          </div>
          <div class="db-feedback" id="dbnfFb"></div>
        </div>
        <div class="game-actions">
          <button class="btn btn-secondary" id="dbnfNext">Nächste Aufgabe →</button>
        </div>
        <details class="game-help"><summary>📚 Normalformen-Schnellcheck</summary>
          <ol>
            <li><b>1NF</b>: nur atomare Werte.</li>
            <li><b>2NF</b>: 1NF + jedes Nicht-Primattribut <i>voll</i> abhängig vom <i>ganzen</i> Schlüssel (kein Teilschlüssel).</li>
            <li><b>3NF</b>: 2NF + keine transitive Abhängigkeit eines Nicht-Primattributs (Nichtschlüssel → Nichtschlüssel).</li>
            <li><b>BCNF</b>: für jede nicht-triviale FD α → β ist α Superschlüssel.</li>
          </ol>
        </details>
      `;
      const $ = s => root.querySelector(s);
      root.querySelectorAll('.db-choice').forEach(b => {
        b.addEventListener('click', () => {
          if (state.picked !== null) return;
          const pick = b.dataset.nf;
          state.picked = pick;
          state.total += 1;
          const ok = pick === t.nf;
          if (ok) state.score += 1;
          root.querySelectorAll('.db-choice').forEach(btn => {
            const v = btn.dataset.nf;
            if (v === t.nf) btn.classList.add('ok');
            else if (v === pick) btn.classList.add('bad');
            btn.disabled = true;
          });
          $('#dbnfFb').innerHTML = (ok ? '✅ Richtig! ' : `❌ Korrekt wäre <b>${t.nf}</b>. `) + t.why;
        });
      });
      $('#dbnfNext').addEventListener('click', () => {
        state.i = (state.i + 1) % TASKS.length;
        state.picked = null;
        render();
      });
    }
    render();
  }

  // ---------- 3) Attributhülle α⁺ ----------
  function renderDbClosure(root) {
    const PRESETS = [
      { name: 'Beispiel 1', attrs: ['A','B','C','D','E'], fds: [['A','B'],['B','C'],['C,D','E'],['A','D']], start: ['A'] },
      { name: 'Beispiel 2', attrs: ['A','B','C','D','E','F'], fds: [['A,B','C'],['C','D'],['D','E'],['E','F']], start: ['A','B'] },
      { name: 'Probe (Workshop)', attrs: ['TerminID','TeilnehmerID','TarifCode','Anmeldedatum','TarifPreis','TerminDatum','WorkshopID'],
        fds: [['TerminID','TerminDatum,WorkshopID'],['TerminID,TeilnehmerID','Anmeldedatum,TarifCode'],['TarifCode','TarifPreis']],
        start: ['TerminID','TeilnehmerID'] },
    ];

    const state = { preset: 0, closure: new Set(), steps: [] };

    function reset() {
      const p = PRESETS[state.preset];
      state.closure = new Set(p.start);
      state.steps = [{ added: [...p.start], reason: 'Start (gegeben)' }];
      render();
    }

    function applicable() {
      const p = PRESETS[state.preset];
      const out = [];
      for (const [lhs, rhs] of p.fds) {
        const L = lhs.split(',').map(s => s.trim());
        const R = rhs.split(',').map(s => s.trim());
        const lhsIn = L.every(a => state.closure.has(a));
        const rhsNew = R.filter(a => !state.closure.has(a));
        if (lhsIn && rhsNew.length) out.push({ L, R, rhsNew, fd: `${L.join(',')} → ${R.join(',')}` });
      }
      return out;
    }

    function apply(idx) {
      const opts = applicable();
      const op = opts[idx];
      if (!op) return;
      op.rhsNew.forEach(a => state.closure.add(a));
      state.steps.push({ added: op.rhsNew, reason: `via FD ${op.fd}` });
      render();
    }

    function render() {
      const p = PRESETS[state.preset];
      const opts = applicable();
      const done = opts.length === 0;
      root.innerHTML = `
        <div class="game-controls">
          <label>Beispiel
            <select id="dbcPreset">${PRESETS.map((x, i) => `<option value="${i}" ${i===state.preset?'selected':''}>${x.name}</option>`).join('')}</select>
          </label>
          <button class="btn btn-primary" id="dbcReset">▶ Neu</button>
        </div>
        <div class="db-card">
          <div class="db-kicker">FDs</div>
          <ul class="db-list">${p.fds.map(([l,r]) => `<li><code>${l} → ${r}</code></li>`).join('')}</ul>
          <div class="db-kicker">Berechne {${p.start.join(',')}}⁺</div>
          <div class="db-mono">α⁺ = { ${[...state.closure].join(', ')} }</div>
        </div>
        <div class="db-card">
          <div class="db-kicker">Welche FD anwenden?</div>
          ${done
            ? `<div class="db-feedback ok">✅ Hülle vollständig — keine FD mehr anwendbar.<br><b>Ergebnis:</b> { ${[...state.closure].join(', ')} } (${state.closure.size === p.attrs.length ? 'Superschlüssel — alle Attribute ableitbar!' : 'kein Superschlüssel'})</div>`
            : `<div class="db-choices">${opts.map((o, i) => `<button class="db-choice" data-i="${i}"><b>${o.fd}</b><br><span class="muted">fügt hinzu: { ${o.rhsNew.join(', ')} }</span></button>`).join('')}</div>`
          }
        </div>
        <div class="db-card">
          <div class="db-kicker">Berechnungsverlauf</div>
          <ol class="db-list">${state.steps.map(s => `<li>+ { ${s.added.join(', ')} } <span class="muted">— ${s.reason}</span></li>`).join('')}</ol>
        </div>
        <details class="game-help"><summary>📚 Algorithmus</summary>
          <ol>
            <li>Starte mit α⁺ := α.</li>
            <li>Solange eine FD <code>L → R</code> existiert mit L ⊆ α⁺ und R ⊄ α⁺: füge R zu α⁺ hinzu.</li>
            <li>Wenn keine solche FD mehr existiert, ist α⁺ minimal vollständig.</li>
            <li>Ist α⁺ = alle Attribute, ist α ein <b>Superschlüssel</b>.</li>
          </ol>
        </details>
      `;
      const $ = s => root.querySelector(s);
      $('#dbcPreset').addEventListener('change', e => { state.preset = parseInt(e.target.value, 10); reset(); });
      $('#dbcReset').addEventListener('click', reset);
      root.querySelectorAll('.db-choice').forEach(b => b.addEventListener('click', () => apply(parseInt(b.dataset.i, 10))));
    }
    reset();
  }

  // ---------- 4) ER → Relationenmodell ----------
  function renderDbErd(root) {
    const TASKS = [
      {
        q: '<b>1:N</b>-Beziehung „ABTEILUNG (1) — beschäftigt — (N) MITARBEITER" mit Attributen ABT(AbtID PK, Name) und MA(MaID PK, Name). Wie überführen?',
        choices: [
          'Fremdschlüssel <code>AbtID</code> in MITARBEITER aufnehmen (auf der N-Seite).',
          'Fremdschlüssel <code>MaID</code> in ABTEILUNG aufnehmen (auf der 1-Seite).',
          'Eigene Beziehungstabelle BESCHAEFTIGT(AbtID, MaID) erstellen.',
        ],
        correct: 0,
        explain: 'Bei 1:N steht der Fremdschlüssel immer auf der N-Seite — eine eigene Tabelle wäre nur bei M:N nötig.',
      },
      {
        q: '<b>M:N</b>-Beziehung „STUDENT belegt KURS" mit zusätzlichem Attribut „Note". Wie modellieren?',
        choices: [
          'Eigene Beziehungstabelle BELEGT(MatrNr FK, KursID FK, Note, PK(MatrNr, KursID)).',
          'Note in STUDENT als Wiederholungsgruppe.',
          'Fremdschlüssel KursID in STUDENT.',
        ],
        correct: 0,
        explain: 'M:N erfordert immer eine eigene Beziehungstabelle (associative entity). Beziehungsattribute (Note) wandern dorthin.',
      },
      {
        q: '<b>Schwache Entität</b>: ZIMMER ist existenzabhängig von HOTEL. Wie modellieren?',
        choices: [
          'ZIMMER(HotelID FK, ZimmerNr, …, PK(HotelID, ZimmerNr)) — Schlüssel des starken Typs erbt.',
          'ZIMMER(ZimmerID PK, …, HotelID FK).',
          'Spezialisierung HOTEL → ZIMMER (IS-A).',
        ],
        correct: 0,
        explain: 'Schwache Entitäten haben keinen eigenen Schlüssel; ihr Primärschlüssel kombiniert den Schlüssel des starken Typs mit einem Diskriminator.',
      },
      {
        q: '<b>1:1</b>-Beziehung „MITARBEITER (1) — leitet — (0..1) ABTEILUNG", jede Abteilung hat genau einen Leiter. Wo Fremdschlüssel?',
        choices: [
          'In ABTEILUNG: <code>LeiterMaID</code> (auf der Seite mit Pflichtteilnahme).',
          'In MITARBEITER: <code>LeitetAbtID</code> (auf der optionalen Seite).',
          'Eigene Tabelle LEITET(MaID, AbtID).',
        ],
        correct: 0,
        explain: 'Bei 1:1 mit einer Pflicht- und einer optionalen Seite legt man den FK auf die Pflichtseite (jede Abteilung hat zwingend einen Leiter).',
      },
      {
        q: '<b>Spezialisierung</b> PERSON → {STUDENT, MITARBEITER}, disjunkt + total. Welcher Mapping-Stil ist bei vielen gemeinsamen Attributen meist sinnvoll?',
        choices: [
          'Eine Tabelle PERSON mit allen Attributen + Diskriminator (Single Table).',
          'Eine Tabelle pro Subklasse <i>ohne</i> PERSON (Class Table).',
          'Drei Tabellen mit jeweils <i>kompletten</i> Attributen, ohne Beziehung.',
        ],
        correct: 0,
        explain: 'Single-Table eignet sich, wenn viele Attribute gemeinsam sind — kein JOIN nötig. „Drei unabhängige Tabellen" zerstört Identität.',
      },
    ];

    const state = { i: 0, score: 0, total: 0, picked: null };
    function render() {
      const t = TASKS[state.i];
      root.innerHTML = `
        <div class="game-info">
          ${dbBadge('Aufgabe ' + (state.i + 1) + ' / ' + TASKS.length)}
          ${dbBadge('Score ' + state.score + ' / ' + state.total, 'good')}
        </div>
        <div class="db-card">
          <div class="db-kicker">ER → Relation</div>
          <div>${t.q}</div>
          <div class="db-choices">
            ${t.choices.map((c, idx) => `<button class="db-choice" data-i="${idx}">${c}</button>`).join('')}
          </div>
          <div class="db-feedback" id="dbeFb"></div>
        </div>
        <div class="game-actions">
          <button class="btn btn-secondary" id="dbeNext">Nächste Aufgabe →</button>
        </div>
        <details class="game-help"><summary>📚 Mapping-Regeln</summary>
          <ul>
            <li><b>1:1</b> → FK auf der Pflichtseite (oder Tabellen verschmelzen).</li>
            <li><b>1:N</b> → FK auf der N-Seite.</li>
            <li><b>M:N</b> → eigene Beziehungstabelle mit zusammengesetztem PK.</li>
            <li><b>Schwache Entität</b> → erbt Schlüssel der starken Entität.</li>
            <li><b>IS-A</b> → Single Table, Class-per-Subclass oder Tabelle pro Klasse mit FKs.</li>
          </ul>
        </details>
      `;
      const $ = s => root.querySelector(s);
      root.querySelectorAll('.db-choice').forEach(b => {
        b.addEventListener('click', () => {
          if (state.picked !== null) return;
          const i = parseInt(b.dataset.i, 10);
          state.picked = i;
          state.total += 1;
          const ok = i === t.correct;
          if (ok) state.score += 1;
          root.querySelectorAll('.db-choice').forEach((btn, idx) => {
            if (idx === t.correct) btn.classList.add('ok');
            else if (idx === i) btn.classList.add('bad');
            btn.disabled = true;
          });
          $('#dbeFb').innerHTML = (ok ? '✅ Richtig! ' : '❌ ') + t.explain;
        });
      });
      $('#dbeNext').addEventListener('click', () => { state.i = (state.i + 1) % TASKS.length; state.picked = null; render(); });
    }
    render();
  }

  // ---------- 5) Konfliktgraph & Serialisierbarkeit ----------
  function renderDbSerial(root) {
    const PRESETS = [
      { name: 'Klassisch (zyklisch)',   ops: 'r1(x); w2(x); w1(y); r2(y)' },
      { name: 'Lost Update',            ops: 'r1(x); r2(x); w1(x); w2(x)' },
      { name: 'Drei TX, azyklisch',     ops: 'r1(x); w2(x); r3(x); w1(y); r2(y); w3(z)' },
      { name: 'Reihenfolge T1 → T2',    ops: 'r1(x); w1(x); r2(x); w2(y)' },
    ];
    const state = { input: PRESETS[0].ops };

    function parse(text) {
      const re = /([rw])\s*(\d+)\s*\(\s*([A-Za-z0-9_]+)\s*\)/g;
      const ops = [];
      let m;
      while ((m = re.exec(text))) {
        ops.push({ op: m[1], t: parseInt(m[2], 10), x: m[3] });
      }
      return ops;
    }

    function buildGraph(ops) {
      const txs = [...new Set(ops.map(o => o.t))].sort((a, b) => a - b);
      const edges = new Set();
      for (let i = 0; i < ops.length; i++) {
        for (let j = i + 1; j < ops.length; j++) {
          const a = ops[i], b = ops[j];
          if (a.t === b.t || a.x !== b.x) continue;
          if (a.op === 'r' && b.op === 'r') continue;
          edges.add(a.t + '->' + b.t);
        }
      }
      return { txs, edges: [...edges].map(e => e.split('->').map(Number)) };
    }

    function findCycle(txs, edges) {
      const adj = {};
      txs.forEach(t => { adj[t] = []; });
      edges.forEach(([u, v]) => adj[u].push(v));
      const WHITE = 0, GRAY = 1, BLACK = 2;
      const color = {};
      txs.forEach(t => { color[t] = WHITE; });
      let cycle = null;
      function dfs(u, stack) {
        color[u] = GRAY;
        stack.push(u);
        for (const v of adj[u]) {
          if (color[v] === GRAY) {
            const idx = stack.indexOf(v);
            cycle = stack.slice(idx).concat(v);
            return true;
          }
          if (color[v] === WHITE && dfs(v, stack)) return true;
        }
        stack.pop();
        color[u] = BLACK;
        return false;
      }
      for (const t of txs) if (color[t] === WHITE && dfs(t, [])) break;
      return cycle;
    }

    function topo(txs, edges) {
      const adj = {}, indeg = {};
      txs.forEach(t => { adj[t] = []; indeg[t] = 0; });
      edges.forEach(([u, v]) => { adj[u].push(v); indeg[v] = (indeg[v] || 0) + 1; });
      const q = txs.filter(t => indeg[t] === 0).sort((a, b) => a - b);
      const out = [];
      while (q.length) {
        const u = q.shift();
        out.push(u);
        for (const v of adj[u]) { indeg[v] -= 1; if (indeg[v] === 0) q.push(v); }
      }
      return out;
    }

    function render() {
      const ops = parse(state.input);
      const { txs, edges } = buildGraph(ops);
      const cycle = findCycle(txs, edges);
      const order = !cycle ? topo(txs, edges) : null;

      root.innerHTML = `
        <div class="game-controls">
          <label style="flex:1; min-width:18rem;">Schedule
            <input id="dbsInput" class="input" value="${escAttr(state.input)}" />
          </label>
          <label>Beispiel
            <select id="dbsPreset">${PRESETS.map((p, i) => `<option value="${i}">${p.name}</option>`).join('')}</select>
          </label>
          <button class="btn btn-primary" id="dbsRun">▶ Analysieren</button>
        </div>
        <div class="db-card">
          <div class="db-kicker">Erkannte Operationen</div>
          <div class="db-mono">${ops.map(o => `${o.op}<sub>${o.t}</sub>(${o.x})`).join(' · ') || '<i class="muted">keine</i>'}</div>
        </div>
        <div class="db-card">
          <div class="db-kicker">Konfliktkanten</div>
          ${edges.length
            ? `<ul class="db-list">${edges.map(([u, v]) => `<li><b>T${u} → T${v}</b></li>`).join('')}</ul>`
            : `<div class="muted">Keine Konflikte (jede Operation entweder gleiche TX oder nur Lesezugriffe auf verschiedene Objekte).</div>`}
        </div>
        <div class="db-card">
          ${cycle
            ? `<div class="db-feedback bad">❌ <b>Nicht konfliktserialisierbar.</b> Zyklus: ${cycle.map(t => 'T' + t).join(' → ')}</div>`
            : `<div class="db-feedback ok">✅ <b>Konfliktserialisierbar.</b> Eine äquivalente serielle Reihenfolge: ${order.map(t => 'T' + t).join(' → ')}</div>`}
        </div>
        <details class="game-help"><summary>📚 Konfliktgraph</summary>
          <ul>
            <li><b>Konflikt</b>: zwei Operationen verschiedener Transaktionen auf demselben Objekt, mindestens eine schreibt.</li>
            <li>Kante <code>T<sub>i</sub> → T<sub>j</sub></code>, wenn Op von T<sub>i</sub> <i>vor</i> einer konfliktären Op von T<sub>j</sub> erfolgt.</li>
            <li><b>Zyklenfrei ⇔ konfliktserialisierbar.</b> Eine topologische Sortierung liefert eine äquivalente serielle Ausführung.</li>
            <li>Notation: <code>r1(x)</code> = T1 liest x; trennen mit <code>;</code> oder Komma.</li>
          </ul>
        </details>
      `;
      const $ = s => root.querySelector(s);
      $('#dbsRun').addEventListener('click', () => { state.input = $('#dbsInput').value; render(); });
      $('#dbsInput').addEventListener('keydown', e => { if (e.key === 'Enter') { state.input = e.target.value; render(); } });
      $('#dbsPreset').addEventListener('change', e => { state.input = PRESETS[parseInt(e.target.value, 10)].ops; render(); });
    }
    render();
  }

  // ---------- 6) Join-Cost-Rechner ----------
  function renderDbJoinCost(root) {
    const state = { NR: 1000, NS: 500, B: 10 };

    function compute() {
      const NR = Math.max(1, state.NR | 0);
      const NS = Math.max(1, state.NS | 0);
      const B  = Math.max(3, state.B | 0);
      const nl  = NR + NR * NS;
      const bnl = NR + Math.ceil(NR / (B - 2)) * NS;
      function sortCost(N) {
        if (N <= B) return 2 * N;
        const passes = 1 + Math.ceil(Math.log(N / B) / Math.log(B - 1));
        return 2 * N * passes;
      }
      const sm  = sortCost(NR) + sortCost(NS) + NR + NS;
      const hj  = 3 * (NR + NS);
      const inl = NR + NR * 3;
      const ranked = [
        { name: 'Nested-Loops (tuple)',             cost: nl,  hint: 'N_R + N_R · N_S' },
        { name: 'Block-Nested-Loops',               cost: bnl, hint: 'N_R + ⌈N_R/(B−2)⌉ · N_S' },
        { name: 'Index-Nested-Loops (S indiziert)', cost: inl, hint: 'N_R + N_R · 3' },
        { name: 'Sort-Merge-Join',                  cost: sm,  hint: '2·sort(N_R) + 2·sort(N_S) + N_R + N_S' },
        { name: 'Hash-Join (Equi-Join)',            cost: hj,  hint: '3·(N_R + N_S)' },
      ].sort((a, b) => a.cost - b.cost);
      return ranked;
    }

    function render() {
      const r = compute();
      const best = r[0];
      root.innerHTML = `
        <div class="game-controls">
          <label>|R| (Seiten) <input type="number" id="jcNR" value="${state.NR}" min="1"></label>
          <label>|S| (Seiten) <input type="number" id="jcNS" value="${state.NS}" min="1"></label>
          <label>B (Pufferseiten) <input type="number" id="jcB" value="${state.B}" min="3"></label>
        </div>
        <div class="db-card">
          <div class="db-kicker">Geschätzte I/O-Kosten (sortiert)</div>
          <table class="db-table">
            <thead><tr><th>Algorithmus</th><th>Kosten</th><th>Formel</th></tr></thead>
            <tbody>
              ${r.map((x, i) => `<tr class="${i === 0 ? 'best' : ''}"><td>${i === 0 ? '🏆 ' : ''}${x.name}</td><td>${x.cost.toLocaleString('de-DE')}</td><td><code>${x.hint}</code></td></tr>`).join('')}
            </tbody>
          </table>
          <div class="db-feedback ok">Empfehlung bei diesen Parametern: <b>${best.name}</b> mit ca. <b>${best.cost.toLocaleString('de-DE')}</b> I/Os.</div>
        </div>
        <details class="game-help"><summary>📚 Faustregeln</summary>
          <ul>
            <li><b>Block-NL</b> schlägt naives NL massiv, sobald B groß genug ist.</li>
            <li><b>Hash-Join</b> dominiert bei Gleichheits-Joins großer Relationen, ~3·(N_R+N_S).</li>
            <li><b>Sort-Merge</b> lohnt sich, wenn Eingabe schon sortiert ist oder Bereichsanfragen folgen.</li>
            <li><b>Index-NL</b> ist Topwahl, wenn die innere Relation einen passenden Index besitzt und R klein ist.</li>
          </ul>
        </details>
      `;
      const $ = s => root.querySelector(s);
      ['jcNR','jcNS','jcB'].forEach(id => $('#' + id).addEventListener('input', e => {
        if (id === 'jcNR') state.NR = +e.target.value;
        if (id === 'jcNS') state.NS = +e.target.value;
        if (id === 'jcB')  state.B  = +e.target.value;
        render();
      }));
    }
    render();
  }

  // ---------- 7) 2PC-Simulator ----------
  function renderDb2PC(root) {
    function freshState() {
      return {
        agents: [
          { id: 'A', state: 'IDLE', vote: null },
          { id: 'B', state: 'IDLE', vote: null },
          { id: 'C', state: 'IDLE', vote: null },
        ],
        coord: 'IDLE',
        log: ['Koordinator und 3 Agenten bereit.'],
        decided: null,
        phase: 0,
      };
    }
    let state = freshState();

    function sendPrepare() {
      if (state.phase !== 0) return;
      state.coord = 'WAIT';
      state.agents.forEach(a => { a.state = 'PREPARED?'; });
      state.log.push('Koordinator → alle Agenten: PREPARE');
      state.phase = 1;
      render();
    }

    function vote(id, v) {
      if (state.phase !== 1) return;
      const a = state.agents.find(x => x.id === id);
      if (!a || a.vote !== null) return;
      a.vote = v;
      a.state = v === 'READY' ? 'READY' : 'FAILED';
      state.log.push(`Agent ${id} → Koordinator: ${v}` + (v === 'READY' ? ' (lokales Log persistent)' : ' (Abort)'));
      if (state.agents.every(x => x.vote !== null)) {
        const allReady = state.agents.every(x => x.vote === 'READY');
        state.decided = allReady ? 'COMMIT' : 'ABORT';
        state.coord = 'DECIDED:' + state.decided;
        state.log.push(`Koordinator entscheidet: <b>${state.decided}</b> (${allReady ? 'alle READY' : 'mind. ein FAILED'})`);
        state.agents.forEach(a => { a.state = state.decided; });
        state.log.push(`Koordinator → alle Agenten: ${state.decided}; Agenten antworten ACK.`);
        state.phase = 3;
      }
      render();
    }

    function reset() { state = freshState(); render(); }

    function render() {
      root.innerHTML = `
        <div class="game-controls">
          <button class="btn btn-primary" id="tpcPrep" ${state.phase !== 0 ? 'disabled' : ''}>① PREPARE senden</button>
          <button class="btn btn-secondary" id="tpcReset">⟲ Neu starten</button>
        </div>
        <div class="db-card">
          <div class="db-kicker">Koordinator</div>
          <div class="db-mono">Status: <b>${state.coord}</b>${state.decided ? ' · Entscheidung: <b>' + state.decided + '</b>' : ''}</div>
        </div>
        <div class="db-2pc-grid">
          ${state.agents.map(a => `
            <div class="db-card">
              <div class="db-kicker">Agent ${a.id}</div>
              <div class="db-mono">Status: <b>${a.state}</b></div>
              <div class="game-actions">
                <button class="btn btn-secondary db-vote" data-id="${a.id}" data-v="READY"  ${state.phase !== 1 || a.vote ? 'disabled' : ''}>READY ✓</button>
                <button class="btn btn-secondary db-vote" data-id="${a.id}" data-v="FAILED" ${state.phase !== 1 || a.vote ? 'disabled' : ''}>FAILED ✗</button>
              </div>
            </div>
          `).join('')}
        </div>
        <div class="db-card">
          <div class="db-kicker">Protokoll</div>
          <ol class="db-list">${state.log.map(l => `<li>${l}</li>`).join('')}</ol>
        </div>
        <details class="game-help"><summary>📚 Two-Phase-Commit</summary>
          <ol>
            <li><b>Phase 1 (Voting):</b> Koordinator sendet PREPARE. Jeder Agent persistiert das Log und antwortet READY oder FAILED.</li>
            <li><b>Phase 2 (Decision):</b> Nur wenn <i>alle</i> READY → COMMIT, sonst ABORT. Entscheidung wird im Log fixiert und an alle Agenten gesendet.</li>
            <li>Agenten-Crash: nach Recovery aus Log nachvollziehen. Koordinator-Crash: Agenten blockieren — Hauptproblem von 2PC.</li>
          </ol>
        </details>
      `;
      const $ = s => root.querySelector(s);
      $('#tpcPrep').addEventListener('click', sendPrepare);
      $('#tpcReset').addEventListener('click', reset);
      root.querySelectorAll('.db-vote').forEach(b => b.addEventListener('click', () => vote(b.dataset.id, b.dataset.v)));
    }
    render();
  }

  // ============================================================
  //  NETZE UND VERTEILTE SYSTEME
  // ============================================================

  function netBadge(html, cls = '') { return `<span class="db-badge ${cls}">${html}</span>`; }

  // ---------- 1) CRC-Detective ----------
  function renderNetCRC(root) {
    function bin(n, len) { return n.toString(2).padStart(len, '0'); }
    function crcDivide(msg, gen) {
      const m = msg.split('').map(Number);
      const g = gen.split('').map(Number);
      const work = m.slice();
      const steps = [];
      for (let i = 0; i <= work.length - g.length; i++) {
        if (work[i] === 1) {
          const before = work.join('');
          for (let j = 0; j < g.length; j++) work[i + j] ^= g[j];
          steps.push({ pos: i, before, gen: gen, after: work.join('') });
        }
      }
      const rem = work.slice(work.length - (g.length - 1)).join('');
      return { rem, steps };
    }

    const PRESETS = [
      { msg: '1001100', gen: '10110', label: 'M=1001100, G(x)=x⁴+x²+x' },
      { msg: '1101011', gen: '1011',  label: 'M=1101011, G(x)=x³+x+1' },
      { msg: '11010110', gen: '10011', label: 'M=11010110, G(x)=x⁴+x+1' },
      { msg: '101100',  gen: '1101',  label: 'M=101100, G(x)=x³+x²+1' },
    ];

    const state = { i: 0, mode: 'sender', flipIdx: -1, picked: null, score: 0, total: 0 };

    function genTransmitted() {
      const p = PRESETS[state.i];
      const padded = p.msg + '0'.repeat(p.gen.length - 1);
      const { rem } = crcDivide(padded, p.gen);
      return { padded, rem, transmitted: p.msg + rem };
    }

    function newReceiver() {
      const { transmitted } = genTransmitted();
      // 50% chance to flip a random bit
      const corrupt = Math.random() < 0.5;
      if (corrupt) {
        const idx = Math.floor(Math.random() * transmitted.length);
        const arr = transmitted.split('');
        arr[idx] = arr[idx] === '0' ? '1' : '0';
        state.received = arr.join('');
        state.actualOk = false;
      } else {
        state.received = transmitted;
        state.actualOk = true;
      }
      state.picked = null;
    }

    function render() {
      const p = PRESETS[state.i];
      const { padded, rem, transmitted } = genTransmitted();

      let body = '';
      if (state.mode === 'sender') {
        const choices = [rem];
        // generate 3 distractors
        const seen = new Set([rem]);
        while (choices.length < 4) {
          const cand = bin(Math.floor(Math.random() * (1 << (p.gen.length - 1))), p.gen.length - 1);
          if (!seen.has(cand)) { seen.add(cand); choices.push(cand); }
        }
        // shuffle
        for (let k = choices.length - 1; k > 0; k--) { const j = Math.floor(Math.random() * (k + 1)); [choices[k], choices[j]] = [choices[j], choices[k]]; }
        const correct = choices.indexOf(rem);

        body = `
          <div class="db-card">
            <div class="db-kicker">📨 Sender</div>
            <div class="db-mono">Nachricht M = <b>${p.msg}</b></div>
            <div class="db-mono">Generator G = <b>${p.gen}</b> (Grad ${p.gen.length - 1})</div>
            <div class="db-mono">Mit ${p.gen.length - 1} Nullen aufgef\u00fcllt: <b>${padded}</b></div>
            <p class="muted" style="margin-top:.5rem">Welcher Rest entsteht bei der XOR-Division <code>${padded} : ${p.gen}</code>?</p>
            <div class="db-choices row">
              ${choices.map((c, i) => `<button class="db-choice pill" data-c="${i}" ${state.picked !== null ? 'disabled' : ''}>${c}</button>`).join('')}
            </div>
            <div id="netCrcFb" class="db-feedback" style="display:${state.picked !== null ? 'block' : 'none'}"></div>
          </div>
        `;
        setTimeout(() => {
          root.querySelectorAll('.db-choice').forEach((btn, i) => {
            btn.addEventListener('click', () => {
              state.picked = i;
              const ok = i === correct;
              state.total++;
              if (ok) state.score++;
              root.querySelectorAll('.db-choice').forEach((b, k) => {
                if (k === correct) b.classList.add('ok');
                else if (k === i) b.classList.add('bad');
                b.disabled = true;
              });
              const fb = root.querySelector('#netCrcFb');
              fb.classList.add(ok ? 'ok' : 'bad');
              fb.style.display = 'block';
              fb.innerHTML = (ok ? '✅ Richtig! ' : `❌ Falsch — der korrekte Rest ist <b>${rem}</b>. `)
                + `\u00dcbertragen wird daher <b>${transmitted}</b>.`;
            });
          });
        }, 0);
      } else {
        // receiver mode
        if (!state.received) newReceiver();
        body = `
          <div class="db-card">
            <div class="db-kicker">📡 Empf\u00e4nger</div>
            <div class="db-mono">Empfangen: <b style="font-size:1.05rem">${state.received}</b></div>
            <div class="db-mono">Generator: <b>${p.gen}</b></div>
            <p class="muted">Teile durch G und pr\u00fcfe den Rest. Was meldet die CRC-Pr\u00fcfung?</p>
            <div class="db-choices row">
              <button class="db-choice pill" id="netCrcOk"   ${state.picked !== null ? 'disabled' : ''}>✅ Sauber</button>
              <button class="db-choice pill" id="netCrcBad"  ${state.picked !== null ? 'disabled' : ''}>⚠️ Fehler erkannt</button>
            </div>
            <div id="netCrcFb" class="db-feedback" style="display:${state.picked !== null ? 'block' : 'none'}"></div>
          </div>
        `;
        setTimeout(() => {
          const handle = (claimOk) => {
            if (state.picked !== null) return;
            state.picked = claimOk;
            const correct = claimOk === state.actualOk;
            state.total++;
            if (correct) state.score++;
            const { rem: actualRem } = crcDivide(state.received, p.gen);
            const fb = root.querySelector('#netCrcFb');
            fb.classList.add(correct ? 'ok' : 'bad');
            fb.style.display = 'block';
            fb.innerHTML = (correct ? '✅ Richtig! ' : '❌ Daneben. ')
              + `Rest der Empf\u00e4nger-Division: <b>${actualRem}</b> \u2192 ${state.actualOk ? 'unauff\u00e4llig' : 'Fehler erkannt'}.`;
            root.querySelector('#netCrcOk').classList.add(state.actualOk ? 'ok' : 'bad');
            root.querySelector('#netCrcBad').classList.add(state.actualOk ? 'bad' : 'ok');
          };
          root.querySelector('#netCrcOk').addEventListener('click', () => handle(true));
          root.querySelector('#netCrcBad').addEventListener('click', () => handle(false));
        }, 0);
      }

      root.innerHTML = `
        <div class="game-controls">
          <select id="netCrcSel" class="select">
            ${PRESETS.map((x, i) => `<option value="${i}" ${i === state.i ? 'selected' : ''}>${x.label}</option>`).join('')}
          </select>
          <div class="games-filter" style="margin-left:auto">
            <button class="games-filter-chip ${state.mode === 'sender' ? 'active' : ''}" data-m="sender">📨 Sender</button>
            <button class="games-filter-chip ${state.mode === 'receiver' ? 'active' : ''}" data-m="receiver">📡 Empf\u00e4nger</button>
          </div>
          <button class="btn btn-secondary" id="netCrcNext">Neue Runde →</button>
          ${netBadge(`Score: ${state.score} / ${state.total}`, state.score === state.total && state.total > 0 ? 'good' : '')}
        </div>
        ${body}
        <details class="game-help"><summary>📚 CRC kompakt</summary>
          <ul>
            <li>Generator-Polynom <code>G(x)</code> hat Grad <code>g</code>; Nachricht wird mit <code>g</code> Nullen aufgef\u00fcllt.</li>
            <li>XOR-Division: an jeder F\u00fchrungs-1 wird G subtrahiert (XOR). Ergebnis ist der Rest <code>r(x)</code>.</li>
            <li>Gesendet wird <b>M·x^g \u2295 r(x)</b>. Beim Empf\u00e4nger muss die Division Rest 0 ergeben.</li>
          </ul>
        </details>
      `;
      root.querySelector('#netCrcSel').addEventListener('change', e => { state.i = +e.target.value; state.picked = null; state.received = null; render(); });
      root.querySelectorAll('[data-m]').forEach(b => b.addEventListener('click', () => { state.mode = b.dataset.m; state.picked = null; state.received = null; render(); }));
      root.querySelector('#netCrcNext').addEventListener('click', () => { state.picked = null; state.received = null; if (state.mode === 'sender') state.i = (state.i + 1) % PRESETS.length; render(); });
      // re-render body controls
      const placeholder = root.querySelector('#netCrcFb');
      if (placeholder) {} // (handlers wired in setTimeout above)
    }
    render();
  }

  // ---------- 2) Manchester-Studio ----------
  function renderNetManchester(root) {
    const state = { bits: '10110010', mode: 'manchester' };

    function svgSignal(levels, label) {
      // levels: array of {t, v} where v in {0,1}
      const w = 24, h = 60, pad = 18;
      const totalW = pad * 2 + levels.length * w;
      let path = '';
      let prevY = null;
      levels.forEach((p, i) => {
        const x0 = pad + i * w;
        const x1 = x0 + w;
        const y = p.v === 1 ? 12 : h - 12;
        if (prevY !== null && prevY !== y) path += ` L ${x0} ${prevY} L ${x0} ${y}`;
        else if (i === 0) path += `M ${x0} ${y}`;
        path += ` L ${x1} ${y}`;
        prevY = y;
      });
      const ticks = levels.map((_, i) => `<line x1="${pad + i * w}" y1="0" x2="${pad + i * w}" y2="${h}" stroke="rgba(148,163,184,.25)" stroke-dasharray="2 3"/>`).join('');
      return `
        <div class="db-card">
          <div class="db-kicker">${label}</div>
          <svg viewBox="0 0 ${totalW} ${h}" width="100%" height="${h}" style="background:rgba(15,23,42,.04);border-radius:8px">
            ${ticks}
            <line x1="0" y1="${h/2}" x2="${totalW}" y2="${h/2}" stroke="rgba(148,163,184,.4)"/>
            <path d="${path}" fill="none" stroke="#0ea5e9" stroke-width="2.5" stroke-linejoin="miter"/>
          </svg>
        </div>
      `;
    }

    function nrz(bits) { return bits.split('').map(b => ({ v: +b })); }
    function nrzi(bits) {
      let cur = 0; const out = [];
      for (const b of bits) { if (b === '1') cur = 1 - cur; out.push({ v: cur }); }
      return out;
    }
    function manchester(bits) {
      const out = [];
      for (const b of bits) {
        if (b === '0') { out.push({ v: 1 }); out.push({ v: 0 }); } // hi→lo
        else { out.push({ v: 0 }); out.push({ v: 1 }); }            // lo→hi
      }
      return out;
    }
    function bitStuff(bits) {
      let run = 0; let out = '';
      for (const b of bits) {
        out += b;
        if (b === '1') { run++; if (run === 5) { out += '0'; run = 0; } } else run = 0;
      }
      return out;
    }

    function bitLabels(bits) {
      const w = 24, pad = 18;
      const totalW = pad * 2 + bits.length * w;
      const labels = bits.split('').map((b, i) => `<text x="${pad + i * w + w/2}" y="14" text-anchor="middle" font-family="monospace" font-size="14" fill="#0f172a">${b}</text>`).join('');
      return `<svg viewBox="0 0 ${totalW} 22" width="100%" height="22">${labels}</svg>`;
    }

    function render() {
      const bits = state.bits.replace(/[^01]/g, '').slice(0, 16) || '0';
      const stuffed = bitStuff(bits);
      let signal;
      if (state.mode === 'nrz') signal = svgSignal(nrz(bits), 'NRZ-Signal');
      else if (state.mode === 'nrzi') signal = svgSignal(nrzi(bits), 'NRZI-Signal (1 = Pegelwechsel, 0 = halten)');
      else signal = svgSignal(manchester(bits), 'Manchester-Signal (1 = lo→hi, 0 = hi→lo · doppelte Symbolrate)');

      root.innerHTML = `
        <div class="game-controls">
          <label class="muted">Bits:</label>
          <input id="netManIn" class="select" value="${bits}" maxlength="16" style="font-family:monospace;letter-spacing:.15em" />
          <div class="games-filter" style="margin-left:auto">
            ${['nrz','nrzi','manchester'].map(m => `<button class="games-filter-chip ${state.mode === m ? 'active' : ''}" data-m="${m}">${m === 'nrz' ? 'NRZ' : m === 'nrzi' ? 'NRZI' : 'Manchester'}</button>`).join('')}
          </div>
          <button class="btn btn-secondary" id="netManRand">🎲 Zufall</button>
        </div>
        <div class="db-card">
          <div class="db-kicker">Bits</div>
          ${bitLabels(bits)}
        </div>
        ${signal}
        ${bits !== stuffed ? `
          <div class="db-card">
            <div class="db-kicker">HDLC-Bit-Stuffing (nach 5 × 1 wird eine 0 eingef\u00fcgt)</div>
            <div class="db-mono">Original: <b>${bits}</b><br>Gestopft: <b>${stuffed}</b></div>
          </div>` : `
          <div class="db-card">
            <div class="db-kicker">HDLC-Bit-Stuffing</div>
            <div class="db-mono">Keine f\u00fcnf aufeinanderfolgenden 1en — nichts zu stopfen.</div>
          </div>`}
        <details class="game-help"><summary>📚 Codierungen kompakt</summary>
          <ul>
            <li><b>NRZ</b>: 1 = High, 0 = Low. Einfach, aber lange Folgen \u2192 Synchronisationsproblem.</li>
            <li><b>NRZI</b>: bei 1 wird umgeschaltet, bei 0 nicht (oder umgekehrt). Polarit\u00e4tsneutral.</li>
            <li><b>Manchester</b>: jede Bitzelle hat eine Flanke in der Mitte (0 = Fall, 1 = Anstieg). Selbsttaktend, aber doppelte Bandbreite.</li>
            <li><b>Bit-Stuffing (HDLC)</b>: Senderseite f\u00fcgt nach f\u00fcnf 1en eine 0 ein, damit das Flag <code>01111110</code> nie versehentlich entsteht.</li>
          </ul>
        </details>
      `;
      root.querySelector('#netManIn').addEventListener('input', e => { state.bits = e.target.value; render(); });
      root.querySelectorAll('[data-m]').forEach(b => b.addEventListener('click', () => { state.mode = b.dataset.m; render(); }));
      root.querySelector('#netManRand').addEventListener('click', () => {
        const len = 8 + Math.floor(Math.random() * 4);
        let s = ''; for (let i = 0; i < len; i++) s += Math.random() < .5 ? '0' : '1';
        state.bits = s; render();
      });
    }
    render();
  }

  // ---------- 3) Sliding-Window-Lab ----------
  function renderNetWindow(root) {
    const state = {
      protocol: 'gbn', // 'sw' | 'gbn' | 'sr'
      window: 4,
      lossSet: new Set(),
      total: 8,
      stepIdx: 0,
      timeline: null,
    };

    function build() {
      const N = state.total;
      const W = state.protocol === 'sw' ? 1 : state.window;
      const events = [];
      let nextSeq = 0;
      let base = 0;
      const acked = new Array(N).fill(false);
      const sent = new Array(N).fill(0);
      const inflight = []; // {seq, sentAt}
      let t = 0;
      const TIMEOUT = 4;
      const RTT = 2;
      let safety = 0;
      while (base < N && safety++ < 200) {
        // send all in window
        while (inflight.length < W && nextSeq < N) {
          inflight.push({ seq: nextSeq, sentAt: t });
          sent[nextSeq]++;
          events.push({ t, kind: 'send', seq: nextSeq, lost: state.lossSet.has(`${nextSeq}-${sent[nextSeq]}`) });
          nextSeq++;
        }
        t++;
        // process arrivals at t (sentAt + RTT)
        const arrivals = inflight.filter(p => t - p.sentAt >= RTT);
        for (const p of arrivals) {
          const lost = state.lossSet.has(`${p.seq}-${sent[p.seq]}`);
          if (lost) {
            events.push({ t, kind: 'lost', seq: p.seq });
            // wait for timeout — keep in flight until timeout
            if (t - p.sentAt >= TIMEOUT) {
              events.push({ t, kind: 'timeout', seq: p.seq });
              if (state.protocol === 'gbn') {
                // flush in-flight, restart from base
                const toResend = inflight.map(x => x.seq).sort((a,b)=>a-b);
                inflight.length = 0;
                nextSeq = base;
                for (const _s of toResend) { /* drop */ }
              } else if (state.protocol === 'sr') {
                inflight.splice(inflight.indexOf(p), 1);
                sent[p.seq]++;
                events.push({ t, kind: 'send', seq: p.seq, lost: state.lossSet.has(`${p.seq}-${sent[p.seq]}`) });
                inflight.push({ seq: p.seq, sentAt: t });
              } else {
                // sw: resend
                inflight.splice(inflight.indexOf(p), 1);
                sent[p.seq]++;
                events.push({ t, kind: 'send', seq: p.seq, lost: state.lossSet.has(`${p.seq}-${sent[p.seq]}`) });
                inflight.push({ seq: p.seq, sentAt: t });
              }
            }
          } else {
            events.push({ t, kind: 'ack', seq: p.seq });
            acked[p.seq] = true;
            inflight.splice(inflight.indexOf(p), 1);
            // advance base
            while (base < N && acked[base]) base++;
          }
        }
      }
      return { events, T: t };
    }

    function render() {
      const { events, T } = build();
      const lostKey = (seq, attempt) => `${seq}-${attempt}`;
      const totalSends = events.filter(e => e.kind === 'send').length;
      const efficiency = (state.total / totalSends * 100).toFixed(0);

      // build lattice
      const cellW = 44, cellH = 28;
      const cols = Math.max(8, T + 1);
      const rows = state.total;
      let bars = '';
      for (let s = 0; s < rows; s++) {
        for (let t = 0; t < cols; t++) {
          const ev = events.filter(e => e.seq === s && e.t === t);
          let cls = '', sym = '';
          if (ev.find(e => e.kind === 'send' && e.lost)) { cls = 'sw-send sw-lost'; sym = '✉️💥'; }
          else if (ev.find(e => e.kind === 'send')) { cls = 'sw-send'; sym = '✉️'; }
          else if (ev.find(e => e.kind === 'ack')) { cls = 'sw-ack'; sym = '✓'; }
          else if (ev.find(e => e.kind === 'timeout')) { cls = 'sw-timeout'; sym = '⏰'; }
          if (cls) bars += `<div class="sw-cell ${cls}" style="left:${t*cellW}px;top:${s*cellH}px;width:${cellW-4}px;height:${cellH-4}px" title="t=${t} seq=${s}">${sym}</div>`;
        }
      }

      // loss toggles
      const lossButtons = [];
      for (let s = 0; s < state.total; s++) {
        const k = lostKey(s, 1);
        lossButtons.push(`<button class="db-choice pill ${state.lossSet.has(k) ? 'bad' : ''}" data-loss="${k}">Frame ${s} verlieren</button>`);
      }

      root.innerHTML = `
        <div class="game-controls">
          <div class="games-filter">
            ${['sw','gbn','sr'].map(p => `<button class="games-filter-chip ${state.protocol === p ? 'active' : ''}" data-p="${p}">${p === 'sw' ? 'Stop&Wait' : p === 'gbn' ? 'Go-Back-N' : 'Selective Repeat'}</button>`).join('')}
          </div>
          <label class="muted">Window:</label>
          <input id="netWinW" type="number" min="1" max="6" value="${state.window}" class="select" style="width:4rem" ${state.protocol === 'sw' ? 'disabled' : ''}/>
          <label class="muted">Frames:</label>
          <input id="netWinN" type="number" min="3" max="10" value="${state.total}" class="select" style="width:4rem"/>
          <button class="btn btn-secondary" id="netWinReset">⟲ Reset</button>
          ${netBadge(`${totalSends} Sendungen f\u00fcr ${state.total} Frames \u2192 ${efficiency}% Effizienz`, efficiency >= 80 ? 'good' : '')}
        </div>
        <div class="db-card">
          <div class="db-kicker">Verluste umschalten (klicken)</div>
          <div class="db-choices row">${lossButtons.join('')}</div>
        </div>
        <div class="db-card">
          <div class="db-kicker">Zeitachse (Sender vertikal · Zeit horizontal · RTT=2, Timeout=4)</div>
          <div class="sw-grid" style="position:relative;width:${cols*cellW}px;height:${rows*cellH + 24}px">
            ${Array.from({length: rows}).map((_,s)=>`<div class="sw-row-label" style="left:-2.5rem;top:${s*cellH+2}px">S${s}</div>`).join('')}
            ${Array.from({length: cols}).map((_,t)=>`<div class="sw-col-label" style="left:${t*cellW+8}px;top:${rows*cellH+2}px">${t}</div>`).join('')}
            ${bars}
          </div>
        </div>
        <details class="game-help"><summary>📚 Sliding-Window kompakt</summary>
          <ul>
            <li><b>Stop-and-Wait</b>: Window=1. Nach jedem Frame muss ACK kommen. Sicher, aber langsam.</li>
            <li><b>Go-Back-N</b>: Bei Timeout werden <i>alle</i> ungeacknowledgten Frames neu gesendet \u2192 hoher Overhead bei Verlust.</li>
            <li><b>Selective Repeat</b>: Empf\u00e4nger puffert; nur das verlorene Frame wird neu gesendet.</li>
            <li>Effizienz = Nutz-Frames / gesendete Frames. Toggle Verluste, vergleiche Protokolle!</li>
          </ul>
        </details>
      `;
      root.querySelectorAll('[data-p]').forEach(b => b.addEventListener('click', () => { state.protocol = b.dataset.p; render(); }));
      root.querySelector('#netWinW').addEventListener('change', e => { state.window = Math.max(1, Math.min(6, +e.target.value || 1)); render(); });
      root.querySelector('#netWinN').addEventListener('change', e => { state.total = Math.max(3, Math.min(10, +e.target.value || 3)); state.lossSet.clear(); render(); });
      root.querySelector('#netWinReset').addEventListener('click', () => { state.lossSet.clear(); render(); });
      root.querySelectorAll('[data-loss]').forEach(b => b.addEventListener('click', () => {
        const k = b.dataset.loss; if (state.lossSet.has(k)) state.lossSet.delete(k); else state.lossSet.add(k); render();
      }));
    }
    render();
  }

  // ---------- 4) Subnetz-Sprint ----------
  function renderNetSubnet(root) {
    function ip2int(ip) { return ip.split('.').reduce((a, o) => (a << 8) + (+o), 0) >>> 0; }
    function int2ip(n) { return [(n>>>24)&255, (n>>>16)&255, (n>>>8)&255, n&255].join('.'); }
    function genTask() {
      const cidr = 16 + Math.floor(Math.random() * 14); // /16 .. /29
      const mask = cidr === 0 ? 0 : (0xFFFFFFFF << (32 - cidr)) >>> 0;
      const base = Math.floor(Math.random() * 0xFFFFFFFF) >>> 0;
      const net = (base & mask) >>> 0;
      const offset = Math.floor(Math.random() * Math.max(1, (~mask >>> 0) - 2)) + 1;
      const ip = (net + offset) >>> 0;
      const broadcast = (net | (~mask >>> 0)) >>> 0;
      const hosts = cidr >= 31 ? 0 : (~mask >>> 0) - 1;
      const which = Math.floor(Math.random() * 3); // 0=net, 1=broadcast, 2=hosts
      return { cidr, ip: int2ip(ip), netStr: int2ip(net), bcStr: int2ip(broadcast), hosts, which };
    }

    const state = { task: null, score: 0, total: 0, time: 30, running: false, picked: null, timer: null, best: +(localStorage.getItem('netSubnetBest') || 0) };

    function startTimer() {
      clearInterval(state.timer);
      state.time = 30;
      state.running = true;
      state.timer = setInterval(() => {
        state.time--;
        if (state.time <= 0) {
          clearInterval(state.timer);
          state.running = false;
          state.picked = '__end__';
          if (state.score > state.best) { state.best = state.score; localStorage.setItem('netSubnetBest', state.score); }
        }
        render();
      }, 1000);
    }

    function start() {
      state.score = 0; state.total = 0;
      state.task = genTask(); state.picked = null;
      startTimer();
      render();
    }

    function nextTask() { state.task = genTask(); state.picked = null; render(); }

    function render() {
      if (!state.task) state.task = genTask();
      const t = state.task;
      const labels = ['Netz-Adresse', 'Broadcast-Adresse', 'Anzahl nutzbare Hosts'];
      const correct = t.which === 0 ? t.netStr : t.which === 1 ? t.bcStr : String(t.hosts);

      // generate 4 choices around correct
      const choices = [correct];
      const seen = new Set([correct]);
      while (choices.length < 4) {
        let cand;
        if (t.which === 2) {
          const delta = (Math.floor(Math.random() * 6) - 3);
          cand = String(Math.max(0, t.hosts + (delta === 0 ? 1 : delta) * (1 << Math.floor(Math.random()*3))));
        } else {
          const ipi = ip2int(correct);
          const delta = (Math.floor(Math.random() * 8) + 1);
          cand = int2ip(((ipi + (Math.random() < .5 ? delta : -delta)) >>> 0));
        }
        if (!seen.has(cand)) { seen.add(cand); choices.push(cand); }
      }
      for (let k = choices.length - 1; k > 0; k--) { const j = Math.floor(Math.random() * (k + 1)); [choices[k], choices[j]] = [choices[j], choices[k]]; }
      const correctIdx = choices.indexOf(correct);

      const ended = state.picked === '__end__';

      root.innerHTML = `
        <div class="game-controls">
          <button class="btn btn-primary" id="netSubStart">${state.running ? '⟲ Neustart' : '▶︎ Start (30s)'}</button>
          ${netBadge(`⏱ ${state.time}s`, state.time > 10 ? 'good' : '')}
          ${netBadge(`Score: ${state.score} / ${state.total}`, state.score > 0 ? 'good' : '')}
          ${netBadge(`🏆 Best: ${state.best}`, '')}
        </div>
        ${ended ? `
          <div class="db-card">
            <div class="db-kicker">⏰ Zeit abgelaufen!</div>
            <div class="db-mono">Endstand: <b>${state.score}</b> richtige Antworten in 30 Sekunden.</div>
          </div>
        ` : `
          <div class="db-card">
            <div class="db-kicker">IP / CIDR</div>
            <div class="db-mono" style="font-size:1.15rem">${t.ip} / ${t.cidr}</div>
            <p class="muted" style="margin-top:.25rem">Bestimme die <b>${labels[t.which]}</b>.</p>
            <div class="db-choices row">
              ${choices.map((c, i) => `<button class="db-choice pill" data-c="${i}" ${state.picked !== null && state.picked !== '__end__' ? 'disabled' : ''}>${c}</button>`).join('')}
            </div>
          </div>
        `}
        <details class="game-help"><summary>📚 Subnetting kompakt</summary>
          <ul>
            <li><b>Netzmaske</b>: erste <code>/n</code> Bits sind 1, Rest 0. Beispiel <code>/26</code> = <code>255.255.255.192</code>.</li>
            <li><b>Netzadresse</b>: IP <i>AND</i> Maske. <b>Broadcast</b>: IP <i>OR</i> NOT(Maske).</li>
            <li><b>Hosts</b>: <code>2^(32\u2212n) \u2212 2</code> (Netz- und Broadcast-Adresse abziehen). Bei <code>/31</code>/<code>/32</code> Sonderregeln.</li>
          </ul>
        </details>
      `;
      const startBtn = root.querySelector('#netSubStart');
      startBtn.addEventListener('click', start);
      if (!ended) root.querySelectorAll('.db-choice').forEach((btn, i) => {
        btn.addEventListener('click', () => {
          if (!state.running || state.picked !== null) return;
          state.picked = i;
          state.total++;
          if (i === correctIdx) state.score++;
          root.querySelectorAll('.db-choice').forEach((b, k) => {
            if (k === correctIdx) b.classList.add('ok'); else if (k === i) b.classList.add('bad');
            b.disabled = true;
          });
          setTimeout(nextTask, 600);
        });
      });
    }
    render();
  }

  // ---------- 5) DVR-Trainer ----------
  function renderNetDVR(root) {
    // Topology: nodes A B C D E with weighted edges
    const NODES = ['A','B','C','D','E'];
    const EDGES = { 'A-B':2, 'A-D':1, 'B-C':3, 'B-E':2, 'C-D':5, 'C-E':1, 'D-E':4 };
    const INF = Infinity;

    function neighbors(n) {
      const out = {};
      for (const k of Object.keys(EDGES)) {
        const [a,b] = k.split('-');
        if (a === n) out[b] = EDGES[k];
        if (b === n) out[a] = EDGES[k];
      }
      return out;
    }

    function initTables() {
      const T = {};
      for (const n of NODES) {
        T[n] = {};
        for (const m of NODES) T[n][m] = (n === m) ? { cost: 0, via: '-' } : { cost: INF, via: '?' };
        for (const [nb, c] of Object.entries(neighbors(n))) T[n][nb] = { cost: c, via: nb };
      }
      return T;
    }

    function step(T) {
      const N = JSON.parse(JSON.stringify(T));
      let changed = false;
      for (const n of NODES) {
        for (const dest of NODES) {
          if (dest === n) continue;
          let bestCost = INF, bestVia = '?';
          for (const [nb, c] of Object.entries(neighbors(n))) {
            const via = T[nb][dest].cost;
            if (via === INF) continue;
            if (c + via < bestCost) { bestCost = c + via; bestVia = nb; }
          }
          if (bestCost !== N[n][dest].cost || bestVia !== N[n][dest].via) {
            if (bestCost < N[n][dest].cost || N[n][dest].cost === INF) {
              N[n][dest] = { cost: bestCost === INF ? INF : bestCost, via: bestVia };
              changed = true;
            }
          }
        }
      }
      return { N, changed };
    }

    const state = { round: 0, T: initTables(), history: [] };

    function doStep() {
      const { N, changed } = step(state.T);
      state.history.push({ round: state.round + 1, changed });
      state.T = N;
      state.round++;
      render();
    }
    function reset() { state.round = 0; state.T = initTables(); state.history = []; render(); }

    function render() {
      const tableHtml = `
        <table class="db-table">
          <thead><tr><th>von \\ zu</th>${NODES.map(n => `<th>${n}</th>`).join('')}</tr></thead>
          <tbody>
            ${NODES.map(n => `<tr><th>${n}</th>${NODES.map(m => {
              const e = state.T[n][m];
              const txt = e.cost === INF ? '∞' : `${e.cost} via ${e.via}`;
              return `<td>${txt}</td>`;
            }).join('')}</tr>`).join('')}
          </tbody>
        </table>
      `;
      const lastChanged = state.history.length ? state.history[state.history.length - 1].changed : null;
      const converged = state.round > 0 && lastChanged === false;

      // SVG topology
      const positions = {
        A: [80, 50], B: [240, 50], C: [320, 170], D: [80, 170], E: [200, 230]
      };
      const lines = Object.entries(EDGES).map(([k, w]) => {
        const [a,b] = k.split('-');
        const [x1,y1] = positions[a], [x2,y2] = positions[b];
        const mx = (x1+x2)/2, my = (y1+y2)/2;
        return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="#94a3b8" stroke-width="2"/><text x="${mx}" y="${my}" font-size="13" fill="#0ea5e9" font-weight="bold" text-anchor="middle" dy="-3">${w}</text>`;
      }).join('');
      const dots = NODES.map(n => {
        const [x,y] = positions[n];
        return `<circle cx="${x}" cy="${y}" r="22" fill="#0ea5e9"/><text x="${x}" y="${y}" text-anchor="middle" dy="5" fill="white" font-weight="bold" font-size="16">${n}</text>`;
      }).join('');

      root.innerHTML = `
        <div class="game-controls">
          <button class="btn btn-primary" id="netDvrStep">▶︎ N\u00e4chste Runde (${state.round + 1})</button>
          <button class="btn btn-secondary" id="netDvrReset">⟲ Reset</button>
          ${netBadge(`Runde: ${state.round}`, '')}
          ${converged ? netBadge('✅ Konvergiert', 'good') : ''}
        </div>
        <div class="db-card">
          <div class="db-kicker">Topologie</div>
          <svg viewBox="0 0 400 270" width="100%" height="240" style="background:rgba(15,23,42,.04);border-radius:8px">
            ${lines}${dots}
          </svg>
        </div>
        <div class="db-card">
          <div class="db-kicker">Routing-Tabellen (Kosten · n\u00e4chster Hop)</div>
          ${tableHtml}
        </div>
        ${state.history.length ? `<div class="db-card">
          <div class="db-kicker">Verlauf</div>
          <ol class="db-list">${state.history.map(h => `<li>Runde ${h.round}: ${h.changed ? '\u2192 \u00c4nderungen' : '✅ keine \u00c4nderungen \u2014 konvergiert'}</li>`).join('')}</ol>
        </div>` : ''}
        <details class="game-help"><summary>📚 Distance-Vector kompakt</summary>
          <ul>
            <li>Jeder Knoten kennt initial nur Kosten zu direkten Nachbarn (alles andere = ∞).</li>
            <li>Pro Runde: <b>D(n,d) = min<sub>nb</sub>( c(n,nb) + D(nb,d) )</b>.</li>
            <li>Konvergenz, sobald keine Tabelle sich \u00e4ndert. <b>Count-to-Infinity</b>: bei Linkausfall k\u00f6nnen alte Routen lange weitergegeben werden — <i>Split Horizon</i> und <i>Poisoned Reverse</i> mildern das.</li>
          </ul>
        </details>
      `;
      root.querySelector('#netDvrStep').addEventListener('click', doStep);
      root.querySelector('#netDvrReset').addEventListener('click', reset);
    }
    render();
  }

  // ---------- 6) TCP-Cwnd-Surfer ----------
  function renderNetCwnd(root) {
    const state = { cwnd: 1, ssthresh: 16, mode: 'ss', history: [{ rtt: 0, cwnd: 1, mode: 'ss' }], lostAt: [], rtt: 0 };

    function tick() {
      state.rtt++;
      if (state.mode === 'ss') {
        state.cwnd = Math.min(state.cwnd * 2, state.ssthresh);
        if (state.cwnd >= state.ssthresh) state.mode = 'ca';
      } else {
        state.cwnd += 1;
      }
      state.history.push({ rtt: state.rtt, cwnd: state.cwnd, mode: state.mode });
      render();
    }
    function loss() {
      state.lostAt.push(state.rtt);
      state.ssthresh = Math.max(2, Math.floor(state.cwnd / 2));
      state.cwnd = 1;
      state.mode = 'ss';
      state.history.push({ rtt: state.rtt, cwnd: state.cwnd, mode: 'loss' });
      render();
    }
    function reset() { state.cwnd = 1; state.ssthresh = 16; state.mode = 'ss'; state.history = [{ rtt: 0, cwnd: 1, mode: 'ss' }]; state.lostAt = []; state.rtt = 0; render(); }

    function render() {
      const W = 520, H = 200, pad = 30;
      const maxRtt = Math.max(20, state.rtt + 2);
      const maxCwnd = Math.max(20, ...state.history.map(p => p.cwnd)) + 2;
      const sx = (W - 2*pad) / maxRtt;
      const sy = (H - 2*pad) / maxCwnd;
      const path = state.history.map((p, i) => `${i === 0 ? 'M' : 'L'} ${pad + p.rtt * sx} ${H - pad - p.cwnd * sy}`).join(' ');
      const dots = state.history.map(p => `<circle cx="${pad + p.rtt * sx}" cy="${H - pad - p.cwnd * sy}" r="3.5" fill="${p.mode === 'loss' ? '#ef4444' : p.mode === 'ss' ? '#22c55e' : '#0ea5e9'}"/>`).join('');
      const lossLines = state.lostAt.map(r => `<line x1="${pad + r * sx}" y1="${pad}" x2="${pad + r * sx}" y2="${H-pad}" stroke="#ef4444" stroke-dasharray="3 3" opacity=".4"/>`).join('');
      const threshLine = `<line x1="${pad}" y1="${H - pad - state.ssthresh * sy}" x2="${W - pad}" y2="${H - pad - state.ssthresh * sy}" stroke="#f59e0b" stroke-dasharray="6 4"/>`;

      root.innerHTML = `
        <div class="game-controls">
          <button class="btn btn-primary" id="netCwndTick">▶︎ ACK (1 RTT)</button>
          <button class="btn btn-secondary" id="netCwndLoss" style="background:rgba(239,68,68,.18);border-color:#ef4444">💥 Paketverlust</button>
          <button class="btn btn-secondary" id="netCwndReset">⟲ Reset</button>
          ${netBadge(`cwnd = ${state.cwnd}`, 'good')}
          ${netBadge(`ssthresh = ${state.ssthresh}`, '')}
          ${netBadge(`Phase: ${state.mode === 'ss' ? 'Slow Start' : 'Congestion Avoidance'}`, state.mode === 'ss' ? 'good' : '')}
        </div>
        <div class="db-card">
          <div class="db-kicker">Congestion Window \u00fcber RTT-Runden</div>
          <svg viewBox="0 0 ${W} ${H}" width="100%" height="${H}" style="background:rgba(15,23,42,.04);border-radius:8px">
            <line x1="${pad}" y1="${H-pad}" x2="${W-pad}" y2="${H-pad}" stroke="#94a3b8"/>
            <line x1="${pad}" y1="${pad}" x2="${pad}" y2="${H-pad}" stroke="#94a3b8"/>
            ${threshLine}
            ${lossLines}
            <path d="${path}" fill="none" stroke="#0ea5e9" stroke-width="2.5"/>
            ${dots}
            <text x="${W-pad}" y="${H-pad+18}" text-anchor="end" font-size="11" fill="#64748b">RTT \u2192</text>
            <text x="${pad-4}" y="${pad-8}" text-anchor="end" font-size="11" fill="#64748b">cwnd</text>
            <text x="${W-pad}" y="${H - pad - state.ssthresh * sy - 4}" text-anchor="end" font-size="11" fill="#f59e0b">ssthresh = ${state.ssthresh}</text>
          </svg>
        </div>
        <div class="db-card">
          <div class="db-kicker">Letzte Schritte</div>
          <div class="db-mono" style="white-space:normal">${state.history.slice(-12).map(p => `<span class="db-badge ${p.mode === 'loss' ? 'bad' : p.mode === 'ss' ? 'good' : ''}">RTT ${p.rtt}: ${p.mode === 'loss' ? '💥 LOSS' : p.mode === 'ss' ? `SS cwnd=${p.cwnd}` : `CA cwnd=${p.cwnd}`}</span>`).join(' ')}</div>
        </div>
        <details class="game-help"><summary>📚 TCP Congestion Control</summary>
          <ul>
            <li><b>Slow Start</b>: cwnd verdoppelt sich pro RTT (exponentiell), bis ssthresh erreicht ist.</li>
            <li><b>Congestion Avoidance (AIMD)</b>: cwnd += 1 pro RTT (additiv).</li>
            <li><b>Paketverlust</b>: ssthresh = cwnd/2, cwnd = 1, zur\u00fcck in Slow Start (Tahoe). Bei Fast Retransmit/Recovery (Reno): cwnd = ssthresh.</li>
          </ul>
        </details>
      `;
      root.querySelector('#netCwndTick').addEventListener('click', tick);
      root.querySelector('#netCwndLoss').addEventListener('click', loss);
      root.querySelector('#netCwndReset').addEventListener('click', reset);
    }
    render();
  }

  // ---------- 7) DNS-Quest ----------
  function renderNetDNS(root) {
    const PRESETS = [
      { domain: 'www.fb.htw-berlin.de', chain: ['Resolver','Root','TLD .de','htw-berlin.de NS','fb.htw-berlin.de NS'] },
      { domain: 'mail.example.com',     chain: ['Resolver','Root','TLD .com','example.com NS'] },
      { domain: 'shop.foo.bar.org',     chain: ['Resolver','Root','TLD .org','bar.org NS','foo.bar.org NS'] },
    ];

    const state = { i: 0, picked: [], finished: false };

    function shuffled(arr) { const a = arr.slice(); for (let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];} return a; }

    function start() { state.picked = []; state.finished = false; state.shuffled = shuffled(PRESETS[state.i].chain); render(); }

    function pick(label) {
      if (state.finished) return;
      const chain = PRESETS[state.i].chain;
      const next = chain[state.picked.length];
      if (label === next) {
        state.picked.push({ label, ok: true });
        if (state.picked.length === chain.length) state.finished = true;
      } else {
        state.picked.push({ label, ok: false });
      }
      render();
    }

    function render() {
      if (!state.shuffled) state.shuffled = shuffled(PRESETS[state.i].chain);
      const p = PRESETS[state.i];
      const remaining = state.shuffled.filter(s => !state.picked.find(x => x.label === s));

      root.innerHTML = `
        <div class="game-controls">
          <select id="netDnsSel" class="select">
            ${PRESETS.map((x,i) => `<option value="${i}" ${i===state.i?'selected':''}>${x.domain}</option>`).join('')}
          </select>
          <button class="btn btn-secondary" id="netDnsReset">⟲ Neu starten</button>
        </div>
        <div class="db-card">
          <div class="db-kicker">Aufgabe</div>
          <div class="db-mono">Browser fragt: <b>${p.domain}</b></div>
          <p class="muted" style="margin-top:.4rem">Klicke die Server in der korrekten Reihenfolge der <b>rekursiven Aufl\u00f6sung</b>.</p>
        </div>
        <div class="db-card">
          <div class="db-kicker">Verf\u00fcgbare Stationen</div>
          <div class="db-choices row">
            ${remaining.map(s => `<button class="db-choice pill" data-l="${s}">${s}</button>`).join('')}
            ${remaining.length === 0 ? '<span class="muted">— alle verteilt —</span>' : ''}
          </div>
        </div>
        <div class="db-card">
          <div class="db-kicker">Deine Pfad</div>
          <ol class="db-list">
            ${state.picked.map(x => `<li class="${x.ok ? '' : ''}"><span class="db-badge ${x.ok ? 'good' : 'bad'}">${x.ok ? '✓' : '✗'}</span> ${x.label}</li>`).join('') || '<li class="muted">Noch nichts gew\u00e4hlt.</li>'}
          </ol>
          ${state.finished ? `<div class="db-feedback ok" style="display:block">🎉 Perfekt! Aufl\u00f6sungspfad korrekt rekonstruiert.</div>` : ''}
        </div>
        <details class="game-help"><summary>📚 DNS-Hierarchie</summary>
          <ol>
            <li><b>Lokaler Resolver</b> (Stub im Browser \u2192 rekursiver DNS, oft beim ISP).</li>
            <li><b>Root-Server</b> (a-m.root-servers.net) liefert NS f\u00fcr die TLD.</li>
            <li><b>TLD-Server</b> (z.B. .de) liefert NS f\u00fcr die n\u00e4chste Zone.</li>
            <li><b>Authoritative NS</b> der jeweiligen Zone, ggf. weitere Sub-Zonen.</li>
            <li>Resolver cached jede Antwort (TTL) und liefert das finale A/AAAA-Record an den Client.</li>
          </ol>
        </details>
      `;
      root.querySelector('#netDnsSel').addEventListener('change', e => { state.i = +e.target.value; state.shuffled = null; start(); });
      root.querySelector('#netDnsReset').addEventListener('click', () => { state.shuffled = null; start(); });
      root.querySelectorAll('[data-l]').forEach(b => b.addEventListener('click', () => pick(b.dataset.l)));
    }
    start();
  }

  // -------- export ----------
  return { renderIndex, openGame, getGames, renderGameInto };
})();
